/*!
 * We offer some hooks so you can plug your own logic. These custom events are
 * fired on window object:
 *
 * - VIPLoaded
 * - VIPPointWillApply
 * - VIPPointWillCancel
 * - VIPPointDidCancel
 *
 * Some events includes "discountCode" field in the detail property.
 * event.preventDefault() works to stop the default behavior of VIP Extension on
 * some events as well. e.g.
 *
 * window.addEventListener('VIPPointWillApply', (event) => {
 *   console.log(event.detail.discountCode);
 *   event.preventDefault();
 * });
 *
 * These behavior can change anytime without prior notice. We do not guarantee
 * anything about it.
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 77:
/***/ (function(module, exports) {

var __self__ = (function (root) {
function F() {
this.fetch = false;
this.DOMException = root.DOMException
}
F.prototype = root;
return new F();
})(typeof self !== 'undefined' ? self : this);
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  return exports;

}({}));
})(__self__);
delete __self__.fetch.polyfill
exports = __self__.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = __self__.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = __self__.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = __self__.Headers
exports.Request = __self__.Request
exports.Response = __self__.Response
module.exports = exports


/***/ }),

/***/ 445:
/***/ (function(module) {

"use strict";


module.exports = function ReactNativeFile(_ref) {
  var uri = _ref.uri,
    name = _ref.name,
    type = _ref.type;
  this.uri = uri;
  this.name = name;
  this.type = type;
};


/***/ }),

/***/ 804:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var defaultIsExtractableFile = __webpack_require__(268);

module.exports = function extractFiles(value, path, isExtractableFile) {
  if (path === void 0) {
    path = '';
  }

  if (isExtractableFile === void 0) {
    isExtractableFile = defaultIsExtractableFile;
  }

  var clone;
  var files = new Map();

  function addFile(paths, file) {
    var storedPaths = files.get(file);
    if (storedPaths) storedPaths.push.apply(storedPaths, paths);
    else files.set(file, paths);
  }

  if (isExtractableFile(value)) {
    clone = null;
    addFile([path], value);
  } else {
    var prefix = path ? path + '.' : '';
    if (typeof FileList !== 'undefined' && value instanceof FileList)
      clone = Array.prototype.map.call(value, function (file, i) {
        addFile(['' + prefix + i], file);
        return null;
      });
    else if (Array.isArray(value))
      clone = value.map(function (child, i) {
        var result = extractFiles(child, '' + prefix + i, isExtractableFile);
        result.files.forEach(addFile);
        return result.clone;
      });
    else if (value && value.constructor === Object) {
      clone = {};

      for (var i in value) {
        var result = extractFiles(value[i], '' + prefix + i, isExtractableFile);
        result.files.forEach(addFile);
        clone[i] = result.clone;
      }
    } else clone = value;
  }

  return {
    clone: clone,
    files: files,
  };
};


/***/ }),

/***/ 823:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.ReactNativeFile = __webpack_require__(445);
exports.extractFiles = __webpack_require__(804);
exports.isExtractableFile = __webpack_require__(268);


/***/ }),

/***/ 268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var ReactNativeFile = __webpack_require__(445);

module.exports = function isExtractableFile(value) {
  return (
    (typeof File !== 'undefined' && value instanceof File) ||
    (typeof Blob !== 'undefined' && value instanceof Blob) ||
    value instanceof ReactNativeFile
  );
};


/***/ }),

/***/ 230:
/***/ (function(module) {

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ }),

/***/ 458:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var extract_files_1 = __webpack_require__(823);
var form_data_1 = __importDefault(__webpack_require__(230));
/**
 * Duck type if NodeJS stream
 * https://github.com/sindresorhus/is-stream/blob/3750505b0727f6df54324784fe369365ef78841e/index.js#L3
 */
var isExtractableFileEnhanced = function (value) {
    return extract_files_1.isExtractableFile(value) ||
        (value !== null && typeof value === 'object' && typeof value.pipe === 'function');
};
/**
 * Returns Multipart Form if body contains files
 * (https://github.com/jaydenseric/graphql-multipart-request-spec)
 * Otherwise returns JSON
 */
function createRequestBody(query, variables) {
    var _a = extract_files_1.extractFiles({ query: query, variables: variables }, '', isExtractableFileEnhanced), clone = _a.clone, files = _a.files;
    if (files.size === 0) {
        return JSON.stringify(clone);
    }
    var Form = typeof FormData === 'undefined' ? form_data_1.default : FormData;
    var form = new Form();
    form.append('operations', JSON.stringify(clone));
    var map = {};
    var i = 0;
    files.forEach(function (paths) {
        map[++i] = paths;
    });
    form.append('map', JSON.stringify(map));
    i = 0;
    files.forEach(function (paths, file) {
        form.append("" + ++i, file);
    });
    return form;
}
exports["default"] = createRequestBody;
//# sourceMappingURL=createRequestBody.js.map

/***/ }),

/***/ 687:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.gql = exports.request = exports.rawRequest = exports.GraphQLClient = exports.ClientError = void 0;
var cross_fetch_1 = __importStar(__webpack_require__(77)), CrossFetch = cross_fetch_1;
var printer_1 = __webpack_require__(33);
var createRequestBody_1 = __importDefault(__webpack_require__(458));
var types_1 = __webpack_require__(308);
var types_2 = __webpack_require__(308);
Object.defineProperty(exports, "ClientError", ({ enumerable: true, get: function () { return types_2.ClientError; } }));
/**
 * Convert the given headers configuration into a plain object.
 */
var resolveHeaders = function (headers) {
    var oHeaders = {};
    if (headers) {
        if ((typeof Headers !== 'undefined' && headers instanceof Headers) ||
            headers instanceof CrossFetch.Headers) {
            oHeaders = HeadersInstanceToPlainObject(headers);
        }
        else if (Array.isArray(headers)) {
            headers.forEach(function (_a) {
                var name = _a[0], value = _a[1];
                oHeaders[name] = value;
            });
        }
        else {
            oHeaders = headers;
        }
    }
    return oHeaders;
};
/**
 * todo
 */
var GraphQLClient = /** @class */ (function () {
    function GraphQLClient(url, options) {
        this.url = url;
        this.options = options || {};
    }
    GraphQLClient.prototype.rawRequest = function (query, variables, requestHeaders) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, _b, localFetch, others, body, response, result, headers_1, status_1, errorResult;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.options, headers = _a.headers, _b = _a.fetch, localFetch = _b === void 0 ? cross_fetch_1.default : _b, others = __rest(_a, ["headers", "fetch"]);
                        body = createRequestBody_1.default(query, variables);
                        return [4 /*yield*/, localFetch(this.url, __assign({ method: 'POST', headers: __assign(__assign(__assign({}, (typeof body === 'string' ? { 'Content-Type': 'application/json' } : {})), resolveHeaders(headers)), resolveHeaders(requestHeaders)), body: body }, others))];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, getResult(response)];
                    case 2:
                        result = _c.sent();
                        if (response.ok && !result.errors && result.data) {
                            headers_1 = response.headers, status_1 = response.status;
                            return [2 /*return*/, __assign(__assign({}, result), { headers: headers_1, status: status_1 })];
                        }
                        else {
                            errorResult = typeof result === 'string' ? { error: result } : result;
                            throw new types_1.ClientError(__assign(__assign({}, errorResult), { status: response.status, headers: response.headers }), { query: query, variables: variables });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Send a GraphQL document to the server.
     */
    GraphQLClient.prototype.request = function (document, variables, requestHeaders) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, _b, localFetch, others, resolvedDoc, body, response, result, errorResult;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.options, headers = _a.headers, _b = _a.fetch, localFetch = _b === void 0 ? cross_fetch_1.default : _b, others = __rest(_a, ["headers", "fetch"]);
                        resolvedDoc = resolveRequestDocument(document);
                        body = createRequestBody_1.default(resolvedDoc, variables);
                        return [4 /*yield*/, localFetch(this.url, __assign({ method: 'POST', headers: __assign(__assign(__assign({}, (typeof body === 'string' ? { 'Content-Type': 'application/json' } : {})), resolveHeaders(headers)), resolveHeaders(requestHeaders)), body: body }, others))];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, getResult(response)];
                    case 2:
                        result = _c.sent();
                        if (response.ok && !result.errors && result.data) {
                            return [2 /*return*/, result.data];
                        }
                        else {
                            errorResult = typeof result === 'string' ? { error: result } : result;
                            throw new types_1.ClientError(__assign(__assign({}, errorResult), { status: response.status }), { query: resolvedDoc, variables: variables });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GraphQLClient.prototype.setHeaders = function (headers) {
        this.options.headers = headers;
        return this;
    };
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
    GraphQLClient.prototype.setHeader = function (key, value) {
        var _a;
        var headers = this.options.headers;
        if (headers) {
            // todo what if headers is in nested array form... ?
            //@ts-ignore
            headers[key] = value;
        }
        else {
            this.options.headers = (_a = {}, _a[key] = value, _a);
        }
        return this;
    };
    return GraphQLClient;
}());
exports.GraphQLClient = GraphQLClient;
/**
 * todo
 */
function rawRequest(url, query, variables) {
    return __awaiter(this, void 0, void 0, function () {
        var client;
        return __generator(this, function (_a) {
            client = new GraphQLClient(url);
            return [2 /*return*/, client.rawRequest(query, variables)];
        });
    });
}
exports.rawRequest = rawRequest;
/**
 * Send a GraphQL Document to the GraphQL server for exectuion.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await request('https://foo.bar/graphql', `
 *   {
 *     query {
 *       users
 *     }
 *   }
 * `)
 *
 * // You can also pass a GraphQL DocumentNode. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * // If you don't actually care about using DocumentNode but just
 * // want the tooling support for gql template tag like IDE syntax
 * // coloring and prettier autoformat then note you can use the
 * // passthrough gql tag shipped with graphql-request to save a bit
 * // of performance and not have to install another dep into your project.
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 */
function request(url, document, variables) {
    return __awaiter(this, void 0, void 0, function () {
        var client;
        return __generator(this, function (_a) {
            client = new GraphQLClient(url);
            return [2 /*return*/, client.request(document, variables)];
        });
    });
}
exports.request = request;
exports["default"] = request;
/**
 * todo
 */
function getResult(response) {
    var contentType = response.headers.get('Content-Type');
    if (contentType && contentType.startsWith('application/json')) {
        return response.json();
    }
    else {
        return response.text();
    }
}
/**
 * helpers
 */
function resolveRequestDocument(document) {
    if (typeof document === 'string')
        return document;
    return printer_1.print(document);
}
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */
function gql(chunks) {
    var variables = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        variables[_i - 1] = arguments[_i];
    }
    return chunks.reduce(function (accumulator, chunk, index) { return "" + accumulator + chunk + (index in variables ? variables[index] : ''); }, '');
}
exports.gql = gql;
/**
 * Convert Headers instance into regular object
 */
function HeadersInstanceToPlainObject(headers) {
    var o = {};
    headers.forEach(function (v, k) {
        o[k] = v;
    });
    return o;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 308:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClientError = void 0;
var ClientError = /** @class */ (function (_super) {
    __extends(ClientError, _super);
    function ClientError(response, request) {
        var _this = this;
        var message = ClientError.extractMessage(response) + ": " + JSON.stringify({
            response: response,
            request: request,
        });
        _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ClientError.prototype);
        _this.response = response;
        _this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, ClientError);
        }
        return _this;
    }
    ClientError.extractMessage = function (response) {
        try {
            return response.errors[0].message;
        }
        catch (e) {
            return "GraphQL Error (Code: " + response.status + ")";
        }
    };
    return ClientError;
}(Error));
exports.ClientError = ClientError;
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parser = __webpack_require__(370);

var parse = parser.parse;

// Strip insignificant whitespace
// Note that this could do a lot more, such as reorder fields etc.
function normalize(string) {
  return string.replace(/[\s,]+/g, ' ').trim();
}

// A map docString -> graphql document
var docCache = {};

// A map fragmentName -> [normalized source]
var fragmentSourceMap = {};

function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}

// For testing.
function resetCaches() {
  docCache = {};
  fragmentSourceMap = {};
}

// Take a unstripped parsed document (query/mutation or even fragment), and
// check all fragment definitions, checking for name->source uniqueness.
// We also want to make sure only unique fragments exist in the document.
var printFragmentWarnings = true;
function processFragments(ast) {
  var astFragmentMap = {};
  var definitions = [];

  for (var i = 0; i < ast.definitions.length; i++) {
    var fragmentDefinition = ast.definitions[i];

    if (fragmentDefinition.kind === 'FragmentDefinition') {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);

      // We know something about this fragment
      if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {

        // this is a problem because the app developer is trying to register another fragment with
        // the same name as one previously registered. So, we tell them about it.
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
            + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
            + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }

        fragmentSourceMap[fragmentName][sourceKey] = true;

      } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
        fragmentSourceMap[fragmentName] = {};
        fragmentSourceMap[fragmentName][sourceKey] = true;
      }

      if (!astFragmentMap[sourceKey]) {
        astFragmentMap[sourceKey] = true;
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  }

  ast.definitions = definitions;
  return ast;
}

function disableFragmentWarnings() {
  printFragmentWarnings = false;
}

function stripLoc(doc, removeLocAtThisLevel) {
  var docType = Object.prototype.toString.call(doc);

  if (docType === '[object Array]') {
    return doc.map(function (d) {
      return stripLoc(d, removeLocAtThisLevel);
    });
  }

  if (docType !== '[object Object]') {
    throw new Error('Unexpected input.');
  }

  // We don't want to remove the root loc field so we can use it
  // for fragment substitution (see below)
  if (removeLocAtThisLevel && doc.loc) {
    delete doc.loc;
  }

  // https://github.com/apollographql/graphql-tag/issues/40
  if (doc.loc) {
    delete doc.loc.startToken;
    delete doc.loc.endToken;
  }

  var keys = Object.keys(doc);
  var key;
  var value;
  var valueType;

  for (key in keys) {
    if (keys.hasOwnProperty(key)) {
      value = doc[keys[key]];
      valueType = Object.prototype.toString.call(value);

      if (valueType === '[object Object]' || valueType === '[object Array]') {
        doc[keys[key]] = stripLoc(value, true);
      }
    }
  }

  return doc;
}

var experimentalFragmentVariables = false;
function parseDocument(doc) {
  var cacheKey = normalize(doc);

  if (docCache[cacheKey]) {
    return docCache[cacheKey];
  }

  var parsed = parse(doc, { experimentalFragmentVariables: experimentalFragmentVariables });
  if (!parsed || parsed.kind !== 'Document') {
    throw new Error('Not a valid GraphQL document.');
  }

  // check that all "new" fragments inside the documents are consistent with
  // existing fragments of the same name
  parsed = processFragments(parsed);
  parsed = stripLoc(parsed, false);
  docCache[cacheKey] = parsed;

  return parsed;
}

function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}

function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}

// XXX This should eventually disallow arbitrary string interpolation, like Relay does
function gql(/* arguments */) {
  var args = Array.prototype.slice.call(arguments);

  var literals = args[0];

  // We always get literals[0] and then matching post literals for each arg given
  var result = (typeof(literals) === "string") ? literals : literals[0];

  for (var i = 1; i < args.length; i++) {
    if (args[i] && args[i].kind && args[i].kind === 'Document') {
      result += args[i].loc.source.body;
    } else {
      result += args[i];
    }

    result += literals[i];
  }

  return parseDocument(result);
}

// Support typescript, which isn't as nice as Babel about default exports
gql.default = gql;
gql.resetCaches = resetCaches;
gql.disableFragmentWarnings = disableFragmentWarnings;
gql.enableExperimentalFragmentVariables = enableExperimentalFragmentVariables;
gql.disableExperimentalFragmentVariables = disableExperimentalFragmentVariables;

module.exports = gql;


/***/ }),

/***/ 822:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.printError = printError;
exports.GraphQLError = void 0;

var _isObjectLike = _interopRequireDefault(__webpack_require__(690));

var _symbols = __webpack_require__(98);

var _location = __webpack_require__(16);

var _printLocation = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */
var GraphQLError = /*#__PURE__*/function (_Error) {
  _inherits(GraphQLError, _Error);

  var _super = _createSuper(GraphQLError);

  /**
   * A message describing the Error for debugging purposes.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   *
   * Note: should be treated as readonly, despite invariant usage.
   */

  /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */
  function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    var _locations2, _source2, _positions2, _extensions2;

    var _this;

    _classCallCheck(this, GraphQLError);

    _this = _super.call(this, message); // Compute list of blame nodes.

    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.


    var _source = source;

    if (!_source && _nodes) {
      var _nodes$0$loc;

      _source = (_nodes$0$loc = _nodes[0].loc) === null || _nodes$0$loc === void 0 ? void 0 : _nodes$0$loc.source;
    }

    var _positions = positions;

    if (!_positions && _nodes) {
      _positions = _nodes.reduce(function (list, node) {
        if (node.loc) {
          list.push(node.loc.start);
        }

        return list;
      }, []);
    }

    if (_positions && _positions.length === 0) {
      _positions = undefined;
    }

    var _locations;

    if (positions && source) {
      _locations = positions.map(function (pos) {
        return (0, _location.getLocation)(source, pos);
      });
    } else if (_nodes) {
      _locations = _nodes.reduce(function (list, node) {
        if (node.loc) {
          list.push((0, _location.getLocation)(node.loc.source, node.loc.start));
        }

        return list;
      }, []);
    }

    var _extensions = extensions;

    if (_extensions == null && originalError != null) {
      var originalExtensions = originalError.extensions;

      if ((0, _isObjectLike.default)(originalExtensions)) {
        _extensions = originalExtensions;
      }
    }

    Object.defineProperties(_assertThisInitialized(_this), {
      name: {
        value: 'GraphQLError'
      },
      message: {
        value: message,
        // By being enumerable, JSON.stringify will include `message` in the
        // resulting output. This ensures that the simplest possible GraphQL
        // service adheres to the spec.
        enumerable: true,
        writable: true
      },
      locations: {
        // Coercing falsy values to undefined ensures they will not be included
        // in JSON.stringify() when not provided.
        value: (_locations2 = _locations) !== null && _locations2 !== void 0 ? _locations2 : undefined,
        // By being enumerable, JSON.stringify will include `locations` in the
        // resulting output. This ensures that the simplest possible GraphQL
        // service adheres to the spec.
        enumerable: _locations != null
      },
      path: {
        // Coercing falsy values to undefined ensures they will not be included
        // in JSON.stringify() when not provided.
        value: path !== null && path !== void 0 ? path : undefined,
        // By being enumerable, JSON.stringify will include `path` in the
        // resulting output. This ensures that the simplest possible GraphQL
        // service adheres to the spec.
        enumerable: path != null
      },
      nodes: {
        value: _nodes !== null && _nodes !== void 0 ? _nodes : undefined
      },
      source: {
        value: (_source2 = _source) !== null && _source2 !== void 0 ? _source2 : undefined
      },
      positions: {
        value: (_positions2 = _positions) !== null && _positions2 !== void 0 ? _positions2 : undefined
      },
      originalError: {
        value: originalError
      },
      extensions: {
        // Coercing falsy values to undefined ensures they will not be included
        // in JSON.stringify() when not provided.
        value: (_extensions2 = _extensions) !== null && _extensions2 !== void 0 ? _extensions2 : undefined,
        // By being enumerable, JSON.stringify will include `path` in the
        // resulting output. This ensures that the simplest possible GraphQL
        // service adheres to the spec.
        enumerable: _extensions != null
      }
    }); // Include (non-enumerable) stack trace.

    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn(_this);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
    } else {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }

    return _this;
  }

  _createClass(GraphQLError, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    } // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet

  }, {
    key: _symbols.SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Object';
    }
  }]);

  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */


exports.GraphQLError = GraphQLError;

function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++) {
      var node = _error$nodes2[_i2];

      if (node.loc) {
        output += '\n\n' + (0, _printLocation.printLocation)(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++) {
      var location = _error$locations2[_i4];
      output += '\n\n' + (0, _printLocation.printSourceLocation)(error.source, location);
    }
  }

  return output;
}


/***/ }),

/***/ 338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.syntaxError = syntaxError;

var _GraphQLError = __webpack_require__(822);

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
function syntaxError(source, position, description) {
  return new _GraphQLError.GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}


/***/ }),

/***/ 972:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = defineInspect;

var _invariant = _interopRequireDefault(__webpack_require__(706));

var _nodejsCustomInspectSymbol = _interopRequireDefault(__webpack_require__(554));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */
function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || (0, _invariant.default)(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (_nodejsCustomInspectSymbol.default) {
    classObject.prototype[_nodejsCustomInspectSymbol.default] = fn;
  }
}


/***/ }),

/***/ 242:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = devAssert;

function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 2:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = inspect;

var _nodejsCustomInspectSymbol = _interopRequireDefault(__webpack_require__(554));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(_nodejsCustomInspectSymbol.default)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 752:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */
// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
var _default =  true ? // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
// eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
} : // eslint-disable-next-line no-shadow
0;

exports["default"] = _default;


/***/ }),

/***/ 706:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = invariant;

function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}


/***/ }),

/***/ 690:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isObjectLike;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}


/***/ }),

/***/ 554:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var _default = nodejsCustomInspectSymbol;
exports["default"] = _default;


/***/ }),

/***/ 807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isNode = isNode;
exports.Token = exports.Location = void 0;

var _defineInspect = _interopRequireDefault(__webpack_require__(972));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.


exports.Location = Location;
(0, _defineInspect.default)(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.


exports.Token = Token;
(0, _defineInspect.default)(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */


/***/ }),

/***/ 849:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.dedentBlockStringValue = dedentBlockStringValue;
exports.getBlockStringIndentation = getBlockStringIndentation;
exports.printBlockString = printBlockString;

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */


function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/***/ }),

/***/ 333:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DirectiveLocation = void 0;

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

exports.DirectiveLocation = DirectiveLocation;


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Kind = void 0;

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

exports.Kind = Kind;


/***/ }),

/***/ 274:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isPunctuatorTokenKind = isPunctuatorTokenKind;
exports.Lexer = void 0;

var _syntaxError = __webpack_require__(338);

var _ast = __webpack_require__(807);

var _tokenKind = __webpack_require__(175);

var _blockString = __webpack_require__(849);

/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
var Lexer = /*#__PURE__*/function () {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function Lexer(source) {
    var startOfFileToken = new _ast.Token(_tokenKind.TokenKind.SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */


  var _proto = Lexer.prototype;

  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  ;

  _proto.lookahead = function lookahead() {
    var token = this.token;

    if (token.kind !== _tokenKind.TokenKind.EOF) {
      do {
        var _token$next;

        // Note: next is only mutable during parsing, so we cast to allow this.
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === _tokenKind.TokenKind.COMMENT);
    }

    return token;
  };

  return Lexer;
}();
/**
 * @internal
 */


exports.Lexer = Lexer;

function isPunctuatorTokenKind(kind) {
  return kind === _tokenKind.TokenKind.BANG || kind === _tokenKind.TokenKind.DOLLAR || kind === _tokenKind.TokenKind.AMP || kind === _tokenKind.TokenKind.PAREN_L || kind === _tokenKind.TokenKind.PAREN_R || kind === _tokenKind.TokenKind.SPREAD || kind === _tokenKind.TokenKind.COLON || kind === _tokenKind.TokenKind.EQUALS || kind === _tokenKind.TokenKind.AT || kind === _tokenKind.TokenKind.BRACKET_L || kind === _tokenKind.TokenKind.BRACKET_R || kind === _tokenKind.TokenKind.BRACE_L || kind === _tokenKind.TokenKind.PIPE || kind === _tokenKind.TokenKind.BRACE_R;
}

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? _tokenKind.TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;

  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;

    var _col = 1 + pos - lexer.lineStart; // SourceCharacter


    switch (code) {
      case 0xfeff: // <BOM>

      case 9: //   \t

      case 32: //  <space>

      case 44:
        //  ,
        ++pos;
        continue;

      case 10:
        //  \n
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 13:
        //  \r
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }

        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 33:
        //  !
        return new _ast.Token(_tokenKind.TokenKind.BANG, pos, pos + 1, _line, _col, prev);

      case 35:
        //  #
        return readComment(source, pos, _line, _col, prev);

      case 36:
        //  $
        return new _ast.Token(_tokenKind.TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);

      case 38:
        //  &
        return new _ast.Token(_tokenKind.TokenKind.AMP, pos, pos + 1, _line, _col, prev);

      case 40:
        //  (
        return new _ast.Token(_tokenKind.TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);

      case 41:
        //  )
        return new _ast.Token(_tokenKind.TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);

      case 46:
        //  .
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new _ast.Token(_tokenKind.TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
        }

        break;

      case 58:
        //  :
        return new _ast.Token(_tokenKind.TokenKind.COLON, pos, pos + 1, _line, _col, prev);

      case 61:
        //  =
        return new _ast.Token(_tokenKind.TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);

      case 64:
        //  @
        return new _ast.Token(_tokenKind.TokenKind.AT, pos, pos + 1, _line, _col, prev);

      case 91:
        //  [
        return new _ast.Token(_tokenKind.TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);

      case 93:
        //  ]
        return new _ast.Token(_tokenKind.TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);

      case 123:
        // {
        return new _ast.Token(_tokenKind.TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);

      case 124:
        // |
        return new _ast.Token(_tokenKind.TokenKind.PIPE, pos, pos + 1, _line, _col, prev);

      case 125:
        // }
        return new _ast.Token(_tokenKind.TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);

      case 34:
        //  "
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }

        return readString(source, pos, _line, _col, prev);

      case 45: //  -

      case 48: //  0

      case 49: //  1

      case 50: //  2

      case 51: //  3

      case 52: //  4

      case 53: //  5

      case 54: //  6

      case 55: //  7

      case 56: //  8

      case 57:
        //  9
        return readNumber(source, pos, code, _line, _col, prev);

      case 65: //  A

      case 66: //  B

      case 67: //  C

      case 68: //  D

      case 69: //  E

      case 70: //  F

      case 71: //  G

      case 72: //  H

      case 73: //  I

      case 74: //  J

      case 75: //  K

      case 76: //  L

      case 77: //  M

      case 78: //  N

      case 79: //  O

      case 80: //  P

      case 81: //  Q

      case 82: //  R

      case 83: //  S

      case 84: //  T

      case 85: //  U

      case 86: //  V

      case 87: //  W

      case 88: //  X

      case 89: //  Y

      case 90: //  Z

      case 95: //  _

      case 97: //  a

      case 98: //  b

      case 99: //  c

      case 100: // d

      case 101: // e

      case 102: // f

      case 103: // g

      case 104: // h

      case 105: // i

      case 106: // j

      case 107: // k

      case 108: // l

      case 109: // m

      case 110: // n

      case 111: // o

      case 112: // p

      case 113: // q

      case 114: // r

      case 115: // s

      case 116: // t

      case 117: // u

      case 118: // v

      case 119: // w

      case 120: // x

      case 121: // y

      case 122:
        // z
        return readName(source, pos, _line, _col, prev);
    }

    throw (0, _syntaxError.syntaxError)(source, pos, unexpectedCharacterMessage(code));
  }

  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new _ast.Token(_tokenKind.TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new _ast.Token(_tokenKind.TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart


  if (code === 46 || isNameStart(code)) {
    throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new _ast.Token(isFloat ? _tokenKind.TokenKind.FLOAT : _tokenKind.TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new _ast.Token(_tokenKind.TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw (0, _syntaxError.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw (0, _syntaxError.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw (0, _syntaxError.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw (0, _syntaxError.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new _ast.Token(_tokenKind.TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockString.dedentBlockStringValue)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw (0, _syntaxError.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw (0, _syntaxError.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new _ast.Token(_tokenKind.TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z


function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


/***/ }),

/***/ 16:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getLocation = getLocation;

/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}


/***/ }),

/***/ 370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.parse = parse;
exports.parseValue = parseValue;
exports.parseType = parseType;
exports.Parser = void 0;

var _syntaxError = __webpack_require__(338);

var _kinds = __webpack_require__(828);

var _ast = __webpack_require__(807);

var _tokenKind = __webpack_require__(175);

var _source = __webpack_require__(412);

var _directiveLocation = __webpack_require__(333);

var _lexer = __webpack_require__(274);

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */


function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(_tokenKind.TokenKind.SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(_tokenKind.TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */


function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(_tokenKind.TokenKind.SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(_tokenKind.TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */


var Parser = /*#__PURE__*/function () {
  function Parser(source, options) {
    var sourceObj = (0, _source.isSource)(source) ? source : new _source.Source(source);
    this._lexer = new _lexer.Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(_tokenKind.TokenKind.NAME);
    return {
      kind: _kinds.Kind.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.DOCUMENT,
      definitions: this.many(_tokenKind.TokenKind.SOF, this.parseDefinition, _tokenKind.TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(_tokenKind.TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(_tokenKind.TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(_tokenKind.TokenKind.BRACE_L)) {
      return {
        kind: _kinds.Kind.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(_tokenKind.TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: _kinds.Kind.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(_tokenKind.TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, this.parseVariableDefinition, _tokenKind.TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(_tokenKind.TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(_tokenKind.TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(_tokenKind.TokenKind.DOLLAR);
    return {
      kind: _kinds.Kind.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.SELECTION_SET,
      selections: this.many(_tokenKind.TokenKind.BRACE_L, this.parseSelection, _tokenKind.TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(_tokenKind.TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(_tokenKind.TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: _kinds.Kind.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(_tokenKind.TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, item, _tokenKind.TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(_tokenKind.TokenKind.COLON);
    return {
      kind: _kinds.Kind.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(_tokenKind.TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(_tokenKind.TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(_tokenKind.TokenKind.NAME)) {
      return {
        kind: _kinds.Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: _kinds.Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;

    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: _kinds.Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: _kinds.Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case _tokenKind.TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case _tokenKind.TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case _tokenKind.TokenKind.INT:
        this._lexer.advance();

        return {
          kind: _kinds.Kind.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case _tokenKind.TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: _kinds.Kind.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case _tokenKind.TokenKind.STRING:
      case _tokenKind.TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case _tokenKind.TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return {
              kind: _kinds.Kind.BOOLEAN,
              value: true,
              loc: this.loc(token)
            };

          case 'false':
            return {
              kind: _kinds.Kind.BOOLEAN,
              value: false,
              loc: this.loc(token)
            };

          case 'null':
            return {
              kind: _kinds.Kind.NULL,
              loc: this.loc(token)
            };

          default:
            return {
              kind: _kinds.Kind.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }

      case _tokenKind.TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: _kinds.Kind.STRING,
      value: token.value,
      block: token.kind === _tokenKind.TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: _kinds.Kind.LIST,
      values: this.any(_tokenKind.TokenKind.BRACKET_L, item, _tokenKind.TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: _kinds.Kind.OBJECT,
      fields: this.any(_tokenKind.TokenKind.BRACE_L, item, _tokenKind.TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(_tokenKind.TokenKind.COLON);
    return {
      kind: _kinds.Kind.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(_tokenKind.TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(_tokenKind.TokenKind.AT);
    return {
      kind: _kinds.Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(_tokenKind.TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(_tokenKind.TokenKind.BRACKET_R);
      type = {
        kind: _kinds.Kind.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(_tokenKind.TokenKind.BANG)) {
      return {
        kind: _kinds.Kind.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: _kinds.Kind.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === _tokenKind.TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(_tokenKind.TokenKind.STRING) || this.peek(_tokenKind.TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(_tokenKind.TokenKind.BRACE_L, this.parseOperationTypeDefinition, _tokenKind.TokenKind.BRACE_R);
    return {
      kind: _kinds.Kind.SCHEMA_DEFINITION,
      description: description,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(_tokenKind.TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;

    if (!this.expectOptionalKeyword('implements')) {
      return [];
    }

    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = []; // Optional leading ampersand

      this.expectOptionalToken(_tokenKind.TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(_tokenKind.TokenKind.AMP) || this.peek(_tokenKind.TokenKind.NAME));

      return types;
    }

    return this.delimitedMany(_tokenKind.TokenKind.AMP, this.parseNamedType);
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;

    // Legacy support for the SDL?
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(_tokenKind.TokenKind.BRACE_L) && this._lexer.lookahead().kind === _tokenKind.TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseFieldDefinition, _tokenKind.TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(_tokenKind.TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, this.parseInputValueDef, _tokenKind.TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(_tokenKind.TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(_tokenKind.TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: _kinds.Kind.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(_tokenKind.TokenKind.EQUALS) ? this.delimitedMany(_tokenKind.TokenKind.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseEnumValueDefinition, _tokenKind.TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseInputValueDef, _tokenKind.TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === _tokenKind.TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseOperationTypeDefinition, _tokenKind.TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(_tokenKind.TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: _kinds.Kind.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(_tokenKind.TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (_directiveLocation.DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    var _this$_options4;

    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new _ast.Location(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === _tokenKind.TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === _tokenKind.TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  ;

  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  };

  return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */


exports.Parser = Parser;

function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */


function getTokenKindDesc(kind) {
  return (0, _lexer.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}


/***/ }),

/***/ 38:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.printLocation = printLocation;
exports.printSourceLocation = printSourceLocation;

var _location = __webpack_require__(16);

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(location.source, (0, _location.getLocation)(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */


function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function (subLine) {
      return ['', subLine];
    }), [[' ', whitespace(subLineColumnNum - 1) + '^'], ['', subLines[subLineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function leftPad(len, str) {
  return whitespace(len - str.length) + str;
}


/***/ }),

/***/ 33:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.print = print;

var _visitor = __webpack_require__(285);

var _blockString = __webpack_require__(849);

/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
function print(ast) {
  return (0, _visitor.visit)(ast, {
    leave: printDocASTReducer
  });
}

var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = wrap('', alias, ': ') + name;
    var argsLine = prefix + wrap('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? (0, _blockString.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function wrap(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}


/***/ }),

/***/ 412:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isSource = isSource;
exports.Source = void 0;

var _symbols = __webpack_require__(98);

var _inspect = _interopRequireDefault(__webpack_require__(2));

var _devAssert = _interopRequireDefault(__webpack_require__(242));

var _instanceOf = _interopRequireDefault(__webpack_require__(752));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
var Source = /*#__PURE__*/function () {
  function Source(body) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
    var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === 'string' || (0, _devAssert.default)(0, "Body must be a string. Received: ".concat((0, _inspect.default)(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || (0, _devAssert.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
    this.locationOffset.column > 0 || (0, _devAssert.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet


  _createClass(Source, [{
    key: _symbols.SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Source';
    }
  }]);

  return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */


exports.Source = Source;

// eslint-disable-next-line no-redeclare
function isSource(source) {
  return (0, _instanceOf.default)(source, Source);
}


/***/ }),

/***/ 175:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TokenKind = void 0;

/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

exports.TokenKind = TokenKind;


/***/ }),

/***/ 285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.visit = visit;
exports.visitInParallel = visitInParallel;
exports.getVisitFn = getVisitFn;
exports.BREAK = exports.QueryDocumentKeys = void 0;

var _inspect = _interopRequireDefault(__webpack_require__(2));

var _ast = __webpack_require__(807);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
exports.QueryDocumentKeys = QueryDocumentKeys;
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

exports.BREAK = BREAK;

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!(0, _ast.isNode)(node)) {
        throw new Error("Invalid AST Node: ".concat((0, _inspect.default)(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if ((0, _ast.isNode)(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */


function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */


function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}


/***/ }),

/***/ 98:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SYMBOL_TO_STRING_TAG = exports.SYMBOL_ASYNC_ITERATOR = exports.SYMBOL_ITERATOR = void 0;
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

exports.SYMBOL_ITERATOR = SYMBOL_ITERATOR;
var SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

exports.SYMBOL_ASYNC_ITERATOR = SYMBOL_ASYNC_ITERATOR;
var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';
exports.SYMBOL_TO_STRING_TAG = SYMBOL_TO_STRING_TAG;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";

// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// CONCATENATED MODULE: ./src/typings/generated/graphql-request.ts

var ImageType;
(function (ImageType) {
    ImageType["Invalid"] = "INVALID";
    ImageType["Webp"] = "WEBP";
    ImageType["Png"] = "PNG";
    ImageType["Jpeg"] = "JPEG";
})(ImageType || (ImageType = {}));
/**
 * 対象サービス
 * リクエストを投げるサービスによってパーミッションを変更することができる
 */
var PermittedService;
(function (PermittedService) {
    PermittedService["Invalid"] = "INVALID";
    /** Appifyアプリ */
    PermittedService["App"] = "APP";
    /** Appify Admin */
    PermittedService["Admin"] = "ADMIN";
    /** Shopify ユーザー */
    PermittedService["ShopifyUser"] = "SHOPIFY_USER";
})(PermittedService || (PermittedService = {}));
/**
 * タイプ
 * 許可する対象を設定する
 */
var PermittedType;
(function (PermittedType) {
    /** 指定したserviceにPermissionを与えない */
    PermittedType["Invalid"] = "INVALID";
    /**
     * APP:   対象リソースを保持するアプリ利用者
     * ADMIN: 対象リソースを保持する管理画面の利用者
     */
    PermittedType["Owner"] = "OWNER";
    /**
     * APP:   対象リソースと同じアプリを利用しているアプリ利用者全員
     * ADMIN: 対象リソースと同じアプリのApplicationMemberである管理画面利用者全員
     */
    PermittedType["Member"] = "MEMBER";
    /** 公開情報 */
    PermittedType["Public"] = "PUBLIC";
})(PermittedType || (PermittedType = {}));
var Role;
(function (Role) {
    Role["Invalid"] = "INVALID";
    /** Appify開発メンバー */
    Role["Developer"] = "DEVELOPER";
    /** CSツールユーザー */
    Role["CsUser"] = "CS_USER";
    /** Appify Admin画面ユーザー */
    Role["Admin"] = "ADMIN";
    /** Appify アプリユーザー */
    Role["AuthUser"] = "AUTH_USER";
    /** Shopify ユーザー */
    Role["ShopifyUser"] = "SHOPIFY_USER";
    /** 公開ユーザー */
    Role["PublicUser"] = "PUBLIC_USER";
})(Role || (Role = {}));
var AdminOrderByField;
(function (AdminOrderByField) {
    AdminOrderByField["CreatedAt"] = "CREATED_AT";
})(AdminOrderByField || (AdminOrderByField = {}));
var ShopifyAppExtensionOrderByField;
(function (ShopifyAppExtensionOrderByField) {
    ShopifyAppExtensionOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyAppExtensionOrderByField || (ShopifyAppExtensionOrderByField = {}));
var AppExtensionOrderByField;
(function (AppExtensionOrderByField) {
    AppExtensionOrderByField["CreatedAt"] = "CREATED_AT";
})(AppExtensionOrderByField || (AppExtensionOrderByField = {}));
var AppType;
(function (AppType) {
    AppType["ShopifyMobile"] = "SHOPIFY_MOBILE";
    AppType["ShopifyVip"] = "SHOPIFY_VIP";
})(AppType || (AppType = {}));
var ApplicationOrderByField;
(function (ApplicationOrderByField) {
    ApplicationOrderByField["CreatedAt"] = "CREATED_AT";
})(ApplicationOrderByField || (ApplicationOrderByField = {}));
var ApplicationStatus;
(function (ApplicationStatus) {
    /** 申請中 */
    ApplicationStatus["Review"] = "REVIEW";
    /** 公開中 */
    ApplicationStatus["Release"] = "RELEASE";
})(ApplicationStatus || (ApplicationStatus = {}));
var ApplicationMemberOrderByField;
(function (ApplicationMemberOrderByField) {
    ApplicationMemberOrderByField["CreatedAt"] = "CREATED_AT";
})(ApplicationMemberOrderByField || (ApplicationMemberOrderByField = {}));
var ApplicationMemberInvitationOrderByField;
(function (ApplicationMemberInvitationOrderByField) {
    ApplicationMemberInvitationOrderByField["CreatedAt"] = "CREATED_AT";
})(ApplicationMemberInvitationOrderByField || (ApplicationMemberInvitationOrderByField = {}));
var BaseOrderByField;
(function (BaseOrderByField) {
    BaseOrderByField["CreatedAt"] = "CREATED_AT";
})(BaseOrderByField || (BaseOrderByField = {}));
var BaseAnnouncementOrderByField;
(function (BaseAnnouncementOrderByField) {
    BaseAnnouncementOrderByField["PublishTime"] = "PUBLISH_TIME";
})(BaseAnnouncementOrderByField || (BaseAnnouncementOrderByField = {}));
var BaseAnnouncementMasterOrderByField;
(function (BaseAnnouncementMasterOrderByField) {
    BaseAnnouncementMasterOrderByField["PublishTime"] = "PUBLISH_TIME";
})(BaseAnnouncementMasterOrderByField || (BaseAnnouncementMasterOrderByField = {}));
var BaseCartItemOrderByField;
(function (BaseCartItemOrderByField) {
    BaseCartItemOrderByField["CreatedAt"] = "CREATED_AT";
})(BaseCartItemOrderByField || (BaseCartItemOrderByField = {}));
var BaseCategoryOrderByField;
(function (BaseCategoryOrderByField) {
    BaseCategoryOrderByField["CreatedAt"] = "CREATED_AT";
})(BaseCategoryOrderByField || (BaseCategoryOrderByField = {}));
var BaseDesignBlockOrderByField;
(function (BaseDesignBlockOrderByField) {
    BaseDesignBlockOrderByField["CreatedAt"] = "CREATED_AT";
})(BaseDesignBlockOrderByField || (BaseDesignBlockOrderByField = {}));
var BaseDesignBlockType;
(function (BaseDesignBlockType) {
    BaseDesignBlockType["Update"] = "Update";
    BaseDesignBlockType["WebBanner"] = "WebBanner";
    BaseDesignBlockType["ItemBanner"] = "ItemBanner";
    BaseDesignBlockType["CategoryBanner"] = "CategoryBanner";
    BaseDesignBlockType["CategoryItems"] = "CategoryItems";
    BaseDesignBlockType["CategoryItems2"] = "CategoryItems2";
})(BaseDesignBlockType || (BaseDesignBlockType = {}));
var BaseDesignBlockMasterOrderByField;
(function (BaseDesignBlockMasterOrderByField) {
    BaseDesignBlockMasterOrderByField["CreatedAt"] = "CREATED_AT";
})(BaseDesignBlockMasterOrderByField || (BaseDesignBlockMasterOrderByField = {}));
var BaseItemOrderByField;
(function (BaseItemOrderByField) {
    BaseItemOrderByField["CreatedAt"] = "CREATED_AT";
    BaseItemOrderByField["Index"] = "INDEX";
    BaseItemOrderByField["BaseItemListOrder"] = "BASE_ITEM_LIST_ORDER";
})(BaseItemOrderByField || (BaseItemOrderByField = {}));
var BasePurchaseLogOrderByField;
(function (BasePurchaseLogOrderByField) {
    BasePurchaseLogOrderByField["CreatedAt"] = "CREATED_AT";
})(BasePurchaseLogOrderByField || (BasePurchaseLogOrderByField = {}));
var BaseReleasedDesignOrderByField;
(function (BaseReleasedDesignOrderByField) {
    BaseReleasedDesignOrderByField["CreatedAt"] = "CREATED_AT";
})(BaseReleasedDesignOrderByField || (BaseReleasedDesignOrderByField = {}));
var BaseReleasedDesignBlockOrderByField;
(function (BaseReleasedDesignBlockOrderByField) {
    BaseReleasedDesignBlockOrderByField["Order"] = "ORDER";
})(BaseReleasedDesignBlockOrderByField || (BaseReleasedDesignBlockOrderByField = {}));
var BaseSavedDesignBlockOrderByField;
(function (BaseSavedDesignBlockOrderByField) {
    BaseSavedDesignBlockOrderByField["Order"] = "ORDER";
})(BaseSavedDesignBlockOrderByField || (BaseSavedDesignBlockOrderByField = {}));
var CsUserOrderByField;
(function (CsUserOrderByField) {
    CsUserOrderByField["CreatedAt"] = "CREATED_AT";
})(CsUserOrderByField || (CsUserOrderByField = {}));
var ErrorCode;
(function (ErrorCode) {
    /** デフォルト値で返すものではない */
    ErrorCode["Invalid"] = "INVALID";
    /** 原因不明のエラーです */
    ErrorCode["Unknown"] = "UNKNOWN";
    /** ネットワークが利用できません */
    ErrorCode["NetworkUnavailable"] = "NETWORK_UNAVAILABLE";
    /** 正しい役割ではありません */
    ErrorCode["InvalidRole"] = "INVALID_ROLE";
    /** 正しい実行環境ではありません */
    ErrorCode["InvalidEnvironment"] = "INVALID_ENVIRONMENT";
    /** 不正な引数です */
    ErrorCode["InvalidArgument"] = "INVALID_ARGUMENT";
    /** 事前条件違反です */
    ErrorCode["InvalidPrecondition"] = "INVALID_PRECONDITION";
    /** 強制アップデート */
    ErrorCode["ForceUpdateVersion"] = "FORCE_UPDATE_VERSION";
    /** メンテナンスモード */
    ErrorCode["UnderMaintenance"] = "UNDER_MAINTENANCE";
    /** 強制ログアウト */
    ErrorCode["ForceLogout"] = "FORCE_LOGOUT";
    /** ログインに失敗しました */
    ErrorCode["LoginFailed"] = "LOGIN_FAILED";
    /** 権限がありません */
    ErrorCode["NoPermission"] = "NO_PERMISSION";
    /** 認証トークンが間違っています */
    ErrorCode["InvalidAuthToken"] = "INVALID_AUTH_TOKEN";
    /** トークンの期限切れ */
    ErrorCode["ExpiredAuthToken"] = "EXPIRED_AUTH_TOKEN";
    /** 既に存在しています */
    ErrorCode["AlreadyExist"] = "ALREADY_EXIST";
    /** 上限を超えています */
    ErrorCode["OverLimit"] = "OVER_LIMIT";
    /** サービス(機能)が有効化されていません */
    ErrorCode["ServiceDisabled"] = "SERVICE_DISABLED";
    /** 既にCustomerは作成済みです */
    ErrorCode["CustomerAlreadyExist"] = "CUSTOMER_ALREADY_EXIST";
    /** Customerは存在しません */
    ErrorCode["CustomerNotFound"] = "CUSTOMER_NOT_FOUND";
    /** ShopifyCustomerの作成にはEmailとPasswordに加えて、Emailに送信されたURLをクリックする必要があります。これが発生する条件は不明 */
    ErrorCode["CustomerVerificationRequired"] = "CUSTOMER_VERIFICATION_REQUIRED";
    /** 不正なEmailです */
    ErrorCode["InvalidEmail"] = "INVALID_EMAIL";
    /** パスワードの先頭または末尾にホワイトスペースが存在します */
    ErrorCode["PasswordStartsOrEndsWithWhitespace"] = "PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE";
    /** EmailまたはPasswordが不正です */
    ErrorCode["InvalidEmailOrPassword"] = "INVALID_EMAIL_OR_PASSWORD";
    /** お客様の作成可能数が上限に達しました。後でもう一度お試しください。 */
    ErrorCode["OverCreateCustomerLimit"] = "OVER_CREATE_CUSTOMER_LIMIT";
    /** ポイント残高不足です */
    ErrorCode["NotEnoughPoint"] = "NOT_ENOUGH_POINT";
    /** すでに存在するメールアドレスです */
    ErrorCode["EmailExists"] = "EMAIL_EXISTS";
    /** デバイスからのすべてのリクエストをブロック */
    ErrorCode["TooManyAttemptsTryLater"] = "TOO_MANY_ATTEMPTS_TRY_LATER";
    /** クレデンシャルが無効 */
    ErrorCode["CredentialTooOldLoginAgain"] = "CREDENTIAL_TOO_OLD_LOGIN_AGAIN";
    /** パスワード強度が弱いです */
    ErrorCode["WeakPassword"] = "WEAK_PASSWORD";
    /** パスワードは6文字以上 */
    ErrorCode["EmailNotFound"] = "EMAIL_NOT_FOUND";
    /** パスワードが無効 */
    ErrorCode["InvalidPassword"] = "INVALID_PASSWORD";
    /** ユーザーアカウントは管理者によって無効化 */
    ErrorCode["UserDisabled"] = "USER_DISABLED";
    /** ユーザーがいません */
    ErrorCode["UserNotFound"] = "USER_NOT_FOUND";
    /** 無効なリフレッシュトークン */
    ErrorCode["InvalidRefreshToken"] = "INVALID_REFRESH_TOKEN";
    ErrorCode["AdminOnlyOperation"] = "ADMIN_ONLY_OPERATION";
    /** BASEのリフレッシュトークンの有効期限が切れました */
    ErrorCode["ExpiredBaseRefreshToken"] = "EXPIRED_BASE_REFRESH_TOKEN";
    /** Cloud TasksなどでRetryするために返すエラー。クライアントに返ることはない。 */
    ErrorCode["Retry"] = "RETRY";
})(ErrorCode || (ErrorCode = {}));
var AppStoreCategory;
(function (AppStoreCategory) {
    AppStoreCategory["Books"] = "BOOKS";
    AppStoreCategory["Business"] = "BUSINESS";
    AppStoreCategory["Medical"] = "MEDICAL";
    AppStoreCategory["Music"] = "MUSIC";
    AppStoreCategory["DeveloperTool"] = "DEVELOPER_TOOL";
    AppStoreCategory["Navigation"] = "NAVIGATION";
    AppStoreCategory["Education"] = "EDUCATION";
    AppStoreCategory["News"] = "NEWS";
    AppStoreCategory["Entertaiment"] = "ENTERTAIMENT";
    AppStoreCategory["PhotoVideo"] = "PHOTO_VIDEO";
    AppStoreCategory["Finance"] = "FINANCE";
    AppStoreCategory["Productivity"] = "PRODUCTIVITY";
    AppStoreCategory["FoddDrink"] = "FODD_DRINK";
    AppStoreCategory["Reference"] = "REFERENCE";
    AppStoreCategory["Game"] = "GAME";
    AppStoreCategory["Shopping"] = "SHOPPING";
    AppStoreCategory["SocialNetworking"] = "SOCIAL_NETWORKING";
    AppStoreCategory["GraphicsDesign"] = "GRAPHICS_DESIGN";
    AppStoreCategory["Sports"] = "SPORTS";
    AppStoreCategory["HealthFitness"] = "HEALTH_FITNESS";
    AppStoreCategory["Travel"] = "TRAVEL";
    AppStoreCategory["Lifestyle"] = "LIFESTYLE";
    AppStoreCategory["Utilities"] = "UTILITIES";
    AppStoreCategory["MagazinesNewspapers"] = "MAGAZINES_NEWSPAPERS";
    AppStoreCategory["Weather"] = "WEATHER";
})(AppStoreCategory || (AppStoreCategory = {}));
var OrderByDirection;
(function (OrderByDirection) {
    OrderByDirection["Asc"] = "ASC";
    OrderByDirection["Desc"] = "DESC";
})(OrderByDirection || (OrderByDirection = {}));
var PushLogOrderByField;
(function (PushLogOrderByField) {
    PushLogOrderByField["CreatedAt"] = "CREATED_AT";
})(PushLogOrderByField || (PushLogOrderByField = {}));
var PushLogPushStatus;
(function (PushLogPushStatus) {
    PushLogPushStatus["Waiting"] = "WAITING";
    PushLogPushStatus["Sending"] = "SENDING";
    PushLogPushStatus["Completed"] = "COMPLETED";
    PushLogPushStatus["PushTokenNotFound"] = "PUSH_TOKEN_NOT_FOUND";
})(PushLogPushStatus || (PushLogPushStatus = {}));
var PushSegmentType;
(function (PushSegmentType) {
    PushSegmentType["All"] = "ALL";
    PushSegmentType["CustomerSegment"] = "CUSTOMER_SEGMENT";
})(PushSegmentType || (PushSegmentType = {}));
var PushUserLogOrderByField;
(function (PushUserLogOrderByField) {
    PushUserLogOrderByField["CreatedAt"] = "CREATED_AT";
})(PushUserLogOrderByField || (PushUserLogOrderByField = {}));
var PushUserLogPushStatus;
(function (PushUserLogPushStatus) {
    PushUserLogPushStatus["Waiting"] = "WAITING";
    PushUserLogPushStatus["Completed"] = "COMPLETED";
    PushUserLogPushStatus["PushTokenNotFound"] = "PUSH_TOKEN_NOT_FOUND";
})(PushUserLogPushStatus || (PushUserLogPushStatus = {}));
var FavoriteShopifyProductOrderByField;
(function (FavoriteShopifyProductOrderByField) {
    FavoriteShopifyProductOrderByField["CreatedAt"] = "CREATED_AT";
})(FavoriteShopifyProductOrderByField || (FavoriteShopifyProductOrderByField = {}));
var ShopifyAddonMasterOrderByField;
(function (ShopifyAddonMasterOrderByField) {
    ShopifyAddonMasterOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyAddonMasterOrderByField || (ShopifyAddonMasterOrderByField = {}));
var ShopifyInstalledAddonOrderByField;
(function (ShopifyInstalledAddonOrderByField) {
    ShopifyInstalledAddonOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyInstalledAddonOrderByField || (ShopifyInstalledAddonOrderByField = {}));
var ShopifyAddonType;
(function (ShopifyAddonType) {
    ShopifyAddonType["Raffle"] = "RAFFLE";
    ShopifyAddonType["Appsflyer"] = "APPSFLYER";
    ShopifyAddonType["ChannelTalk"] = "CHANNEL_TALK";
    ShopifyAddonType["SignUpBonus"] = "SIGN_UP_BONUS";
    ShopifyAddonType["OfflineStoreManagement"] = "OFFLINE_STORE_MANAGEMENT";
    ShopifyAddonType["AutoPushNotification"] = "AUTO_PUSH_NOTIFICATION";
})(ShopifyAddonType || (ShopifyAddonType = {}));
var ShopifyAdminProductStatus;
(function (ShopifyAdminProductStatus) {
    ShopifyAdminProductStatus["Active"] = "ACTIVE";
    ShopifyAdminProductStatus["Archived"] = "ARCHIVED";
    ShopifyAdminProductStatus["Draft"] = "DRAFT";
})(ShopifyAdminProductStatus || (ShopifyAdminProductStatus = {}));
var ShopifyAdminProductOrderByField;
(function (ShopifyAdminProductOrderByField) {
    ShopifyAdminProductOrderByField["Id"] = "ID";
    ShopifyAdminProductOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyAdminProductOrderByField || (ShopifyAdminProductOrderByField = {}));
var ShopifyAnnouncementOrderByField;
(function (ShopifyAnnouncementOrderByField) {
    ShopifyAnnouncementOrderByField["PublishTime"] = "PUBLISH_TIME";
})(ShopifyAnnouncementOrderByField || (ShopifyAnnouncementOrderByField = {}));
var ShopifyAnnouncementMasterOrderByField;
(function (ShopifyAnnouncementMasterOrderByField) {
    ShopifyAnnouncementMasterOrderByField["PublishTime"] = "PUBLISH_TIME";
})(ShopifyAnnouncementMasterOrderByField || (ShopifyAnnouncementMasterOrderByField = {}));
var ShopifyAnnouncementSenderRole;
(function (ShopifyAnnouncementSenderRole) {
    ShopifyAnnouncementSenderRole["Admin"] = "ADMIN";
    ShopifyAnnouncementSenderRole["System"] = "SYSTEM";
})(ShopifyAnnouncementSenderRole || (ShopifyAnnouncementSenderRole = {}));
var ShopifyAnnouncementSegmentCustomerInterestRulePushLogPushStatus;
(function (ShopifyAnnouncementSegmentCustomerInterestRulePushLogPushStatus) {
    ShopifyAnnouncementSegmentCustomerInterestRulePushLogPushStatus["Waiting"] = "WAITING";
    ShopifyAnnouncementSegmentCustomerInterestRulePushLogPushStatus["AllPushUserLogsCreated"] = "ALL_PUSH_USER_LOGS_CREATED";
    ShopifyAnnouncementSegmentCustomerInterestRulePushLogPushStatus["Completed"] = "COMPLETED";
})(ShopifyAnnouncementSegmentCustomerInterestRulePushLogPushStatus || (ShopifyAnnouncementSegmentCustomerInterestRulePushLogPushStatus = {}));
var ShopifyAnnouncementVipAppRankRulePushLogPushStatus;
(function (ShopifyAnnouncementVipAppRankRulePushLogPushStatus) {
    ShopifyAnnouncementVipAppRankRulePushLogPushStatus["Waiting"] = "WAITING";
    ShopifyAnnouncementVipAppRankRulePushLogPushStatus["AllPushUserLogsCreated"] = "ALL_PUSH_USER_LOGS_CREATED";
    ShopifyAnnouncementVipAppRankRulePushLogPushStatus["Completed"] = "COMPLETED";
})(ShopifyAnnouncementVipAppRankRulePushLogPushStatus || (ShopifyAnnouncementVipAppRankRulePushLogPushStatus = {}));
var ShopifyAppSubscriptionStatus;
(function (ShopifyAppSubscriptionStatus) {
    ShopifyAppSubscriptionStatus["Accepted"] = "ACCEPTED";
    ShopifyAppSubscriptionStatus["Active"] = "ACTIVE";
    ShopifyAppSubscriptionStatus["Cancelled"] = "CANCELLED";
    ShopifyAppSubscriptionStatus["Declined"] = "DECLINED";
    ShopifyAppSubscriptionStatus["Expired"] = "EXPIRED";
    ShopifyAppSubscriptionStatus["Frozen"] = "FROZEN";
    ShopifyAppSubscriptionStatus["Pending"] = "PENDING";
})(ShopifyAppSubscriptionStatus || (ShopifyAppSubscriptionStatus = {}));
var ShopifyAppPricingIntervalType;
(function (ShopifyAppPricingIntervalType) {
    ShopifyAppPricingIntervalType["Annual"] = "ANNUAL";
    ShopifyAppPricingIntervalType["Every_30Days"] = "EVERY_30_DAYS";
})(ShopifyAppPricingIntervalType || (ShopifyAppPricingIntervalType = {}));
var ShopifyAutoPushNotificationCustomerCreatedRuleOrderByField;
(function (ShopifyAutoPushNotificationCustomerCreatedRuleOrderByField) {
    ShopifyAutoPushNotificationCustomerCreatedRuleOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyAutoPushNotificationCustomerCreatedRuleOrderByField || (ShopifyAutoPushNotificationCustomerCreatedRuleOrderByField = {}));
var ShopifyCartLineOrderByField;
(function (ShopifyCartLineOrderByField) {
    ShopifyCartLineOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyCartLineOrderByField || (ShopifyCartLineOrderByField = {}));
var ShopifyCollectionOrderByField;
(function (ShopifyCollectionOrderByField) {
    ShopifyCollectionOrderByField["Id"] = "ID";
    ShopifyCollectionOrderByField["Relevance"] = "RELEVANCE";
    ShopifyCollectionOrderByField["Title"] = "TITLE";
    ShopifyCollectionOrderByField["UpdatedAt"] = "UPDATED_AT";
})(ShopifyCollectionOrderByField || (ShopifyCollectionOrderByField = {}));
var ShopifyProductCollectionOrderByField;
(function (ShopifyProductCollectionOrderByField) {
    ShopifyProductCollectionOrderByField["BestSelling"] = "BEST_SELLING";
    ShopifyProductCollectionOrderByField["CollectionDefault"] = "COLLECTION_DEFAULT";
    ShopifyProductCollectionOrderByField["Created"] = "CREATED";
    ShopifyProductCollectionOrderByField["Id"] = "ID";
    ShopifyProductCollectionOrderByField["Manual"] = "MANUAL";
    ShopifyProductCollectionOrderByField["Price"] = "PRICE";
    ShopifyProductCollectionOrderByField["Relevance"] = "RELEVANCE";
    ShopifyProductCollectionOrderByField["Title"] = "TITLE";
})(ShopifyProductCollectionOrderByField || (ShopifyProductCollectionOrderByField = {}));
var ShopifyCountryCode;
(function (ShopifyCountryCode) {
    /** Ascension Island. */
    ShopifyCountryCode["Ac"] = "AC";
    /** Andorra. */
    ShopifyCountryCode["Ad"] = "AD";
    /** United Arab Emirates. */
    ShopifyCountryCode["Ae"] = "AE";
    /** Afghanistan. */
    ShopifyCountryCode["Af"] = "AF";
    /** Antigua & Barbuda. */
    ShopifyCountryCode["Ag"] = "AG";
    /** Anguilla. */
    ShopifyCountryCode["Ai"] = "AI";
    /** Albania. */
    ShopifyCountryCode["Al"] = "AL";
    /** Armenia. */
    ShopifyCountryCode["Am"] = "AM";
    /** Netherlands Antilles. */
    ShopifyCountryCode["An"] = "AN";
    /** Angola. */
    ShopifyCountryCode["Ao"] = "AO";
    /** Argentina. */
    ShopifyCountryCode["Ar"] = "AR";
    /** Austria. */
    ShopifyCountryCode["At"] = "AT";
    /** Australia. */
    ShopifyCountryCode["Au"] = "AU";
    /** Aruba. */
    ShopifyCountryCode["Aw"] = "AW";
    /** Åland Islands. */
    ShopifyCountryCode["Ax"] = "AX";
    /** Azerbaijan. */
    ShopifyCountryCode["Az"] = "AZ";
    /** Bosnia & Herzegovina. */
    ShopifyCountryCode["Ba"] = "BA";
    /** Barbados. */
    ShopifyCountryCode["Bb"] = "BB";
    /** Bangladesh. */
    ShopifyCountryCode["Bd"] = "BD";
    /** Belgium. */
    ShopifyCountryCode["Be"] = "BE";
    /** Burkina Faso. */
    ShopifyCountryCode["Bf"] = "BF";
    /** Bulgaria. */
    ShopifyCountryCode["Bg"] = "BG";
    /** Bahrain. */
    ShopifyCountryCode["Bh"] = "BH";
    /** Burundi. */
    ShopifyCountryCode["Bi"] = "BI";
    /** Benin. */
    ShopifyCountryCode["Bj"] = "BJ";
    /** St. Barthélemy. */
    ShopifyCountryCode["Bl"] = "BL";
    /** Bermuda. */
    ShopifyCountryCode["Bm"] = "BM";
    /** Brunei. */
    ShopifyCountryCode["Bn"] = "BN";
    /** Bolivia. */
    ShopifyCountryCode["Bo"] = "BO";
    /** Caribbean Netherlands. */
    ShopifyCountryCode["Bq"] = "BQ";
    /** Brazil. */
    ShopifyCountryCode["Br"] = "BR";
    /** Bahamas. */
    ShopifyCountryCode["Bs"] = "BS";
    /** Bhutan. */
    ShopifyCountryCode["Bt"] = "BT";
    /** Bouvet Island. */
    ShopifyCountryCode["Bv"] = "BV";
    /** Botswana. */
    ShopifyCountryCode["Bw"] = "BW";
    /** Belarus. */
    ShopifyCountryCode["By"] = "BY";
    /** Belize. */
    ShopifyCountryCode["Bz"] = "BZ";
    /** Canada. */
    ShopifyCountryCode["Ca"] = "CA";
    /** Cocos (Keeling) Islands. */
    ShopifyCountryCode["Cc"] = "CC";
    /** Congo - Kinshasa. */
    ShopifyCountryCode["Cd"] = "CD";
    /** Central African Republic. */
    ShopifyCountryCode["Cf"] = "CF";
    /** Congo - Brazzaville. */
    ShopifyCountryCode["Cg"] = "CG";
    /** Switzerland. */
    ShopifyCountryCode["Ch"] = "CH";
    /** Côte d’Ivoire. */
    ShopifyCountryCode["Ci"] = "CI";
    /** Cook Islands. */
    ShopifyCountryCode["Ck"] = "CK";
    /** Chile. */
    ShopifyCountryCode["Cl"] = "CL";
    /** Cameroon. */
    ShopifyCountryCode["Cm"] = "CM";
    /** China. */
    ShopifyCountryCode["Cn"] = "CN";
    /** Colombia. */
    ShopifyCountryCode["Co"] = "CO";
    /** Costa Rica. */
    ShopifyCountryCode["Cr"] = "CR";
    /** Cuba. */
    ShopifyCountryCode["Cu"] = "CU";
    /** Cape Verde. */
    ShopifyCountryCode["Cv"] = "CV";
    /** Curaçao. */
    ShopifyCountryCode["Cw"] = "CW";
    /** Christmas Island. */
    ShopifyCountryCode["Cx"] = "CX";
    /** Cyprus. */
    ShopifyCountryCode["Cy"] = "CY";
    /** Czechia. */
    ShopifyCountryCode["Cz"] = "CZ";
    /** Germany. */
    ShopifyCountryCode["De"] = "DE";
    /** Djibouti. */
    ShopifyCountryCode["Dj"] = "DJ";
    /** Denmark. */
    ShopifyCountryCode["Dk"] = "DK";
    /** Dominica. */
    ShopifyCountryCode["Dm"] = "DM";
    /** Dominican Republic. */
    ShopifyCountryCode["Do"] = "DO";
    /** Algeria. */
    ShopifyCountryCode["Dz"] = "DZ";
    /** Ecuador. */
    ShopifyCountryCode["Ec"] = "EC";
    /** Estonia. */
    ShopifyCountryCode["Ee"] = "EE";
    /** Egypt. */
    ShopifyCountryCode["Eg"] = "EG";
    /** Western Sahara. */
    ShopifyCountryCode["Eh"] = "EH";
    /** Eritrea. */
    ShopifyCountryCode["Er"] = "ER";
    /** Spain. */
    ShopifyCountryCode["Es"] = "ES";
    /** Ethiopia. */
    ShopifyCountryCode["Et"] = "ET";
    /** Finland. */
    ShopifyCountryCode["Fi"] = "FI";
    /** Fiji. */
    ShopifyCountryCode["Fj"] = "FJ";
    /** Falkland Islands. */
    ShopifyCountryCode["Fk"] = "FK";
    /** Faroe Islands. */
    ShopifyCountryCode["Fo"] = "FO";
    /** France. */
    ShopifyCountryCode["Fr"] = "FR";
    /** Gabon. */
    ShopifyCountryCode["Ga"] = "GA";
    /** United Kingdom. */
    ShopifyCountryCode["Gb"] = "GB";
    /** Grenada. */
    ShopifyCountryCode["Gd"] = "GD";
    /** Georgia. */
    ShopifyCountryCode["Ge"] = "GE";
    /** French Guiana. */
    ShopifyCountryCode["Gf"] = "GF";
    /** Guernsey. */
    ShopifyCountryCode["Gg"] = "GG";
    /** Ghana. */
    ShopifyCountryCode["Gh"] = "GH";
    /** Gibraltar. */
    ShopifyCountryCode["Gi"] = "GI";
    /** Greenland. */
    ShopifyCountryCode["Gl"] = "GL";
    /** Gambia. */
    ShopifyCountryCode["Gm"] = "GM";
    /** Guinea. */
    ShopifyCountryCode["Gn"] = "GN";
    /** Guadeloupe. */
    ShopifyCountryCode["Gp"] = "GP";
    /** Equatorial Guinea. */
    ShopifyCountryCode["Gq"] = "GQ";
    /** Greece. */
    ShopifyCountryCode["Gr"] = "GR";
    /** South Georgia & South Sandwich Islands. */
    ShopifyCountryCode["Gs"] = "GS";
    /** Guatemala. */
    ShopifyCountryCode["Gt"] = "GT";
    /** Guinea-Bissau. */
    ShopifyCountryCode["Gw"] = "GW";
    /** Guyana. */
    ShopifyCountryCode["Gy"] = "GY";
    /** Hong Kong SAR. */
    ShopifyCountryCode["Hk"] = "HK";
    /** Heard & McDonald Islands. */
    ShopifyCountryCode["Hm"] = "HM";
    /** Honduras. */
    ShopifyCountryCode["Hn"] = "HN";
    /** Croatia. */
    ShopifyCountryCode["Hr"] = "HR";
    /** Haiti. */
    ShopifyCountryCode["Ht"] = "HT";
    /** Hungary. */
    ShopifyCountryCode["Hu"] = "HU";
    /** Indonesia. */
    ShopifyCountryCode["Id"] = "ID";
    /** Ireland. */
    ShopifyCountryCode["Ie"] = "IE";
    /** Israel. */
    ShopifyCountryCode["Il"] = "IL";
    /** Isle of Man. */
    ShopifyCountryCode["Im"] = "IM";
    /** India. */
    ShopifyCountryCode["In"] = "IN";
    /** British Indian Ocean Territory. */
    ShopifyCountryCode["Io"] = "IO";
    /** Iraq. */
    ShopifyCountryCode["Iq"] = "IQ";
    /** Iran. */
    ShopifyCountryCode["Ir"] = "IR";
    /** Iceland. */
    ShopifyCountryCode["Is"] = "IS";
    /** Italy. */
    ShopifyCountryCode["It"] = "IT";
    /** Jersey. */
    ShopifyCountryCode["Je"] = "JE";
    /** Jamaica. */
    ShopifyCountryCode["Jm"] = "JM";
    /** Jordan. */
    ShopifyCountryCode["Jo"] = "JO";
    /** Japan. */
    ShopifyCountryCode["Jp"] = "JP";
    /** Kenya. */
    ShopifyCountryCode["Ke"] = "KE";
    /** Kyrgyzstan. */
    ShopifyCountryCode["Kg"] = "KG";
    /** Cambodia. */
    ShopifyCountryCode["Kh"] = "KH";
    /** Kiribati. */
    ShopifyCountryCode["Ki"] = "KI";
    /** Comoros. */
    ShopifyCountryCode["Km"] = "KM";
    /** St. Kitts & Nevis. */
    ShopifyCountryCode["Kn"] = "KN";
    /** North Korea. */
    ShopifyCountryCode["Kp"] = "KP";
    /** South Korea. */
    ShopifyCountryCode["Kr"] = "KR";
    /** Kuwait. */
    ShopifyCountryCode["Kw"] = "KW";
    /** Cayman Islands. */
    ShopifyCountryCode["Ky"] = "KY";
    /** Kazakhstan. */
    ShopifyCountryCode["Kz"] = "KZ";
    /** Laos. */
    ShopifyCountryCode["La"] = "LA";
    /** Lebanon. */
    ShopifyCountryCode["Lb"] = "LB";
    /** St. Lucia. */
    ShopifyCountryCode["Lc"] = "LC";
    /** Liechtenstein. */
    ShopifyCountryCode["Li"] = "LI";
    /** Sri Lanka. */
    ShopifyCountryCode["Lk"] = "LK";
    /** Liberia. */
    ShopifyCountryCode["Lr"] = "LR";
    /** Lesotho. */
    ShopifyCountryCode["Ls"] = "LS";
    /** Lithuania. */
    ShopifyCountryCode["Lt"] = "LT";
    /** Luxembourg. */
    ShopifyCountryCode["Lu"] = "LU";
    /** Latvia. */
    ShopifyCountryCode["Lv"] = "LV";
    /** Libya. */
    ShopifyCountryCode["Ly"] = "LY";
    /** Morocco. */
    ShopifyCountryCode["Ma"] = "MA";
    /** Monaco. */
    ShopifyCountryCode["Mc"] = "MC";
    /** Moldova. */
    ShopifyCountryCode["Md"] = "MD";
    /** Montenegro. */
    ShopifyCountryCode["Me"] = "ME";
    /** St. Martin. */
    ShopifyCountryCode["Mf"] = "MF";
    /** Madagascar. */
    ShopifyCountryCode["Mg"] = "MG";
    /** North Macedonia. */
    ShopifyCountryCode["Mk"] = "MK";
    /** Mali. */
    ShopifyCountryCode["Ml"] = "ML";
    /** Myanmar (Burma). */
    ShopifyCountryCode["Mm"] = "MM";
    /** Mongolia. */
    ShopifyCountryCode["Mn"] = "MN";
    /** Macao SAR. */
    ShopifyCountryCode["Mo"] = "MO";
    /** Martinique. */
    ShopifyCountryCode["Mq"] = "MQ";
    /** Mauritania. */
    ShopifyCountryCode["Mr"] = "MR";
    /** Montserrat. */
    ShopifyCountryCode["Ms"] = "MS";
    /** Malta. */
    ShopifyCountryCode["Mt"] = "MT";
    /** Mauritius. */
    ShopifyCountryCode["Mu"] = "MU";
    /** Maldives. */
    ShopifyCountryCode["Mv"] = "MV";
    /** Malawi. */
    ShopifyCountryCode["Mw"] = "MW";
    /** Mexico. */
    ShopifyCountryCode["Mx"] = "MX";
    /** Malaysia. */
    ShopifyCountryCode["My"] = "MY";
    /** Mozambique. */
    ShopifyCountryCode["Mz"] = "MZ";
    /** Namibia. */
    ShopifyCountryCode["Na"] = "NA";
    /** New Caledonia. */
    ShopifyCountryCode["Nc"] = "NC";
    /** Niger. */
    ShopifyCountryCode["Ne"] = "NE";
    /** Norfolk Island. */
    ShopifyCountryCode["Nf"] = "NF";
    /** Nigeria. */
    ShopifyCountryCode["Ng"] = "NG";
    /** Nicaragua. */
    ShopifyCountryCode["Ni"] = "NI";
    /** Netherlands. */
    ShopifyCountryCode["Nl"] = "NL";
    /** Norway. */
    ShopifyCountryCode["No"] = "NO";
    /** Nepal. */
    ShopifyCountryCode["Np"] = "NP";
    /** Nauru. */
    ShopifyCountryCode["Nr"] = "NR";
    /** Niue. */
    ShopifyCountryCode["Nu"] = "NU";
    /** New Zealand. */
    ShopifyCountryCode["Nz"] = "NZ";
    /** Oman. */
    ShopifyCountryCode["Om"] = "OM";
    /** Panama. */
    ShopifyCountryCode["Pa"] = "PA";
    /** Peru. */
    ShopifyCountryCode["Pe"] = "PE";
    /** French Polynesia. */
    ShopifyCountryCode["Pf"] = "PF";
    /** Papua New Guinea. */
    ShopifyCountryCode["Pg"] = "PG";
    /** Philippines. */
    ShopifyCountryCode["Ph"] = "PH";
    /** Pakistan. */
    ShopifyCountryCode["Pk"] = "PK";
    /** Poland. */
    ShopifyCountryCode["Pl"] = "PL";
    /** St. Pierre & Miquelon. */
    ShopifyCountryCode["Pm"] = "PM";
    /** Pitcairn Islands. */
    ShopifyCountryCode["Pn"] = "PN";
    /** Palestinian Territories. */
    ShopifyCountryCode["Ps"] = "PS";
    /** Portugal. */
    ShopifyCountryCode["Pt"] = "PT";
    /** Paraguay. */
    ShopifyCountryCode["Py"] = "PY";
    /** Qatar. */
    ShopifyCountryCode["Qa"] = "QA";
    /** Réunion. */
    ShopifyCountryCode["Re"] = "RE";
    /** Romania. */
    ShopifyCountryCode["Ro"] = "RO";
    /** Serbia. */
    ShopifyCountryCode["Rs"] = "RS";
    /** Russia. */
    ShopifyCountryCode["Ru"] = "RU";
    /** Rwanda. */
    ShopifyCountryCode["Rw"] = "RW";
    /** Saudi Arabia. */
    ShopifyCountryCode["Sa"] = "SA";
    /** Solomon Islands. */
    ShopifyCountryCode["Sb"] = "SB";
    /** Seychelles. */
    ShopifyCountryCode["Sc"] = "SC";
    /** Sudan. */
    ShopifyCountryCode["Sd"] = "SD";
    /** Sweden. */
    ShopifyCountryCode["Se"] = "SE";
    /** Singapore. */
    ShopifyCountryCode["Sg"] = "SG";
    /** St. Helena. */
    ShopifyCountryCode["Sh"] = "SH";
    /** Slovenia. */
    ShopifyCountryCode["Si"] = "SI";
    /** Svalbard & Jan Mayen. */
    ShopifyCountryCode["Sj"] = "SJ";
    /** Slovakia. */
    ShopifyCountryCode["Sk"] = "SK";
    /** Sierra Leone. */
    ShopifyCountryCode["Sl"] = "SL";
    /** San Marino. */
    ShopifyCountryCode["Sm"] = "SM";
    /** Senegal. */
    ShopifyCountryCode["Sn"] = "SN";
    /** Somalia. */
    ShopifyCountryCode["So"] = "SO";
    /** Suriname. */
    ShopifyCountryCode["Sr"] = "SR";
    /** South Sudan. */
    ShopifyCountryCode["Ss"] = "SS";
    /** São Tomé & Príncipe. */
    ShopifyCountryCode["St"] = "ST";
    /** El Salvador. */
    ShopifyCountryCode["Sv"] = "SV";
    /** Sint Maarten. */
    ShopifyCountryCode["Sx"] = "SX";
    /** Syria. */
    ShopifyCountryCode["Sy"] = "SY";
    /** Eswatini. */
    ShopifyCountryCode["Sz"] = "SZ";
    /** Tristan da Cunha. */
    ShopifyCountryCode["Ta"] = "TA";
    /** Turks & Caicos Islands. */
    ShopifyCountryCode["Tc"] = "TC";
    /** Chad. */
    ShopifyCountryCode["Td"] = "TD";
    /** French Southern Territories. */
    ShopifyCountryCode["Tf"] = "TF";
    /** Togo. */
    ShopifyCountryCode["Tg"] = "TG";
    /** Thailand. */
    ShopifyCountryCode["Th"] = "TH";
    /** Tajikistan. */
    ShopifyCountryCode["Tj"] = "TJ";
    /** Tokelau. */
    ShopifyCountryCode["Tk"] = "TK";
    /** Timor-Leste. */
    ShopifyCountryCode["Tl"] = "TL";
    /** Turkmenistan. */
    ShopifyCountryCode["Tm"] = "TM";
    /** Tunisia. */
    ShopifyCountryCode["Tn"] = "TN";
    /** Tonga. */
    ShopifyCountryCode["To"] = "TO";
    /** Turkey. */
    ShopifyCountryCode["Tr"] = "TR";
    /** Trinidad & Tobago. */
    ShopifyCountryCode["Tt"] = "TT";
    /** Tuvalu. */
    ShopifyCountryCode["Tv"] = "TV";
    /** Taiwan. */
    ShopifyCountryCode["Tw"] = "TW";
    /** Tanzania. */
    ShopifyCountryCode["Tz"] = "TZ";
    /** Ukraine. */
    ShopifyCountryCode["Ua"] = "UA";
    /** Uganda. */
    ShopifyCountryCode["Ug"] = "UG";
    /** U.S. Outlying Islands. */
    ShopifyCountryCode["Um"] = "UM";
    /** United States. */
    ShopifyCountryCode["Us"] = "US";
    /** Uruguay. */
    ShopifyCountryCode["Uy"] = "UY";
    /** Uzbekistan. */
    ShopifyCountryCode["Uz"] = "UZ";
    /** Vatican City. */
    ShopifyCountryCode["Va"] = "VA";
    /** St. Vincent & Grenadines. */
    ShopifyCountryCode["Vc"] = "VC";
    /** Venezuela. */
    ShopifyCountryCode["Ve"] = "VE";
    /** British Virgin Islands. */
    ShopifyCountryCode["Vg"] = "VG";
    /** Vietnam. */
    ShopifyCountryCode["Vn"] = "VN";
    /** Vanuatu. */
    ShopifyCountryCode["Vu"] = "VU";
    /** Wallis & Futuna. */
    ShopifyCountryCode["Wf"] = "WF";
    /** Samoa. */
    ShopifyCountryCode["Ws"] = "WS";
    /** Kosovo. */
    ShopifyCountryCode["Xk"] = "XK";
    /** Yemen. */
    ShopifyCountryCode["Ye"] = "YE";
    /** Mayotte. */
    ShopifyCountryCode["Yt"] = "YT";
    /** South Africa. */
    ShopifyCountryCode["Za"] = "ZA";
    /** Zambia. */
    ShopifyCountryCode["Zm"] = "ZM";
    /** Zimbabwe. */
    ShopifyCountryCode["Zw"] = "ZW";
    /** Unknown Region. */
    ShopifyCountryCode["Zz"] = "ZZ";
})(ShopifyCountryCode || (ShopifyCountryCode = {}));
var ShopifyCouponDeleteLogStatus;
(function (ShopifyCouponDeleteLogStatus) {
    ShopifyCouponDeleteLogStatus["Waiting"] = "WAITING";
    ShopifyCouponDeleteLogStatus["Completed"] = "COMPLETED";
})(ShopifyCouponDeleteLogStatus || (ShopifyCouponDeleteLogStatus = {}));
var ShopifyCouponDeleteLogOrderByField;
(function (ShopifyCouponDeleteLogOrderByField) {
    ShopifyCouponDeleteLogOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyCouponDeleteLogOrderByField || (ShopifyCouponDeleteLogOrderByField = {}));
var ShopifyCurrencyCode;
(function (ShopifyCurrencyCode) {
    /** United Arab Emirates Dirham (AED). */
    ShopifyCurrencyCode["Aed"] = "AED";
    /** Afghan Afghani (AFN). */
    ShopifyCurrencyCode["Afn"] = "AFN";
    /** Albanian Lek (ALL). */
    ShopifyCurrencyCode["All"] = "ALL";
    /** Armenian Dram (AMD). */
    ShopifyCurrencyCode["Amd"] = "AMD";
    /** Netherlands Antillean Guilder. */
    ShopifyCurrencyCode["Ang"] = "ANG";
    /** Angolan Kwanza (AOA). */
    ShopifyCurrencyCode["Aoa"] = "AOA";
    /** Argentine Pesos (ARS). */
    ShopifyCurrencyCode["Ars"] = "ARS";
    /** Australian Dollars (AUD). */
    ShopifyCurrencyCode["Aud"] = "AUD";
    /** Aruban Florin (AWG). */
    ShopifyCurrencyCode["Awg"] = "AWG";
    /** Azerbaijani Manat (AZN). */
    ShopifyCurrencyCode["Azn"] = "AZN";
    /** Bosnia and Herzegovina Convertible Mark (BAM). */
    ShopifyCurrencyCode["Bam"] = "BAM";
    /** Barbadian Dollar (BBD). */
    ShopifyCurrencyCode["Bbd"] = "BBD";
    /** Bangladesh Taka (BDT). */
    ShopifyCurrencyCode["Bdt"] = "BDT";
    /** Bulgarian Lev (BGN). */
    ShopifyCurrencyCode["Bgn"] = "BGN";
    /** Bahraini Dinar (BHD). */
    ShopifyCurrencyCode["Bhd"] = "BHD";
    /** Burundian Franc (BIF). */
    ShopifyCurrencyCode["Bif"] = "BIF";
    /** Bermudian Dollar (BMD). */
    ShopifyCurrencyCode["Bmd"] = "BMD";
    /** Brunei Dollar (BND). */
    ShopifyCurrencyCode["Bnd"] = "BND";
    /** Bolivian Boliviano (BOB). */
    ShopifyCurrencyCode["Bob"] = "BOB";
    /** Brazilian Real (BRL). */
    ShopifyCurrencyCode["Brl"] = "BRL";
    /** Bahamian Dollar (BSD). */
    ShopifyCurrencyCode["Bsd"] = "BSD";
    /** Bhutanese Ngultrum (BTN). */
    ShopifyCurrencyCode["Btn"] = "BTN";
    /** Botswana Pula (BWP). */
    ShopifyCurrencyCode["Bwp"] = "BWP";
    /** Belize Dollar (BZD). */
    ShopifyCurrencyCode["Bzd"] = "BZD";
    /** Canadian Dollars (CAD). */
    ShopifyCurrencyCode["Cad"] = "CAD";
    /** Congolese franc (CDF). */
    ShopifyCurrencyCode["Cdf"] = "CDF";
    /** Swiss Francs (CHF). */
    ShopifyCurrencyCode["Chf"] = "CHF";
    /** Chilean Peso (CLP). */
    ShopifyCurrencyCode["Clp"] = "CLP";
    /** Chinese Yuan Renminbi (CNY). */
    ShopifyCurrencyCode["Cny"] = "CNY";
    /** Colombian Peso (COP). */
    ShopifyCurrencyCode["Cop"] = "COP";
    /** Costa Rican Colones (CRC). */
    ShopifyCurrencyCode["Crc"] = "CRC";
    /** Cape Verdean escudo (CVE). */
    ShopifyCurrencyCode["Cve"] = "CVE";
    /** Czech Koruny (CZK). */
    ShopifyCurrencyCode["Czk"] = "CZK";
    /** Djiboutian Franc (DJF). */
    ShopifyCurrencyCode["Djf"] = "DJF";
    /** Danish Kroner (DKK). */
    ShopifyCurrencyCode["Dkk"] = "DKK";
    /** Dominican Peso (DOP). */
    ShopifyCurrencyCode["Dop"] = "DOP";
    /** Algerian Dinar (DZD). */
    ShopifyCurrencyCode["Dzd"] = "DZD";
    /** Egyptian Pound (EGP). */
    ShopifyCurrencyCode["Egp"] = "EGP";
    /** Ethiopian Birr (ETB). */
    ShopifyCurrencyCode["Etb"] = "ETB";
    /** Euro (EUR). */
    ShopifyCurrencyCode["Eur"] = "EUR";
    /** Fijian Dollars (FJD). */
    ShopifyCurrencyCode["Fjd"] = "FJD";
    /** Falkland Islands Pounds (FKP). */
    ShopifyCurrencyCode["Fkp"] = "FKP";
    /** United Kingdom Pounds (GBP). */
    ShopifyCurrencyCode["Gbp"] = "GBP";
    /** Georgian Lari (GEL). */
    ShopifyCurrencyCode["Gel"] = "GEL";
    /** Ghanaian Cedi (GHS). */
    ShopifyCurrencyCode["Ghs"] = "GHS";
    /** Gibraltar Pounds (GIP). */
    ShopifyCurrencyCode["Gip"] = "GIP";
    /** Gambian Dalasi (GMD). */
    ShopifyCurrencyCode["Gmd"] = "GMD";
    /** Guinean Franc (GNF). */
    ShopifyCurrencyCode["Gnf"] = "GNF";
    /** Guatemalan Quetzal (GTQ). */
    ShopifyCurrencyCode["Gtq"] = "GTQ";
    /** Guyanese Dollar (GYD). */
    ShopifyCurrencyCode["Gyd"] = "GYD";
    /** Hong Kong Dollars (HKD). */
    ShopifyCurrencyCode["Hkd"] = "HKD";
    /** Honduran Lempira (HNL). */
    ShopifyCurrencyCode["Hnl"] = "HNL";
    /** Croatian Kuna (HRK). */
    ShopifyCurrencyCode["Hrk"] = "HRK";
    /** Haitian Gourde (HTG). */
    ShopifyCurrencyCode["Htg"] = "HTG";
    /** Hungarian Forint (HUF). */
    ShopifyCurrencyCode["Huf"] = "HUF";
    /** Indonesian Rupiah (IDR). */
    ShopifyCurrencyCode["Idr"] = "IDR";
    /** Israeli New Shekel (NIS). */
    ShopifyCurrencyCode["Ils"] = "ILS";
    /** Indian Rupees (INR). */
    ShopifyCurrencyCode["Inr"] = "INR";
    /** Iraqi Dinar (IQD). */
    ShopifyCurrencyCode["Iqd"] = "IQD";
    /** Iranian Rial (IRR). */
    ShopifyCurrencyCode["Irr"] = "IRR";
    /** Icelandic Kronur (ISK). */
    ShopifyCurrencyCode["Isk"] = "ISK";
    /** Jersey Pound. */
    ShopifyCurrencyCode["Jep"] = "JEP";
    /** Jamaican Dollars (JMD). */
    ShopifyCurrencyCode["Jmd"] = "JMD";
    /** Jordanian Dinar (JOD). */
    ShopifyCurrencyCode["Jod"] = "JOD";
    /** Japanese Yen (JPY). */
    ShopifyCurrencyCode["Jpy"] = "JPY";
    /** Kenyan Shilling (KES). */
    ShopifyCurrencyCode["Kes"] = "KES";
    /** Kyrgyzstani Som (KGS). */
    ShopifyCurrencyCode["Kgs"] = "KGS";
    /** Cambodian Riel. */
    ShopifyCurrencyCode["Khr"] = "KHR";
    /** Comorian Franc (KMF). */
    ShopifyCurrencyCode["Kmf"] = "KMF";
    /** South Korean Won (KRW). */
    ShopifyCurrencyCode["Krw"] = "KRW";
    /** Kuwaiti Dinar (KWD). */
    ShopifyCurrencyCode["Kwd"] = "KWD";
    /** Cayman Dollars (KYD). */
    ShopifyCurrencyCode["Kyd"] = "KYD";
    /** Kazakhstani Tenge (KZT). */
    ShopifyCurrencyCode["Kzt"] = "KZT";
    /** Laotian Kip (LAK). */
    ShopifyCurrencyCode["Lak"] = "LAK";
    /** Lebanese Pounds (LBP). */
    ShopifyCurrencyCode["Lbp"] = "LBP";
    /** Sri Lankan Rupees (LKR). */
    ShopifyCurrencyCode["Lkr"] = "LKR";
    /** Liberian Dollar (LRD). */
    ShopifyCurrencyCode["Lrd"] = "LRD";
    /** Lesotho Loti (LSL). */
    ShopifyCurrencyCode["Lsl"] = "LSL";
    /** Lithuanian Litai (LTL). */
    ShopifyCurrencyCode["Ltl"] = "LTL";
    /** Latvian Lati (LVL). */
    ShopifyCurrencyCode["Lvl"] = "LVL";
    /** Libyan Dinar (LYD). */
    ShopifyCurrencyCode["Lyd"] = "LYD";
    /** Moroccan Dirham. */
    ShopifyCurrencyCode["Mad"] = "MAD";
    /** Moldovan Leu (MDL). */
    ShopifyCurrencyCode["Mdl"] = "MDL";
    /** Malagasy Ariary (MGA). */
    ShopifyCurrencyCode["Mga"] = "MGA";
    /** Macedonia Denar (MKD). */
    ShopifyCurrencyCode["Mkd"] = "MKD";
    /** Burmese Kyat (MMK). */
    ShopifyCurrencyCode["Mmk"] = "MMK";
    /** Mongolian Tugrik. */
    ShopifyCurrencyCode["Mnt"] = "MNT";
    /** Macanese Pataca (MOP). */
    ShopifyCurrencyCode["Mop"] = "MOP";
    /** Mauritian Rupee (MUR). */
    ShopifyCurrencyCode["Mur"] = "MUR";
    /** Maldivian Rufiyaa (MVR). */
    ShopifyCurrencyCode["Mvr"] = "MVR";
    /** Malawian Kwacha (MWK). */
    ShopifyCurrencyCode["Mwk"] = "MWK";
    /** Mexican Pesos (MXN). */
    ShopifyCurrencyCode["Mxn"] = "MXN";
    /** Malaysian Ringgits (MYR). */
    ShopifyCurrencyCode["Myr"] = "MYR";
    /** Mozambican Metical. */
    ShopifyCurrencyCode["Mzn"] = "MZN";
    /** Namibian Dollar. */
    ShopifyCurrencyCode["Nad"] = "NAD";
    /** Nigerian Naira (NGN). */
    ShopifyCurrencyCode["Ngn"] = "NGN";
    /** Nicaraguan Córdoba (NIO). */
    ShopifyCurrencyCode["Nio"] = "NIO";
    /** Norwegian Kroner (NOK). */
    ShopifyCurrencyCode["Nok"] = "NOK";
    /** Nepalese Rupee (NPR). */
    ShopifyCurrencyCode["Npr"] = "NPR";
    /** New Zealand Dollars (NZD). */
    ShopifyCurrencyCode["Nzd"] = "NZD";
    /** Omani Rial (OMR). */
    ShopifyCurrencyCode["Omr"] = "OMR";
    /** Panamian Balboa (PAB). */
    ShopifyCurrencyCode["Pab"] = "PAB";
    /** Peruvian Nuevo Sol (PEN). */
    ShopifyCurrencyCode["Pen"] = "PEN";
    /** Papua New Guinean Kina (PGK). */
    ShopifyCurrencyCode["Pgk"] = "PGK";
    /** Philippine Peso (PHP). */
    ShopifyCurrencyCode["Php"] = "PHP";
    /** Pakistani Rupee (PKR). */
    ShopifyCurrencyCode["Pkr"] = "PKR";
    /** Polish Zlotych (PLN). */
    ShopifyCurrencyCode["Pln"] = "PLN";
    /** Paraguayan Guarani (PYG). */
    ShopifyCurrencyCode["Pyg"] = "PYG";
    /** Qatari Rial (QAR). */
    ShopifyCurrencyCode["Qar"] = "QAR";
    /** Romanian Lei (RON). */
    ShopifyCurrencyCode["Ron"] = "RON";
    /** Serbian dinar (RSD). */
    ShopifyCurrencyCode["Rsd"] = "RSD";
    /** Russian Rubles (RUB). */
    ShopifyCurrencyCode["Rub"] = "RUB";
    /** Rwandan Franc (RWF). */
    ShopifyCurrencyCode["Rwf"] = "RWF";
    /** Saudi Riyal (SAR). */
    ShopifyCurrencyCode["Sar"] = "SAR";
    /** Solomon Islands Dollar (SBD). */
    ShopifyCurrencyCode["Sbd"] = "SBD";
    /** Seychellois Rupee (SCR). */
    ShopifyCurrencyCode["Scr"] = "SCR";
    /** Sudanese Pound (SDG). */
    ShopifyCurrencyCode["Sdg"] = "SDG";
    /** Swedish Kronor (SEK). */
    ShopifyCurrencyCode["Sek"] = "SEK";
    /** Singapore Dollars (SGD). */
    ShopifyCurrencyCode["Sgd"] = "SGD";
    /** Saint Helena Pounds (SHP). */
    ShopifyCurrencyCode["Shp"] = "SHP";
    /** Sierra Leonean Leone (SLL). */
    ShopifyCurrencyCode["Sll"] = "SLL";
    /** Surinamese Dollar (SRD). */
    ShopifyCurrencyCode["Srd"] = "SRD";
    /** South Sudanese Pound (SSP). */
    ShopifyCurrencyCode["Ssp"] = "SSP";
    /** Sao Tome And Principe Dobra (STD). */
    ShopifyCurrencyCode["Std"] = "STD";
    /** Syrian Pound (SYP). */
    ShopifyCurrencyCode["Syp"] = "SYP";
    /** Swazi Lilangeni (SZL). */
    ShopifyCurrencyCode["Szl"] = "SZL";
    /** Thai baht (THB). */
    ShopifyCurrencyCode["Thb"] = "THB";
    /** Tajikistani Somoni (TJS). */
    ShopifyCurrencyCode["Tjs"] = "TJS";
    /** Turkmenistani Manat (TMT). */
    ShopifyCurrencyCode["Tmt"] = "TMT";
    /** Tunisian Dinar (TND). */
    ShopifyCurrencyCode["Tnd"] = "TND";
    /** Tongan Pa'anga (TOP). */
    ShopifyCurrencyCode["Top"] = "TOP";
    /** Turkish Lira (TRY). */
    ShopifyCurrencyCode["Try"] = "TRY";
    /** Trinidad and Tobago Dollars (TTD). */
    ShopifyCurrencyCode["Ttd"] = "TTD";
    /** Taiwan Dollars (TWD). */
    ShopifyCurrencyCode["Twd"] = "TWD";
    /** Tanzanian Shilling (TZS). */
    ShopifyCurrencyCode["Tzs"] = "TZS";
    /** Ukrainian Hryvnia (UAH). */
    ShopifyCurrencyCode["Uah"] = "UAH";
    /** Ugandan Shilling (UGX). */
    ShopifyCurrencyCode["Ugx"] = "UGX";
    /** United States Dollars (USD). */
    ShopifyCurrencyCode["Usd"] = "USD";
    /** Uruguayan Pesos (UYU). */
    ShopifyCurrencyCode["Uyu"] = "UYU";
    /** Uzbekistan som (UZS). */
    ShopifyCurrencyCode["Uzs"] = "UZS";
    /** Vietnamese đồng (VND). */
    ShopifyCurrencyCode["Vnd"] = "VND";
    /** Vanuatu Vatu (VUV). */
    ShopifyCurrencyCode["Vuv"] = "VUV";
    /** Samoan Tala (WST). */
    ShopifyCurrencyCode["Wst"] = "WST";
    /** Central African CFA Franc (XAF). */
    ShopifyCurrencyCode["Xaf"] = "XAF";
    /** East Caribbean Dollar (XCD). */
    ShopifyCurrencyCode["Xcd"] = "XCD";
    /** West African CFA franc (XOF). */
    ShopifyCurrencyCode["Xof"] = "XOF";
    /** CFP Franc (XPF). */
    ShopifyCurrencyCode["Xpf"] = "XPF";
    /** Yemeni Rial (YER). */
    ShopifyCurrencyCode["Yer"] = "YER";
    /** South African Rand (ZAR). */
    ShopifyCurrencyCode["Zar"] = "ZAR";
    /** Zambian Kwacha (ZMW). */
    ShopifyCurrencyCode["Zmw"] = "ZMW";
})(ShopifyCurrencyCode || (ShopifyCurrencyCode = {}));
var ShopifyCouponDiscountType;
(function (ShopifyCouponDiscountType) {
    /** 割引率で値引き */
    ShopifyCouponDiscountType["Percentage"] = "PERCENTAGE";
    /** 固定額で値引き */
    ShopifyCouponDiscountType["Constant"] = "CONSTANT";
})(ShopifyCouponDiscountType || (ShopifyCouponDiscountType = {}));
var ShopifyCustomerCouponOrderByField;
(function (ShopifyCustomerCouponOrderByField) {
    ShopifyCustomerCouponOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyCustomerCouponOrderByField || (ShopifyCustomerCouponOrderByField = {}));
var ShopifyCustomerCouponKind;
(function (ShopifyCustomerCouponKind) {
    ShopifyCustomerCouponKind["SignUpBonus"] = "SIGN_UP_BONUS";
})(ShopifyCustomerCouponKind || (ShopifyCustomerCouponKind = {}));
var ShopifyCustomerCouponLogOrderByField;
(function (ShopifyCustomerCouponLogOrderByField) {
    ShopifyCustomerCouponLogOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyCustomerCouponLogOrderByField || (ShopifyCustomerCouponLogOrderByField = {}));
var ShopifyCustomerCouponMerchantDeliveryRuleStatus;
(function (ShopifyCustomerCouponMerchantDeliveryRuleStatus) {
    /** 配信予定。現在日時がまだ配信開始日時になっていない場合 */
    ShopifyCustomerCouponMerchantDeliveryRuleStatus["Ready"] = "READY";
    /** 新規カスタマーへの配信期間中。isDeliveryNewMobileAppCustomerEnabledがtrueで、現在日時が配信期間内の場合 */
    ShopifyCustomerCouponMerchantDeliveryRuleStatus["Underway"] = "UNDERWAY";
    /** 配信完了。現在日時がendsAtを過ぎた、またはisDeliveryNewMobileAppCustomerEnabledがfalseの場合 */
    ShopifyCustomerCouponMerchantDeliveryRuleStatus["Finished"] = "FINISHED";
    /** 配信一時停止中 */
    ShopifyCustomerCouponMerchantDeliveryRuleStatus["Paused"] = "PAUSED";
})(ShopifyCustomerCouponMerchantDeliveryRuleStatus || (ShopifyCustomerCouponMerchantDeliveryRuleStatus = {}));
var ShopifyCustomerCouponMerchantDeliveryRuleOrderByField;
(function (ShopifyCustomerCouponMerchantDeliveryRuleOrderByField) {
    ShopifyCustomerCouponMerchantDeliveryRuleOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyCustomerCouponMerchantDeliveryRuleOrderByField || (ShopifyCustomerCouponMerchantDeliveryRuleOrderByField = {}));
var ShopifyCustomerOrderOrderByField;
(function (ShopifyCustomerOrderOrderByField) {
    ShopifyCustomerOrderOrderByField["ProcessedAt"] = "PROCESSED_AT";
    ShopifyCustomerOrderOrderByField["Id"] = "ID";
    ShopifyCustomerOrderOrderByField["TotalPrice"] = "TOTAL_PRICE";
    ShopifyCustomerOrderOrderByField["Relevance"] = "RELEVANCE";
    ShopifyCustomerOrderOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyCustomerOrderOrderByField || (ShopifyCustomerOrderOrderByField = {}));
/** バナーをタップしたときの遷移先画面の区分 */
var ShopifyDesignBlockPageBannerPageKind;
(function (ShopifyDesignBlockPageBannerPageKind) {
    /** アカウント画面 */
    ShopifyDesignBlockPageBannerPageKind["Account"] = "ACCOUNT";
    /** お気に入り */
    ShopifyDesignBlockPageBannerPageKind["Favorite"] = "FAVORITE";
    /** 会員証 */
    ShopifyDesignBlockPageBannerPageKind["MemberCard"] = "MEMBER_CARD";
    /** 実店舗一覧画面 */
    ShopifyDesignBlockPageBannerPageKind["OfflineStore"] = "OFFLINE_STORE";
    /** エリア (実店舗管理) */
    ShopifyDesignBlockPageBannerPageKind["OfflineStoreArea"] = "OFFLINE_STORE_AREA";
    /** ブランド (実店舗管理) */
    ShopifyDesignBlockPageBannerPageKind["OfflineStoreBrand"] = "OFFLINE_STORE_BRAND";
})(ShopifyDesignBlockPageBannerPageKind || (ShopifyDesignBlockPageBannerPageKind = {}));
var ShopifyDesignBlockOrderByField;
(function (ShopifyDesignBlockOrderByField) {
    ShopifyDesignBlockOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyDesignBlockOrderByField || (ShopifyDesignBlockOrderByField = {}));
var ShopifyDesignBlockType;
(function (ShopifyDesignBlockType) {
    ShopifyDesignBlockType["Update"] = "Update";
    ShopifyDesignBlockType["PlainBanner"] = "PlainBanner";
    ShopifyDesignBlockType["WebBanner"] = "WebBanner";
    ShopifyDesignBlockType["ProductBanner"] = "ProductBanner";
    ShopifyDesignBlockType["CollectionBanner"] = "CollectionBanner";
    ShopifyDesignBlockType["PageBanner"] = "PageBanner";
    ShopifyDesignBlockType["Collections"] = "Collections";
    ShopifyDesignBlockType["Collections2"] = "Collections2";
    ShopifyDesignBlockType["CollectionProducts"] = "CollectionProducts";
    ShopifyDesignBlockType["CollectionProducts2"] = "CollectionProducts2";
})(ShopifyDesignBlockType || (ShopifyDesignBlockType = {}));
var ShopifyDesignBlockMasterOrderByField;
(function (ShopifyDesignBlockMasterOrderByField) {
    ShopifyDesignBlockMasterOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyDesignBlockMasterOrderByField || (ShopifyDesignBlockMasterOrderByField = {}));
var ShopifyDesignMerchantSectionItemOrderByField;
(function (ShopifyDesignMerchantSectionItemOrderByField) {
    ShopifyDesignMerchantSectionItemOrderByField["Order"] = "ORDER";
})(ShopifyDesignMerchantSectionItemOrderByField || (ShopifyDesignMerchantSectionItemOrderByField = {}));
/** 会員証のmemberIDをどの連携サービスで定められた方法で取得するかの区分 */
var ShopifyDesignMemberCardMemberIdProviderKind;
(function (ShopifyDesignMemberCardMemberIdProviderKind) {
    ShopifyDesignMemberCardMemberIdProviderKind["Shopify"] = "SHOPIFY";
    ShopifyDesignMemberCardMemberIdProviderKind["OmniHub"] = "OMNI_HUB";
})(ShopifyDesignMemberCardMemberIdProviderKind || (ShopifyDesignMemberCardMemberIdProviderKind = {}));
var ShopifyMobileAppMode;
(function (ShopifyMobileAppMode) {
    ShopifyMobileAppMode["Public"] = "PUBLIC";
    ShopifyMobileAppMode["Private"] = "PRIVATE";
})(ShopifyMobileAppMode || (ShopifyMobileAppMode = {}));
var ShopifyMobileAppOrderByField;
(function (ShopifyMobileAppOrderByField) {
    ShopifyMobileAppOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyMobileAppOrderByField || (ShopifyMobileAppOrderByField = {}));
var ShopifyMobileAppFlowActionLogTestCustomerLogInOrderByField;
(function (ShopifyMobileAppFlowActionLogTestCustomerLogInOrderByField) {
    ShopifyMobileAppFlowActionLogTestCustomerLogInOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyMobileAppFlowActionLogTestCustomerLogInOrderByField || (ShopifyMobileAppFlowActionLogTestCustomerLogInOrderByField = {}));
var ShopifyMobileAppFlowActionLogTestCustomerSignUpOrderByField;
(function (ShopifyMobileAppFlowActionLogTestCustomerSignUpOrderByField) {
    ShopifyMobileAppFlowActionLogTestCustomerSignUpOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyMobileAppFlowActionLogTestCustomerSignUpOrderByField || (ShopifyMobileAppFlowActionLogTestCustomerSignUpOrderByField = {}));
var ShopifyMobileAppFlowActionLogSendPushNotificationOrderByField;
(function (ShopifyMobileAppFlowActionLogSendPushNotificationOrderByField) {
    ShopifyMobileAppFlowActionLogSendPushNotificationOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyMobileAppFlowActionLogSendPushNotificationOrderByField || (ShopifyMobileAppFlowActionLogSendPushNotificationOrderByField = {}));
var ShopifyOfflineStoreOrderByField;
(function (ShopifyOfflineStoreOrderByField) {
    ShopifyOfflineStoreOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyOfflineStoreOrderByField || (ShopifyOfflineStoreOrderByField = {}));
var ShopifyOfflineStoreAreaOrderByField;
(function (ShopifyOfflineStoreAreaOrderByField) {
    ShopifyOfflineStoreAreaOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyOfflineStoreAreaOrderByField || (ShopifyOfflineStoreAreaOrderByField = {}));
var ShopifyOfflineStoreBrandOrderByField;
(function (ShopifyOfflineStoreBrandOrderByField) {
    ShopifyOfflineStoreBrandOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyOfflineStoreBrandOrderByField || (ShopifyOfflineStoreBrandOrderByField = {}));
var ShopifyAcceptedCardBrand;
(function (ShopifyAcceptedCardBrand) {
    ShopifyAcceptedCardBrand["AmericanExpress"] = "AMERICAN_EXPRESS";
    ShopifyAcceptedCardBrand["DinersClub"] = "DINERS_CLUB";
    ShopifyAcceptedCardBrand["Discover"] = "DISCOVER";
    ShopifyAcceptedCardBrand["Jcb"] = "JCB";
    ShopifyAcceptedCardBrand["Mastercard"] = "MASTERCARD";
    ShopifyAcceptedCardBrand["Visa"] = "VISA";
})(ShopifyAcceptedCardBrand || (ShopifyAcceptedCardBrand = {}));
var ShopifyImageCropRegion;
(function (ShopifyImageCropRegion) {
    ShopifyImageCropRegion["Bottom"] = "BOTTOM";
    ShopifyImageCropRegion["Center"] = "CENTER";
    ShopifyImageCropRegion["Left"] = "LEFT";
    ShopifyImageCropRegion["Right"] = "RIGHT";
    ShopifyImageCropRegion["Top"] = "TOP";
})(ShopifyImageCropRegion || (ShopifyImageCropRegion = {}));
var ShopifyImageContentType;
(function (ShopifyImageContentType) {
    ShopifyImageContentType["Jpg"] = "JPG";
    ShopifyImageContentType["Png"] = "PNG";
    ShopifyImageContentType["Webp"] = "WEBP";
})(ShopifyImageContentType || (ShopifyImageContentType = {}));
var ShopifyProductBannerOrderByField;
(function (ShopifyProductBannerOrderByField) {
    ShopifyProductBannerOrderByField["CreatedAt"] = "CREATED_AT";
    ShopifyProductBannerOrderByField["Id"] = "ID";
    ShopifyProductBannerOrderByField["Position"] = "POSITION";
    ShopifyProductBannerOrderByField["Relevance"] = "RELEVANCE";
})(ShopifyProductBannerOrderByField || (ShopifyProductBannerOrderByField = {}));
var ShopifyProductOrderByField;
(function (ShopifyProductOrderByField) {
    ShopifyProductOrderByField["BestSelling"] = "BEST_SELLING";
    ShopifyProductOrderByField["CreatedAt"] = "CREATED_AT";
    ShopifyProductOrderByField["Id"] = "ID";
    ShopifyProductOrderByField["Price"] = "PRICE";
    ShopifyProductOrderByField["ProductType"] = "PRODUCT_TYPE";
    ShopifyProductOrderByField["Relevance"] = "RELEVANCE";
    ShopifyProductOrderByField["Title"] = "TITLE";
    ShopifyProductOrderByField["UpdatedAt"] = "UPDATED_AT";
    ShopifyProductOrderByField["Vendor"] = "VENDOR";
})(ShopifyProductOrderByField || (ShopifyProductOrderByField = {}));
var ShopifyProductVariantOrderByField;
(function (ShopifyProductVariantOrderByField) {
    ShopifyProductVariantOrderByField["Id"] = "ID";
    ShopifyProductVariantOrderByField["Position"] = "POSITION";
    ShopifyProductVariantOrderByField["Relevance"] = "RELEVANCE";
    ShopifyProductVariantOrderByField["Sku"] = "SKU";
    ShopifyProductVariantOrderByField["Title"] = "TITLE";
})(ShopifyProductVariantOrderByField || (ShopifyProductVariantOrderByField = {}));
var ShopifyRafflePaymentMethodKind;
(function (ShopifyRafflePaymentMethodKind) {
    ShopifyRafflePaymentMethodKind["OnlineStore"] = "ONLINE_STORE";
    ShopifyRafflePaymentMethodKind["OfflineStore"] = "OFFLINE_STORE";
})(ShopifyRafflePaymentMethodKind || (ShopifyRafflePaymentMethodKind = {}));
var ShopifyRafflePaymentMethodOfflineSettingPickupWindowStatus;
(function (ShopifyRafflePaymentMethodOfflineSettingPickupWindowStatus) {
    ShopifyRafflePaymentMethodOfflineSettingPickupWindowStatus["BeforeOpen"] = "BEFORE_OPEN";
    ShopifyRafflePaymentMethodOfflineSettingPickupWindowStatus["Open"] = "OPEN";
    ShopifyRafflePaymentMethodOfflineSettingPickupWindowStatus["Closed"] = "CLOSED";
})(ShopifyRafflePaymentMethodOfflineSettingPickupWindowStatus || (ShopifyRafflePaymentMethodOfflineSettingPickupWindowStatus = {}));
var ShopifyProductRaffleOrderByField;
(function (ShopifyProductRaffleOrderByField) {
    ShopifyProductRaffleOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyProductRaffleOrderByField || (ShopifyProductRaffleOrderByField = {}));
var ShopifyProductRaffleWindowStatus;
(function (ShopifyProductRaffleWindowStatus) {
    ShopifyProductRaffleWindowStatus["BeforeOpen"] = "BEFORE_OPEN";
    ShopifyProductRaffleWindowStatus["Open"] = "OPEN";
    ShopifyProductRaffleWindowStatus["Closed"] = "CLOSED";
})(ShopifyProductRaffleWindowStatus || (ShopifyProductRaffleWindowStatus = {}));
var ShopifyRaffleApplicantResult;
(function (ShopifyRaffleApplicantResult) {
    ShopifyRaffleApplicantResult["Winner"] = "WINNER";
    ShopifyRaffleApplicantResult["Unsettled"] = "UNSETTLED";
    ShopifyRaffleApplicantResult["Waiting"] = "WAITING";
    ShopifyRaffleApplicantResult["Loser"] = "LOSER";
})(ShopifyRaffleApplicantResult || (ShopifyRaffleApplicantResult = {}));
var ShopifyRaffleApplicantOrderByField;
(function (ShopifyRaffleApplicantOrderByField) {
    ShopifyRaffleApplicantOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyRaffleApplicantOrderByField || (ShopifyRaffleApplicantOrderByField = {}));
var ShopifyRaffleBannedCustomerOrderByField;
(function (ShopifyRaffleBannedCustomerOrderByField) {
    ShopifyRaffleBannedCustomerOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyRaffleBannedCustomerOrderByField || (ShopifyRaffleBannedCustomerOrderByField = {}));
var ShopifyReleasedDesignOrderByField;
(function (ShopifyReleasedDesignOrderByField) {
    ShopifyReleasedDesignOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyReleasedDesignOrderByField || (ShopifyReleasedDesignOrderByField = {}));
var ShopifyReleasedDesignBlockOrderByField;
(function (ShopifyReleasedDesignBlockOrderByField) {
    ShopifyReleasedDesignBlockOrderByField["Order"] = "ORDER";
})(ShopifyReleasedDesignBlockOrderByField || (ShopifyReleasedDesignBlockOrderByField = {}));
var ShopifyReleasedDesignCollectionGroupOrderByField;
(function (ShopifyReleasedDesignCollectionGroupOrderByField) {
    ShopifyReleasedDesignCollectionGroupOrderByField["Order"] = "ORDER";
})(ShopifyReleasedDesignCollectionGroupOrderByField || (ShopifyReleasedDesignCollectionGroupOrderByField = {}));
var ShopifySavedDesignBlockOrderByField;
(function (ShopifySavedDesignBlockOrderByField) {
    ShopifySavedDesignBlockOrderByField["Order"] = "ORDER";
})(ShopifySavedDesignBlockOrderByField || (ShopifySavedDesignBlockOrderByField = {}));
var ShopifySavedDesignCollectionGroupOrderByField;
(function (ShopifySavedDesignCollectionGroupOrderByField) {
    ShopifySavedDesignCollectionGroupOrderByField["Order"] = "ORDER";
})(ShopifySavedDesignCollectionGroupOrderByField || (ShopifySavedDesignCollectionGroupOrderByField = {}));
var ShopifySegmentCustomerInterestRuleOrderByField;
(function (ShopifySegmentCustomerInterestRuleOrderByField) {
    ShopifySegmentCustomerInterestRuleOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifySegmentCustomerInterestRuleOrderByField || (ShopifySegmentCustomerInterestRuleOrderByField = {}));
var ShopifySegmentCustomerInterestConditionOrderByField;
(function (ShopifySegmentCustomerInterestConditionOrderByField) {
    ShopifySegmentCustomerInterestConditionOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifySegmentCustomerInterestConditionOrderByField || (ShopifySegmentCustomerInterestConditionOrderByField = {}));
var ShopifySegmentCustomerInterestRulePushLogPushStatus;
(function (ShopifySegmentCustomerInterestRulePushLogPushStatus) {
    ShopifySegmentCustomerInterestRulePushLogPushStatus["Waiting"] = "WAITING";
    ShopifySegmentCustomerInterestRulePushLogPushStatus["AllPushUserLogsCreated"] = "ALL_PUSH_USER_LOGS_CREATED";
    ShopifySegmentCustomerInterestRulePushLogPushStatus["Completed"] = "COMPLETED";
})(ShopifySegmentCustomerInterestRulePushLogPushStatus || (ShopifySegmentCustomerInterestRulePushLogPushStatus = {}));
var ShopifyCheckoutCustomerAccountCondition;
(function (ShopifyCheckoutCustomerAccountCondition) {
    ShopifyCheckoutCustomerAccountCondition["Disabled"] = "DISABLED";
    ShopifyCheckoutCustomerAccountCondition["Optional"] = "OPTIONAL";
    ShopifyCheckoutCustomerAccountCondition["Required"] = "REQUIRED";
})(ShopifyCheckoutCustomerAccountCondition || (ShopifyCheckoutCustomerAccountCondition = {}));
var ShopifyVipAppOrderByField;
(function (ShopifyVipAppOrderByField) {
    ShopifyVipAppOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyVipAppOrderByField || (ShopifyVipAppOrderByField = {}));
var ShopifyVipAppCustomerOrderByField;
(function (ShopifyVipAppCustomerOrderByField) {
    ShopifyVipAppCustomerOrderByField["Id"] = "ID";
    ShopifyVipAppCustomerOrderByField["LastOrderDate"] = "LAST_ORDER_DATE";
    ShopifyVipAppCustomerOrderByField["Location"] = "LOCATION";
    ShopifyVipAppCustomerOrderByField["Name"] = "NAME";
    ShopifyVipAppCustomerOrderByField["OrdersCount"] = "ORDERS_COUNT";
    ShopifyVipAppCustomerOrderByField["Relevance"] = "RELEVANCE";
    ShopifyVipAppCustomerOrderByField["TotalSpent"] = "TOTAL_SPENT";
    ShopifyVipAppCustomerOrderByField["UpdatedAt"] = "UPDATED_AT";
})(ShopifyVipAppCustomerOrderByField || (ShopifyVipAppCustomerOrderByField = {}));
var ShopifyVipAppCustomerRankLogOrderByField;
(function (ShopifyVipAppCustomerRankLogOrderByField) {
    ShopifyVipAppCustomerRankLogOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyVipAppCustomerRankLogOrderByField || (ShopifyVipAppCustomerRankLogOrderByField = {}));
var ShopifyVipAppFlowActionLogAddPointOrderByField;
(function (ShopifyVipAppFlowActionLogAddPointOrderByField) {
    ShopifyVipAppFlowActionLogAddPointOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyVipAppFlowActionLogAddPointOrderByField || (ShopifyVipAppFlowActionLogAddPointOrderByField = {}));
var ShopifyVipAppFlowActionLogTestPointChangedOrderByField;
(function (ShopifyVipAppFlowActionLogTestPointChangedOrderByField) {
    ShopifyVipAppFlowActionLogTestPointChangedOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyVipAppFlowActionLogTestPointChangedOrderByField || (ShopifyVipAppFlowActionLogTestPointChangedOrderByField = {}));
var ShopifyVipAppFlowActionLogUsePointOrderByField;
(function (ShopifyVipAppFlowActionLogUsePointOrderByField) {
    ShopifyVipAppFlowActionLogUsePointOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyVipAppFlowActionLogUsePointOrderByField || (ShopifyVipAppFlowActionLogUsePointOrderByField = {}));
var ShopifyVipAppFlowTriggerLogPointChangedOrderByField;
(function (ShopifyVipAppFlowTriggerLogPointChangedOrderByField) {
    ShopifyVipAppFlowTriggerLogPointChangedOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyVipAppFlowTriggerLogPointChangedOrderByField || (ShopifyVipAppFlowTriggerLogPointChangedOrderByField = {}));
var ShopifyVipAppMinusMerchantPointOperationOrderByField;
(function (ShopifyVipAppMinusMerchantPointOperationOrderByField) {
    ShopifyVipAppMinusMerchantPointOperationOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyVipAppMinusMerchantPointOperationOrderByField || (ShopifyVipAppMinusMerchantPointOperationOrderByField = {}));
var ShopifyVipAppMinusMerchantPointOrderByField;
(function (ShopifyVipAppMinusMerchantPointOrderByField) {
    ShopifyVipAppMinusMerchantPointOrderByField["PointCreatedAt"] = "POINT_CREATED_AT";
})(ShopifyVipAppMinusMerchantPointOrderByField || (ShopifyVipAppMinusMerchantPointOrderByField = {}));
/**
 * OrderのWebhookのfulfillment_statusと一致している。
 * https://github.com/appify-technologies/appify-server/blob/7809930a33adb2cbba96261697c32ec7bb07f7c9/platform/domain/shopify_vip_app_order_webhook.go#L20
 */
var ShopifyFulfillmentStatusInput;
(function (ShopifyFulfillmentStatusInput) {
    ShopifyFulfillmentStatusInput["Fulfilled"] = "FULFILLED";
    ShopifyFulfillmentStatusInput["Null"] = "NULL";
    ShopifyFulfillmentStatusInput["Partial"] = "PARTIAL";
    ShopifyFulfillmentStatusInput["Restocked"] = "RESTOCKED";
})(ShopifyFulfillmentStatusInput || (ShopifyFulfillmentStatusInput = {}));
var ShopifyVipAppPointGiftCardOrderByField;
(function (ShopifyVipAppPointGiftCardOrderByField) {
    ShopifyVipAppPointGiftCardOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyVipAppPointGiftCardOrderByField || (ShopifyVipAppPointGiftCardOrderByField = {}));
var ShopifyVipAppPointAddOrderPendingLogOrderByField;
(function (ShopifyVipAppPointAddOrderPendingLogOrderByField) {
    ShopifyVipAppPointAddOrderPendingLogOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyVipAppPointAddOrderPendingLogOrderByField || (ShopifyVipAppPointAddOrderPendingLogOrderByField = {}));
var ShopifyVipAppPointLogOrderByField;
(function (ShopifyVipAppPointLogOrderByField) {
    ShopifyVipAppPointLogOrderByField["CreatedAt"] = "CREATED_AT";
})(ShopifyVipAppPointLogOrderByField || (ShopifyVipAppPointLogOrderByField = {}));
/** 会員ランクの算出方法 */
var ShopifyVipAppRankDecisionMethod;
(function (ShopifyVipAppRankDecisionMethod) {
    /** 獲得ポイント */
    ShopifyVipAppRankDecisionMethod["EarnedPoint"] = "EARNED_POINT";
    /** 購入金額 */
    ShopifyVipAppRankDecisionMethod["PurchasePrice"] = "PURCHASE_PRICE";
})(ShopifyVipAppRankDecisionMethod || (ShopifyVipAppRankDecisionMethod = {}));
var ShopifyVipAppRankRuleOrderByField;
(function (ShopifyVipAppRankRuleOrderByField) {
    ShopifyVipAppRankRuleOrderByField["Threshold"] = "THRESHOLD";
})(ShopifyVipAppRankRuleOrderByField || (ShopifyVipAppRankRuleOrderByField = {}));
var ShopifyVipAppRankRulePushLogPushStatus;
(function (ShopifyVipAppRankRulePushLogPushStatus) {
    ShopifyVipAppRankRulePushLogPushStatus["Waiting"] = "WAITING";
    ShopifyVipAppRankRulePushLogPushStatus["AllPushUserLogsCreated"] = "ALL_PUSH_USER_LOGS_CREATED";
    ShopifyVipAppRankRulePushLogPushStatus["Completed"] = "COMPLETED";
})(ShopifyVipAppRankRulePushLogPushStatus || (ShopifyVipAppRankRulePushLogPushStatus = {}));
/** Checkout時のポイント利用による値引き方法 */
var ShopifyVipAppUsePointCheckoutMethod;
(function (ShopifyVipAppUsePointCheckoutMethod) {
    /** DiscountCodeを発行してポイント消費による値引きに利用する */
    ShopifyVipAppUsePointCheckoutMethod["DiscountCode"] = "DISCOUNT_CODE";
    /** GiftCardを発行してポイント消費による値引きに利用する */
    ShopifyVipAppUsePointCheckoutMethod["GiftCard"] = "GIFT_CARD";
})(ShopifyVipAppUsePointCheckoutMethod || (ShopifyVipAppUsePointCheckoutMethod = {}));
var ShopifyVipAppTransferPointOrderByField;
(function (ShopifyVipAppTransferPointOrderByField) {
    ShopifyVipAppTransferPointOrderByField["CreatedAt"] = "CREATED_AT";
    ShopifyVipAppTransferPointOrderByField["PointCreatedAt"] = "POINT_CREATED_AT";
})(ShopifyVipAppTransferPointOrderByField || (ShopifyVipAppTransferPointOrderByField = {}));
var StripeSubscriptionStatus;
(function (StripeSubscriptionStatus) {
    StripeSubscriptionStatus["Active"] = "ACTIVE";
    StripeSubscriptionStatus["PastDue"] = "PAST_DUE";
    StripeSubscriptionStatus["Unpaid"] = "UNPAID";
    StripeSubscriptionStatus["Canceled"] = "CANCELED";
    StripeSubscriptionStatus["Incomplete"] = "INCOMPLETE";
    StripeSubscriptionStatus["IncompleteExpired"] = "INCOMPLETE_EXPIRED";
    StripeSubscriptionStatus["Trialing"] = "TRIALING";
})(StripeSubscriptionStatus || (StripeSubscriptionStatus = {}));
var StripeSubscriptionStatusParam;
(function (StripeSubscriptionStatusParam) {
    StripeSubscriptionStatusParam["Default"] = "DEFAULT";
    StripeSubscriptionStatusParam["Active"] = "ACTIVE";
    StripeSubscriptionStatusParam["PastDue"] = "PAST_DUE";
    StripeSubscriptionStatusParam["Unpaid"] = "UNPAID";
    StripeSubscriptionStatusParam["Canceled"] = "CANCELED";
    StripeSubscriptionStatusParam["Incomplete"] = "INCOMPLETE";
    StripeSubscriptionStatusParam["IncompleteExpired"] = "INCOMPLETE_EXPIRED";
    StripeSubscriptionStatusParam["Trialing"] = "TRIALING";
    StripeSubscriptionStatusParam["All"] = "ALL";
    StripeSubscriptionStatusParam["Ended"] = "ENDED";
})(StripeSubscriptionStatusParam || (StripeSubscriptionStatusParam = {}));
var UserOrderByField;
(function (UserOrderByField) {
    UserOrderByField["CreatedAt"] = "CREATED_AT";
})(UserOrderByField || (UserOrderByField = {}));
var Gender;
(function (Gender) {
    Gender["Invalid"] = "INVALID";
    Gender["Male"] = "MALE";
    Gender["Female"] = "FEMALE";
})(Gender || (Gender = {}));
var ShopifyMetafieldOwnerType;
(function (ShopifyMetafieldOwnerType) {
    ShopifyMetafieldOwnerType["Article"] = "ARTICLE";
    ShopifyMetafieldOwnerType["Blog"] = "BLOG";
    ShopifyMetafieldOwnerType["Collection"] = "COLLECTION";
    ShopifyMetafieldOwnerType["Customer"] = "CUSTOMER";
    ShopifyMetafieldOwnerType["Draftorder"] = "DRAFTORDER";
    ShopifyMetafieldOwnerType["Order"] = "ORDER";
    ShopifyMetafieldOwnerType["Page"] = "PAGE";
    ShopifyMetafieldOwnerType["Product"] = "PRODUCT";
    ShopifyMetafieldOwnerType["Productimage"] = "PRODUCTIMAGE";
    ShopifyMetafieldOwnerType["Productvariant"] = "PRODUCTVARIANT";
    ShopifyMetafieldOwnerType["Shop"] = "SHOP";
})(ShopifyMetafieldOwnerType || (ShopifyMetafieldOwnerType = {}));
var ShopifyVipAppPointChangedTopic;
(function (ShopifyVipAppPointChangedTopic) {
    ShopifyVipAppPointChangedTopic["PointsAddOrder"] = "POINTS_ADD_ORDER";
    ShopifyVipAppPointChangedTopic["PointsAddSignUp"] = "POINTS_ADD_SIGN_UP";
    ShopifyVipAppPointChangedTopic["PointsAddManual"] = "POINTS_ADD_MANUAL";
    ShopifyVipAppPointChangedTopic["PointsAddHold"] = "POINTS_ADD_HOLD";
    ShopifyVipAppPointChangedTopic["PointsAddCancel"] = "POINTS_ADD_CANCEL";
    ShopifyVipAppPointChangedTopic["PointsSubFlow"] = "POINTS_SUB_FLOW";
    ShopifyVipAppPointChangedTopic["PointsSubExpire"] = "POINTS_SUB_EXPIRE";
    ShopifyVipAppPointChangedTopic["PointsSubHold"] = "POINTS_SUB_HOLD";
    ShopifyVipAppPointChangedTopic["PointsSubRefund"] = "POINTS_SUB_REFUND";
    ShopifyVipAppPointChangedTopic["PointsSubManual"] = "POINTS_SUB_MANUAL";
    ShopifyVipAppPointChangedTopic["PointsSubCancel"] = "POINTS_SUB_CANCEL";
})(ShopifyVipAppPointChangedTopic || (ShopifyVipAppPointChangedTopic = {}));
const BaseItemFragmentDoc = (src_default()) `
    fragment BaseItem on BaseItem {
  id
  title
  imageURLs
}
    `;
const BaseItemPageInfoFragmentDoc = (src_default()) `
    fragment BaseItemPageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
const BaseDesignBlockBannerImgFragmentDoc = (src_default()) `
    fragment BaseDesignBlockBannerImg on ImageResource {
  id
  height
  width
  url
}
    `;
const BaseDesignBlockCategoryFragmentDoc = (src_default()) `
    fragment BaseDesignBlockCategory on BaseCategory {
  id
  name
}
    `;
const BaseDesignBlockCategoryItemFragmentDoc = (src_default()) `
    fragment BaseDesignBlockCategoryItem on BaseCategory {
  id
  items(first: 4) {
    nodes {
      id
      title
      imageURLs
    }
  }
}
    `;
const BaseDesignBlockFragmentDoc = (src_default()) `
    fragment BaseDesignBlock on BaseDesignBlock {
  __typename
  ... on BaseDesignBlockCategoryBanner {
    image {
      ...BaseDesignBlockBannerImg
    }
    category {
      ...BaseDesignBlockCategory
    }
  }
  ... on BaseDesignBlockItemBanner {
    image {
      ...BaseDesignBlockBannerImg
    }
    item {
      id
      title
    }
  }
  ... on BaseDesignBlockWebBanner {
    url
    image {
      ...BaseDesignBlockBannerImg
    }
  }
  ... on BaseDesignBlockCategoryItems {
    category {
      ...BaseDesignBlockCategoryItem
    }
  }
  ... on BaseDesignBlockCategoryItems2 {
    category {
      ...BaseDesignBlockCategoryItem
    }
  }
}
    ${BaseDesignBlockBannerImgFragmentDoc}
${BaseDesignBlockCategoryFragmentDoc}
${BaseDesignBlockCategoryItemFragmentDoc}`;
const SavedBaseDesignBlockNodeFragmentDoc = (src_default()) `
    fragment SavedBaseDesignBlockNode on BaseSavedDesignBlock {
  id
  order
  block {
    ...BaseDesignBlock
  }
}
    ${BaseDesignBlockFragmentDoc}`;
const BaseDesignBlockPageInfoFragmentDoc = (src_default()) `
    fragment BaseDesignBlockPageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
const AdminBaseNavigationMenuFragmentDoc = (src_default()) `
    fragment AdminBaseNavigationMenu on Application {
  id
  ios {
    id
    organizationName
  }
}
    `;
const BaseAnnouncementTextContentFragmentDoc = (src_default()) `
    fragment BaseAnnouncementTextContent on BaseAnnouncementTextContent {
  id
  message
  title
  createdAt
  updatedAt
}
    `;
const BaseAnnouncementMasterTextFragmentDoc = (src_default()) `
    fragment BaseAnnouncementMasterText on BaseAnnouncementMasterText {
  id
  content {
    ...BaseAnnouncementTextContent
  }
  publishTime
  createdAt
  updatedAt
}
    ${BaseAnnouncementTextContentFragmentDoc}`;
const BaseAnnouncementMasterFragmentDoc = (src_default()) `
    fragment BaseAnnouncementMaster on BaseAnnouncementMaster {
  __typename
  ... on BaseAnnouncementMasterText {
    ...BaseAnnouncementMasterText
  }
}
    ${BaseAnnouncementMasterTextFragmentDoc}`;
const BaseAnnouncementFragmentDoc = (src_default()) `
    fragment BaseAnnouncement on Application {
  id
  baseAppExtension {
    id
    base {
      id
      announcementMasters(first: 5, orderBy: {field: PUBLISH_TIME, direction: DESC}) {
        nodes {
          ...BaseAnnouncementMaster
        }
      }
    }
  }
}
    ${BaseAnnouncementMasterFragmentDoc}`;
const BaseSelectedDesignBlockItemFragmentDoc = (src_default()) `
    fragment BaseSelectedDesignBlockItem on BaseItem {
  id
  title
  price
  imageURLs
}
    `;
const BaseSelectedDesignBlockCategoryItemsFragmentDoc = (src_default()) `
    fragment BaseSelectedDesignBlockCategoryItems on BaseCategory {
  id
  name
  items(first: 4) {
    nodes {
      ...BaseSelectedDesignBlockItem
    }
  }
}
    ${BaseSelectedDesignBlockItemFragmentDoc}`;
const BaseSelectedDesignBlockCategoryItems2FragmentDoc = (src_default()) `
    fragment BaseSelectedDesignBlockCategoryItems2 on BaseCategory {
  id
  name
  items(first: 3) {
    nodes {
      ...BaseSelectedDesignBlockItem
    }
  }
}
    ${BaseSelectedDesignBlockItemFragmentDoc}`;
const UpdateAppStoreModalFragmentDoc = (src_default()) `
    fragment UpdateAppStoreModal on IOS {
  id
  appStoreTitle
  appStoreSubTitle
  appStoreDescription
  appStoreKeywords
  appStoreMarketingURL
  appStorePrimaryCategory
  appStoreSecondaryCategory
  appStoreAdminEmail
  appStoreAdminPhoneNumber
  appStoreAdminFirstName
  appStoreAdminLastName
  existAllAppStoreInfo
  releaseVersion
}
    `;
const UpdateGooglePlayStoreModalFragmentDoc = (src_default()) `
    fragment UpdateGooglePlayStoreModal on Android {
  id
  googlePlayStoreAppName
  googlePlayStoreShortDescription
  googlePlayStoreDescription
  googlePlayStoreEmail
  googlePlayStorePhoneNumber
  existAllGooglePlayStoreInfo
  releaseVersion
}
    `;
const PushLogFragmentDoc = (src_default()) `
    fragment PushLog on PushLog {
  id
  pushMessage
  pushStatus
  execTime
}
    `;
const ShopifyCollectionPageInfoFragmentDoc = (src_default()) `
    fragment ShopifyCollectionPageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
const ShopifyProductPageInfoFragmentDoc = (src_default()) `
    fragment ShopifyProductPageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
const ShopifyAddonChannelTalkSettingFragmentDoc = (src_default()) `
    fragment ShopifyAddonChannelTalkSetting on ShopifyChannelTalkAddonSetting {
  id
  isActivated
  pluginKey
}
    `;
const ShopifySignUpBonusCouponAddonSettingStatusFragmentDoc = (src_default()) `
    fragment ShopifySignUpBonusCouponAddonSettingStatus on ShopifySignUpBonusAddon {
  id
  setting {
    id
    isEnabled
  }
}
    `;
const ShopifySignUpBonusCouponAddonSettingFormFragmentDoc = (src_default()) `
    fragment ShopifySignUpBonusCouponAddonSettingForm on ShopifySignUpBonusAddon {
  id
  couponSetting {
    id
    couponTitle
    discountAmount
    discountPercentage
    discountType
    expirationDateCount
    minimumRequirementAmount
  }
}
    `;
const ShopifyDesignBlockPageInfoFragmentDoc = (src_default()) `
    fragment ShopifyDesignBlockPageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
const ShopifyCollectionGroupPageInfoFragmentDoc = (src_default()) `
    fragment ShopifyCollectionGroupPageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
const ShopifyDesignBlockFragmentDoc = (src_default()) `
    fragment ShopifyDesignBlock on ShopifyDesignBlock {
  ... on ShopifyDesignBlockProductBanner {
    kind
    image {
      height
      width
      url
    }
    product {
      id
      productAdminAPIID
    }
    startDate
    endDate
  }
  ... on ShopifyDesignBlockCollectionBanner {
    kind
    image {
      url
      width
      height
    }
    collection {
      id
      collectionAdminAPIID
    }
    startDate
    endDate
  }
  ... on ShopifyDesignBlockWebBanner {
    kind
    image {
      height
      width
      url
    }
    url
    isOpenExternalBrowser
    startDate
    endDate
  }
  ... on ShopifyDesignBlockPageBanner {
    kind
    image {
      height
      width
      url
    }
    pageKind
    startDate
    endDate
  }
  ... on ShopifyDesignBlockPlainBanner {
    kind
    image {
      height
      width
      url
    }
    startDate
    endDate
  }
  ... on ShopifyDesignBlockCollections {
    kind
    title
    showsTitle
    collections {
      nodes {
        id
        collectionAdminAPIID
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ... on ShopifyDesignBlockCollections2 {
    kind
    showsTitle
    collections {
      nodes {
        id
        collectionAdminAPIID
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ... on ShopifyDesignBlockCollectionProducts {
    kind
    collection {
      id
      collectionAdminAPIID
    }
  }
  ... on ShopifyDesignBlockCollectionProducts2 {
    kind
    collection {
      id
      collectionAdminAPIID
    }
  }
}
    `;
const SavedShopifyDesignBlockNodeFragmentDoc = (src_default()) `
    fragment SavedShopifyDesignBlockNode on ShopifySavedDesignBlock {
  id
  order
  block {
    ...ShopifyDesignBlock
  }
}
    ${ShopifyDesignBlockFragmentDoc}`;
const SavedShopifyDesignCollectionGroupNodeFragmentDoc = (src_default()) `
    fragment SavedShopifyDesignCollectionGroupNode on ShopifySavedDesignCollectionGroupValue {
  ... on ShopifySavedDesignCollectionGroupValueCollection {
    id
    collection {
      id
      collectionAdminAPIID
      title
    }
  }
  ... on ShopifySavedDesignCollectionGroupValueGroup {
    id
    name
    subgroups {
      nodes {
        id
        value {
          ... on ShopifySavedDesignCollectionGroupValueCollection {
            id
            collection {
              id
              collectionAdminAPIID
              title
            }
          }
          ... on ShopifySavedDesignCollectionGroupValueGroup {
            id
            name
            subgroups {
              nodes {
                id
                value {
                  ... on ShopifySavedDesignCollectionGroupValueCollection {
                    id
                    collection {
                      id
                      collectionAdminAPIID
                      title
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
const ShopifyStopCouponDeliveryRuleModalFragmentDoc = (src_default()) `
    fragment ShopifyStopCouponDeliveryRuleModal on ShopifyCustomerCouponMerchantDeliveryRule {
  id
  couponTitle
  endsAt
  startsAt
  status
}
    `;
const ShopifyAddonModalFragmentDoc = (src_default()) `
    fragment ShopifyAddonModal on ShopifyAddonMaster {
  id
  addonType
  name
  detailLinkURL
  shortDescription
  featureDescriptions
  installed
  isPaidService
  logoImage {
    id
    url
  }
}
    `;
const ShopifyAddonRaffleCreateModal_ShopifyAdminProductFragmentDoc = (src_default()) `
    fragment ShopifyAddonRaffleCreateModal_ShopifyAdminProduct on ShopifyAdminProduct {
  id
  title
  description
  priceRange {
    minVariantPrice {
      currencyCode
      amount
    }
    maxVariantPrice {
      currencyCode
      amount
    }
  }
  image {
    originalSrc
  }
}
    `;
const ExecuteShopifyRaffleTaskButtonFragmentDoc = (src_default()) `
    fragment ExecuteShopifyRaffleTaskButton on ShopifyProductRaffle {
  id
  isExecuted
  windowStatus
}
    `;
const EditShopifyStyle_ApplicationFragmentDoc = (src_default()) `
    fragment EditShopifyStyle_Application on Application {
  id
  mobileApp {
    id
    shopify {
      id
      design {
        id
        style {
          id
          productImageRatio
          color {
            primaryColor
          }
          isDisplayComparedAtPrice
        }
      }
    }
  }
}
    `;
const UpdateAppAssets_ApplicationFragmentDoc = (src_default()) `
    fragment UpdateAppAssets_Application on Application {
  id
  appAsset {
    id
    iconImageURL
    launchScreenImageURL
    appLogoURL
  }
}
    `;
const ShopifySelectedDesignBlockCollectionFragmentDoc = (src_default()) `
    fragment ShopifySelectedDesignBlockCollection on ShopifyCollection {
  id
  title
  collectionAdminAPIID
  image {
    transformedSrc
  }
}
    `;
const ShopifySelectedDesignBlockProductFragmentDoc = (src_default()) `
    fragment ShopifySelectedDesignBlockProduct on ShopifyProduct {
  id
  title
  images(first: 1) {
    nodes {
      transformedSrc
    }
  }
}
    `;
const ShopifySelectedDesignBlockCollectionProductPreviewProductFragmentDoc = (src_default()) `
    fragment ShopifySelectedDesignBlockCollectionProductPreviewProduct on ShopifyProduct {
  id
  images(first: 1, maxWidth: 498, maxHeight: 498) {
    nodes {
      transformedSrc
    }
  }
  title
  priceRange {
    minVariantPrice {
      amount
    }
  }
}
    `;
const ShopifySelectedDesignBlockCollectionProductFragmentDoc = (src_default()) `
    fragment ShopifySelectedDesignBlockCollectionProduct on ShopifyCollection {
  id
  title
  collectionAdminAPIID
  products(first: 4) {
    nodes {
      ...ShopifySelectedDesignBlockCollectionProductPreviewProduct
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionProductPreviewProductFragmentDoc}`;
const ShopifySelectedDesignBlockCollectionProductPreviewProduct2FragmentDoc = (src_default()) `
    fragment ShopifySelectedDesignBlockCollectionProductPreviewProduct2 on ShopifyProduct {
  id
  images(first: 1, maxWidth: 420, maxHeight: 420) {
    nodes {
      transformedSrc
    }
  }
  title
  priceRange {
    minVariantPrice {
      amount
    }
  }
}
    `;
const ShopifySelectedDesignBlockCollectionProduct2FragmentDoc = (src_default()) `
    fragment ShopifySelectedDesignBlockCollectionProduct2 on ShopifyCollection {
  id
  title
  collectionAdminAPIID
  products(first: 3) {
    nodes {
      ...ShopifySelectedDesignBlockCollectionProductPreviewProduct2
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionProductPreviewProduct2FragmentDoc}`;
const ShopifyAnnouncementMasterTextFragmentDoc = (src_default()) `
    fragment ShopifyAnnouncementMasterText on ShopifyAnnouncementMasterText {
  id
  content {
    id
    message
    title
  }
  publishTime
}
    `;
const ShopifyAnouncementMasterUrlFragmentDoc = (src_default()) `
    fragment ShopifyAnouncementMasterUrl on ShopifyAnnouncementMasterURL {
  id
  content {
    id
    title
    url
  }
  publishTime
}
    `;
const ShopifyMarketingPushNotificationFragmentDoc = (src_default()) `
    fragment ShopifyMarketingPushNotification on PushLog {
  id
  pushMessage
  pushStatus
  execTime
}
    `;
const ShopifyCheckoutCustomerAccountConditionSettingFragmentDoc = (src_default()) `
    fragment ShopifyCheckoutCustomerAccountConditionSetting on ShopifySetting {
  id
  checkoutCustomerAccountCondition
}
    `;
const ShopifyApplicationMemberSettingFragmentDoc = (src_default()) `
    fragment ShopifyApplicationMemberSetting on Application {
  id
  members {
    nodes {
      id
      admin {
        id
        privacy {
          id
          name
        }
      }
    }
  }
  memberInvitations {
    nodes {
      id
      email
    }
  }
}
    `;
const ShopifySettingAccountFragmentDoc = (src_default()) `
    fragment ShopifySettingAccount on Admin {
  id
  privacy {
    id
    email
    name
  }
}
    `;
const ShopifyVipAppPointProgramPointAddRuleOrderUpdateFormFragmentDoc = (src_default()) `
    fragment ShopifyVIPAppPointProgramPointAddRuleOrderUpdateForm on ShopifyVIPApp {
  id
  pointAddRuleOrder {
    id
    title
    isEnabled
    basePoint
    basePrice
    minimumRequirementSubtotal
    rankRuleMultiples {
      rankRule {
        id
        name
      }
      multiple
    }
    expiresIn
  }
}
    `;
const ShopifyVipAppPointProgramPointAddRuleSignUpUpdateFormFragmentDoc = (src_default()) `
    fragment ShopifyVIPAppPointProgramPointAddRuleSignUpUpdateForm on ShopifyVIPAppPointAddRuleSignUp {
  id
  title
  isEnabled
  point
  expiresIn
}
    `;
const ShopifyVipAppRankProgramEditFormFragmentDoc = (src_default()) `
    fragment ShopifyVIPAppRankProgramEditForm on ShopifyVIPAppRankRule {
  id
  isFixedRankRule
  name
  threshold
}
    `;
const ShopifyVipAppRankListFragmentDoc = (src_default()) `
    fragment ShopifyVIPAppRankList on ShopifyVIPApp {
  id
  rank {
    id
    rules(first: 10) {
      nodes {
        id
        name
        threshold
      }
    }
    rankDecisionSetting {
      id
      rankDecisionMethod
    }
  }
}
    `;
const ShopifyVipAppSettingMetafieldsSyncSectionFragmentDoc = (src_default()) `
    fragment ShopifyVIPAppSettingMetafieldsSyncSection on ShopifyVIPApp {
  id
  canStartShopifyMetafieldsSyncForAllCustomers
  isRunningShopifyMetafieldsSyncForAllCustomers
}
    `;
const ShopifyVipAppSettingMemberSectionFragmentDoc = (src_default()) `
    fragment ShopifyVIPAppSettingMemberSection on ShopifyVIPApp {
  id
  application {
    id
    members {
      nodes {
        id
        admin {
          id
          privacy {
            id
            name
          }
        }
      }
    }
    memberInvitations {
      nodes {
        id
        email
      }
    }
  }
}
    `;
const ShopifyVipAppSettingAccountFragmentDoc = (src_default()) `
    fragment ShopifyVIPAppSettingAccount on Admin {
  id
  privacy {
    id
    email
    name
  }
}
    `;
const ApplicationMobileDataTableFragmentDoc = (src_default()) `
    fragment ApplicationMobileDataTable on ShopifyMobileAppConnection {
  nodes {
    id
    application {
      id
      name
      displayName
      ios {
        id
        releaseVersion
        inReviewVersion
      }
      android {
        id
        releaseVersion
        inReviewVersion
      }
      appAsset {
        id
        iconImageURL
      }
    }
    activeAppSubscription {
      id
      price
    }
    annualSales {
      id
      sales {
        amount
      }
    }
    subscriptionPricing {
      id
      price
    }
  }
}
    `;
const ApplicationMobileDetailApplicationFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailApplication on Application {
  id
  name
  firebaseProject
  tenantID
  mobileApp {
    id
    shopOrigin
  }
}
    `;
const ApplicationMobileDetailMobileAppFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailMobileApp on Application {
  id
  ios {
    id
    inReviewVersion
    releaseVersion
  }
  android {
    id
    inReviewVersion
    releaseVersion
  }
}
    `;
const ApplicationMobileDetailAnalyticsFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailAnalytics on Application {
  id
  monthlyUser: statKindDiff(kindName: "User", base: $start, compare: $end) {
    count: diffCount
  }
  totalUser: statKind(kindName: "User", date: $end) {
    id
    count: totalCount
  }
  mobileApp {
    id
    shopify {
      id
      monthlySales: sales(start: $start, end: $end) {
        amount
      }
      totalSales: sales(end: $end) {
        amount
      }
    }
  }
}
    `;
const ApplicationMobileSubscriptionPricingFragmentDoc = (src_default()) `
    fragment ApplicationMobileSubscriptionPricing on Application {
  id
  mobileApp {
    id
    activeAppSubscription {
      id
      price
    }
    subscriptionPricing {
      id
      price
      startDate
    }
  }
}
    `;
const ApplicationMobileDetailAssetFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailAsset on Application {
  id
  appAsset {
    id
    iconImageURL
    launchScreenImageURL
  }
}
    `;
const ApplicationMobileDetailAppsFlyerFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailAppsFlyer on Application {
  id
  mobileApp {
    id
    shopify {
      id
      appsflyerAddon {
        id
        setting {
          id
          isActivated
        }
      }
    }
  }
}
    `;
const ApplicationMobileDetailChannelTalkFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailChannelTalk on Application {
  id
  mobileApp {
    id
    shopify {
      id
      channelTalkAddon {
        id
        setting {
          id
          isActivated
          pluginKey
        }
      }
    }
  }
}
    `;
const ApplicationMobileDetailMemberFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailMember on Application {
  id
  members(first: 100) {
    nodes {
      id
      admin {
        id
        privacy {
          id
          email
        }
      }
    }
  }
}
    `;
const ApplicationMobileDetailFirebaseProjectFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailFirebaseProject on Application {
  id
  firebaseProject
}
    `;
const ApplicationMobileDetailTestPushNotificationFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailTestPushNotification on Application {
  id
  ios {
    id
    releaseVersion
  }
  android {
    id
    releaseVersion
  }
}
    `;
const ApplicationMobileDetailAppleIosFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailAppleIos on IOS {
  id
  organizationName
  teamID
  bundleIdentifier
  appleStoreID
  releaseVersion
  inReviewVersion
}
    `;
const ApplicationMobileDetailAppleFirebaseFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailAppleFirebase on IOS {
  id
  firebaseIOSConfig {
    id
    projectID
    clientID
    apiKey
    gcmSenderID
    googleAPPID
  }
}
    `;
const ApplicationMobileDetailAppleAppStoreFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailAppleAppStore on IOS {
  id
  appStoreTitle
  appStoreSubTitle
  appStoreDescription
  appStorePrimaryCategory
  appStoreSecondaryCategory
  appStoreKeywords
  appStoreMarketingURL
  appStoreAdminFirstName
  appStoreAdminLastName
  appStoreAdminEmail
  appStoreAdminPhoneNumber
}
    `;
const ApplicationMobileDetailAppleUpdateIosModalFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailAppleUpdateIosModal on IOS {
  id
  organizationName
  teamID
  appleStoreID
}
    `;
const ApplicationMobileDetailGoogleAndroidFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailGoogleAndroid on Android {
  id
  packageName
  googlePlayConsoleURL
  inReviewVersion
  releaseVersion
}
    `;
const ApplicationMobileDetailGoogleFirebaseFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailGoogleFirebase on Android {
  id
  firebaseAndroidConfig {
    id
    projectID
    mobileSDKAppID
  }
}
    `;
const ApplicationMobileDetailGooglePlayStoreFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailGooglePlayStore on Android {
  id
  googlePlayStoreAppName
  googlePlayStoreShortDescription
  googlePlayStoreDescription
  googlePlayStoreEmail
  googlePlayStorePhoneNumber
}
    `;
const ApplicationMobileDetailGoogleUpdateAndroidModalFragmentDoc = (src_default()) `
    fragment ApplicationMobileDetailGoogleUpdateAndroidModal on Android {
  id
  developerAccountID
}
    `;
const ApplicationVipDataTableFragmentDoc = (src_default()) `
    fragment ApplicationVIPDataTable on ShopifyVIPAppConnection {
  nodes {
    id
    application {
      id
      displayName
    }
    activeAppSubscription {
      id
      price
    }
    subscriptionPricing {
      id
      price
    }
  }
}
    `;
const ApplicationVipDetailApplicationFragmentDoc = (src_default()) `
    fragment ApplicationVIPDetailApplication on Application {
  id
  vipApp {
    id
    shopOrigin
  }
}
    `;
const ApplicationVipDetailSubscriptionPricingFragmentDoc = (src_default()) `
    fragment ApplicationVIPDetailSubscriptionPricing on Application {
  id
  vipApp {
    id
    activeAppSubscription {
      id
      price
    }
    subscriptionPricing {
      id
      price
      startDate
    }
  }
}
    `;
const ApplicationVipDetailMemberFragmentDoc = (src_default()) `
    fragment ApplicationVIPDetailMember on Application {
  id
  members(first: 100) {
    nodes {
      id
      admin {
        id
        privacy {
          id
          email
        }
      }
    }
  }
}
    `;
const SettingLatestAppVersionsFragmentDoc = (src_default()) `
    fragment SettingLatestAppVersions on App {
  id
  iOS {
    id
    latestVersion
  }
  android {
    id
    latestVersion
  }
}
    `;
const IdentityPlatformTokenFragmentDoc = (src_default()) `
    fragment IdentityPlatformToken on IdentityPlatformToken {
  email
  expiresIn
  idToken
  refreshToken
}
    `;
const PendingPointLogFragmentDoc = (src_default()) `
    fragment PendingPointLog on ShopifyVIPAppPointAddOrderPendingLog {
  id
  point
  title
  name
  createdAt
  availableAt
}
    `;
const PointLogFragmentDoc = (src_default()) `
    fragment PointLog on ShopifyVIPAppPointLog {
  id
  point
  title
  createdAt
  expiredAt
  isExpired
}
    `;
const BaseItemsDocument = (src_default()) `
    query BaseItems($applicationID: ID!, $after: String) {
  application(id: $applicationID) {
    id
    baseAppExtension {
      id
      base {
        id
        items(first: 20, after: $after) {
          nodes {
            ...BaseItem
          }
          pageInfo {
            ...BaseItemPageInfo
          }
        }
      }
    }
  }
}
    ${BaseItemFragmentDoc}
${BaseItemPageInfoFragmentDoc}`;
const UseBaseRedirectUrlDocument = (src_default()) `
    query UseBaseRedirectURL($applicationID: ID!) {
  application(id: $applicationID) {
    id
    baseAppExtension {
      id
      base {
        id
        token {
          accessToken
        }
      }
    }
    stripeCustomer {
      id
      activeSubscription {
        id
        baseStandardPlan {
          id
        }
      }
    }
  }
}
    `;
const BaseDesignPageDocument = (src_default()) `
    query BaseDesignPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    appAsset {
      id
      appLogoURL
    }
    ios {
      id
      releaseVersion
      inReviewVersion
    }
    baseAppExtension {
      id
      base {
        id
        design {
          id
          saved {
            id
            blocks {
              nodes {
                ...SavedBaseDesignBlockNode
              }
              pageInfo {
                ...BaseItemPageInfo
              }
            }
          }
          theme {
            id
            saved {
              id
              appLogoURL
              color {
                primaryColor
              }
            }
          }
        }
      }
    }
  }
}
    ${SavedBaseDesignBlockNodeFragmentDoc}
${BaseItemPageInfoFragmentDoc}`;
const UpdateBaseTokenDocument = (src_default()) `
    mutation UpdateBaseToken($input: UpdateBaseTokenInput!) {
  updateBaseToken(input: $input) {
    base {
      id
      token {
        refreshToken
        expiresIn
        accessToken
        tokenType
      }
    }
  }
}
    `;
const AdminBaseNavigationMenuDocument = (src_default()) `
    query AdminBaseNavigationMenu($applicationID: ID!) {
  application(id: $applicationID) {
    ...AdminBaseNavigationMenu
  }
}
    ${AdminBaseNavigationMenuFragmentDoc}`;
const BaseAnnouncementDocument = (src_default()) `
    query BaseAnnouncement($applicationID: ID!) {
  application(id: $applicationID) {
    ...BaseAnnouncement
  }
}
    ${BaseAnnouncementFragmentDoc}`;
const CreateBaseAnnouncementDocument = (src_default()) `
    mutation CreateBaseAnnouncement($input: CreateBaseAnnouncementInput!) {
  createBaseAnnouncement(input: $input) {
    baseAnnouncementMaster {
      ...BaseAnnouncementMaster
    }
  }
}
    ${BaseAnnouncementMasterFragmentDoc}`;
const CreateBaseAnnouncementAndSendPushNotificationDocument = (src_default()) `
    mutation CreateBaseAnnouncementAndSendPushNotification($announcementInput: CreateBaseAnnouncementInput!, $pushNotificationInput: SendPushNotificationInput!) {
  createBaseAnnouncement(input: $announcementInput) {
    baseAnnouncementMaster {
      ...BaseAnnouncementMaster
    }
  }
  sendPushNotification(input: $pushNotificationInput) {
    pushLog {
      id
      pushMessage
      pushStatus
      execTime
    }
  }
}
    ${BaseAnnouncementMasterFragmentDoc}`;
const BaseDashboardDocument = (src_default()) `
    query BaseDashboard($id: ID!, $start: Date!, $end: Date!) {
  application(id: $id) {
    id
    monthlyUser: statKindDiff(kindName: "User", base: $start, compare: $end) {
      kindName
      count: diffCount
      rate: diffRatePercent
    }
    totalUser: statKind(kindName: "User", date: $end) {
      id
      kindName
      count: totalCount
      createdAt
    }
    monthlyOrder: statKindDiff(
      kindName: "BasePurchaseLog"
      base: $start
      compare: $end
    ) {
      kindName
      count: diffCount
      rate: diffRatePercent
    }
    totalOrder: statKind(kindName: "BasePurchaseLog", date: $end) {
      id
      kindName
      count: totalCount
      createdAt
    }
    baseAppExtension {
      id
      base {
        id
        monthSales: sales(start: $start, end: $end) {
          amount
          start
          end
        }
        totalSales: sales(end: $end) {
          amount
          start
          end
        }
      }
    }
  }
}
    `;
const BaseCategoriesDocument = (src_default()) `
    query BaseCategories($applicationID: ID!) {
  application(id: $applicationID) {
    id
    baseAppExtension {
      id
      base {
        id
        allCategories {
          id
          name
        }
      }
    }
  }
}
    `;
const SaveBaseDesignDocument = (src_default()) `
    mutation SaveBaseDesign($applicationID: ID!, $blocks: [UpdateBaseDesignBlock!]!, $updateAppLogo: UpdateBaseDesignThemeAppLogoInput, $updateColor: UpdateBaseDesignThemeColorInput) {
  updateBaseDesignBlocks(input: {applicationID: $applicationID, blocks: $blocks}) {
    baseSavedDesign {
      id
      blocks {
        nodes {
          ...SavedBaseDesignBlockNode
        }
        pageInfo {
          ...BaseDesignBlockPageInfo
        }
      }
    }
  }
  updateBaseDesignTheme(
    input: {applicationID: $applicationID, updateAppLogo: $updateAppLogo, updateColor: $updateColor}
  ) {
    baseSavedDesignTheme {
      id
      appLogoURL
      color {
        primaryColor
      }
    }
  }
}
    ${SavedBaseDesignBlockNodeFragmentDoc}
${BaseDesignBlockPageInfoFragmentDoc}`;
const ReleaseBaseDesignDocument = (src_default()) `
    mutation ReleaseBaseDesign($applicationID: ID!) {
  releaseBaseDesignBlocks(input: {applicationID: $applicationID}) {
    baseReleasedDesign {
      id
      blocks {
        nodes {
          id
          order
          block {
            ...BaseDesignBlock
          }
        }
        pageInfo {
          ...BaseDesignBlockPageInfo
        }
      }
    }
  }
  releaseBaseDesignTheme(input: {applicationID: $applicationID}) {
    baseReleasedDesignTheme {
      id
      appLogoURL
      color {
        primaryColor
      }
    }
  }
}
    ${BaseDesignBlockFragmentDoc}
${BaseDesignBlockPageInfoFragmentDoc}`;
const BaseSelectedDesignBlockCategoryItemsDocument = (src_default()) `
    query BaseSelectedDesignBlockCategoryItems($id: ID!) {
  category: node(id: $id) {
    ... on BaseCategory {
      ...BaseSelectedDesignBlockCategoryItems
    }
  }
}
    ${BaseSelectedDesignBlockCategoryItemsFragmentDoc}`;
const BaseSelectedDesignBlockCategoryItems2Document = (src_default()) `
    query BaseSelectedDesignBlockCategoryItems2($id: ID!) {
  category: node(id: $id) {
    ... on BaseCategory {
      ...BaseSelectedDesignBlockCategoryItems2
    }
  }
}
    ${BaseSelectedDesignBlockCategoryItems2FragmentDoc}`;
const BasePushNotificationsDocument = (src_default()) `
    query BasePushNotifications($applicationID: ID!) {
  application(id: $applicationID) {
    id
    pushLogs(first: 20, orderBy: {direction: DESC, field: CREATED_AT}) {
      nodes {
        ...PushLog
      }
    }
  }
}
    ${PushLogFragmentDoc}`;
const BaseSendPushNotificationDocument = (src_default()) `
    mutation BaseSendPushNotification($input: SendPushNotificationInput!) {
  sendPushNotification(input: $input) {
    pushLog {
      ...PushLog
    }
  }
}
    ${PushLogFragmentDoc}`;
const CreateStripeCheckoutSessionForBaseStandardPlanDocument = (src_default()) `
    mutation CreateStripeCheckoutSessionForBaseStandardPlan($input: CreateStripeCheckoutSessionForBaseStandardPlanInput!) {
  createStripeCheckoutSessionForBaseStandardPlan(input: $input) {
    id
  }
}
    `;
const FallbackPageTopBarDocument = (src_default()) `
    query FallbackPageTopBar {
  adminViewer {
    id
    privacy {
      id
      name
    }
  }
}
    `;
const AcceptApplicationMemberInvitationDocument = (src_default()) `
    mutation AcceptApplicationMemberInvitation($input: AcceptApplicationMemberInvitationInput!) {
  acceptApplicationMemberInvitation(input: $input) {
    application {
      id
    }
  }
}
    `;
const LoggedInRootDocument = (src_default()) `
    query LoggedInRoot {
  adminViewer {
    id
    appExtensions(first: 1) {
      __typename
      nodes {
        ... on BaseAppExtension {
          id
          application {
            id
          }
        }
        ... on ShopifyAppExtension {
          id
          application {
            id
          }
        }
        ... on CampfireCommunityAppExtension {
          id
          application {
            id
          }
        }
      }
    }
  }
}
    `;
const AccountMenuDocument = (src_default()) `
    query AccountMenu {
  adminViewer {
    id
    privacy {
      id
      name
    }
  }
}
    `;
const AppAssetIconImageUploaderDocument = (src_default()) `
    query AppAssetIconImageUploader($applicationID: ID!) {
  application(id: $applicationID) {
    id
    appAsset {
      id
      iconImageURL
    }
  }
}
    `;
const UpdateAppAssetIconDocument = (src_default()) `
    mutation UpdateAppAssetIcon($input: UpdateAppAssetIconInput!) {
  updateAppAssetIcon(input: $input) {
    application {
      id
      appAsset {
        id
        iconImageURL
      }
    }
  }
}
    `;
const AppAssetLaunchScreenImageUploaderDocument = (src_default()) `
    query AppAssetLaunchScreenImageUploader($applicationID: ID!) {
  application(id: $applicationID) {
    id
    appAsset {
      id
      launchScreenImageURL
    }
  }
}
    `;
const UpdateAppAssetLaunchScreenDocument = (src_default()) `
    mutation UpdateAppAssetLaunchScreen($input: UpdateAppAssetLaunchScreenInput!) {
  updateAppAssetLaunchScreen(input: $input) {
    application {
      id
      appAsset {
        id
        launchScreenImageURL
      }
    }
  }
}
    `;
const UpdateAppStoreDocument = (src_default()) `
    mutation UpdateAppStore($input: UpdateAppStoreInput!) {
  updateAppStore(input: $input) {
    application {
      id
      ios {
        id
        appStoreTitle
        appStoreSubTitle
        appStoreDescription
        appStoreKeywords
        appStoreMarketingURL
        appStorePrimaryCategory
        appStoreSecondaryCategory
        appStoreAdminEmail
        appStoreAdminPhoneNumber
        appStoreAdminFirstName
        appStoreAdminLastName
        existAllAppStoreInfo
      }
    }
  }
}
    `;
const AppifyChannelTalkDocument = (src_default()) `
    query AppifyChannelTalk {
  adminViewer {
    id
    privacy {
      id
      email
      name
    }
  }
}
    `;
const ApplicationSelectorDocument = (src_default()) `
    query ApplicationSelector {
  adminViewer {
    id
    privacy {
      id
      name
    }
    applications {
      nodes {
        id
        displayName
        appExtension {
          __typename
        }
      }
    }
  }
}
    `;
const UpdateGooglePlayStoreDocument = (src_default()) `
    mutation UpdateGooglePlayStore($input: UpdateGooglePlayStoreInput!) {
  updateGooglePlayStore(input: $input) {
    application {
      id
      android {
        id
        googlePlayStoreAppName
        googlePlayStoreShortDescription
        googlePlayStoreDescription
        googlePlayStoreEmail
        googlePlayStorePhoneNumber
        existAllGooglePlayStoreInfo
      }
    }
  }
}
    `;
const PushNotificationsDocument = (src_default()) `
    query PushNotifications($applicationID: ID!) {
  application(id: $applicationID) {
    id
    pushLogs(first: 20, orderBy: {direction: DESC, field: CREATED_AT}) {
      nodes {
        ...PushLog
      }
    }
  }
}
    ${PushLogFragmentDoc}`;
const CancelPushNotificationDocument = (src_default()) `
    mutation CancelPushNotification($input: CancelPushNotificationInput!) {
  cancelPushNotification(input: $input) {
    success
  }
}
    `;
const CreditCardSettingDocument = (src_default()) `
    query CreditCardSetting($applicationID: ID!) {
  application(id: $applicationID) {
    id
    stripeCustomer {
      id
      defaultPaymentMethod {
        id
        card {
          id
          brand
          last4
          expMonth
          expYear
          country
          createdAt
        }
      }
    }
  }
}
    `;
const CreateStripeCustomerPortalSessionDocument = (src_default()) `
    mutation CreateStripeCustomerPortalSession($input: CreateStripeCustomerPortalSessionInput!) {
  createStripeCustomerPortalSession(input: $input) {
    url
  }
}
    `;
const UseMobileAdminLoginDocument = (src_default()) `
    mutation UseMobileAdminLogin($input: SignInWithEmailAndPasswordInput!) {
  signInWithEmailAndPassword(input: $input) {
    identityPlatformToken {
      idToken
      email
      expiresIn
      refreshToken
    }
  }
}
    `;
const ShopifyCollectionDocument = (src_default()) `
    query ShopifyCollection($applicationID: ID!, $after: String, $query: String) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        collections(
          after: $after
          first: 20
          orderBy: {field: UPDATED_AT, direction: DESC}
          query: $query
        ) {
          nodes {
            ...ShopifySelectedDesignBlockCollection
          }
          pageInfo {
            ...ShopifyCollectionPageInfo
          }
        }
      }
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionFragmentDoc}
${ShopifyCollectionPageInfoFragmentDoc}`;
const ShopifyProductDocument = (src_default()) `
    query ShopifyProduct($applicationID: ID!, $after: String, $query: String) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        products(
          after: $after
          first: 20
          orderBy: {field: UPDATED_AT, direction: DESC}
          query: $query
        ) {
          nodes {
            ...ShopifySelectedDesignBlockProduct
          }
          pageInfo {
            ...ShopifyProductPageInfo
          }
        }
      }
    }
  }
}
    ${ShopifySelectedDesignBlockProductFragmentDoc}
${ShopifyProductPageInfoFragmentDoc}`;
const ShopifyRedirectUrlDocument = (src_default()) `
    query ShopifyRedirectURL($applicationID: ID!, $scopes: String!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        apiToken {
          id
          isAppInstalled
          hasScopes(scopes: $scopes)
        }
      }
    }
  }
}
    `;
const ShopifyAddonAppsflyerPageDocument = (src_default()) `
    query ShopifyAddonAppsflyerPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        appsflyerAddon {
          id
          setting {
            id
            isActivated
          }
        }
      }
    }
  }
}
    `;
const CreateShopifyAutoPushNotificationCustomerCreatedRuleDocument = (src_default()) `
    mutation CreateShopifyAutoPushNotificationCustomerCreatedRule($input: CreateShopifyAutoPushNotificationCustomerCreatedRuleInput!) {
  createShopifyAutoPushNotificationCustomerCreatedRule(input: $input) {
    autoPushNotificationAddon {
      id
    }
  }
}
    `;
const ShopifyAddonAutoPushNotificationCustomerCreatedRulePageDocument = (src_default()) `
    query ShopifyAddonAutoPushNotificationCustomerCreatedRulePage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        autoPushNotificationAddon {
          id
          customerCreatedRules {
            nodes {
              id
              title
              daysToSend
              sendTime {
                hour
                minute
              }
            }
          }
        }
      }
    }
  }
}
    `;
const ShopifyAddonAutoPushNotificationEditPageDocument = (src_default()) `
    query ShopifyAddonAutoPushNotificationEditPage($autoPushNotificationCustomerCreatedRuleID: ID!) {
  node(id: $autoPushNotificationCustomerCreatedRuleID) {
    id
    __typename
    ... on ShopifyAutoPushNotificationCustomerCreatedRule {
      id
      title
      pushNotificationMessage
      daysToSend
      sendTime {
        hour
        minute
      }
    }
  }
}
    `;
const UpdateShopifyAutoPushNotificationCustomerCreatedRuleDocument = (src_default()) `
    mutation UpdateShopifyAutoPushNotificationCustomerCreatedRule($input: UpdateShopifyAutoPushNotificationCustomerCreatedRuleInput!) {
  updateShopifyAutoPushNotificationCustomerCreatedRule(input: $input) {
    customerCreatedRule {
      id
      title
      pushNotificationMessage
      daysToSend
      sendTime {
        hour
        minute
      }
    }
  }
}
    `;
const DeleteShopifyAutoPushNotificationCustomerCreatedRuleDocument = (src_default()) `
    mutation DeleteShopifyAutoPushNotificationCustomerCreatedRule($input: DeleteShopifyAutoPushNotificationCustomerCreatedRuleInput!) {
  deleteShopifyAutoPushNotificationCustomerCreatedRule(input: $input) {
    autoPushNotificationAddon {
      id
    }
  }
}
    `;
const ShopifyAddonChannelTalkPageDocument = (src_default()) `
    query ShopifyAddonChannelTalkPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        channelTalkAddon {
          id
          setting {
            ...ShopifyAddonChannelTalkSetting
          }
        }
      }
    }
  }
}
    ${ShopifyAddonChannelTalkSettingFragmentDoc}`;
const ShopifyAddonPageDocument = (src_default()) `
    query ShopifyAddonPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        addon {
          id
          masters(orderBy: {field: CREATED_AT, direction: DESC}) {
            nodes {
              id
              shortDescription
              ...ShopifyAddonModal
            }
          }
        }
      }
    }
  }
}
    ${ShopifyAddonModalFragmentDoc}`;
const ShopifyAddonRaffleApplicantDetailPageDocument = (src_default()) `
    query ShopifyAddonRaffleApplicantDetailPage($raffleApplicantID: ID!) {
  node(id: $raffleApplicantID) {
    id
    __typename
    ... on ShopifyRaffleApplicant {
      id
      result
      productRaffle {
        id
        windowStatus
        isExecuted
      }
      mobileAdminCustomer {
        id
        shopifyCustomerID
        displayName
        email
        isRaffleBanned
        defaultAddress {
          id
          formatted
        }
      }
    }
  }
}
    `;
const ReserveShopifyRaffleApplicantResultDocument = (src_default()) `
    mutation ReserveShopifyRaffleApplicantResult($input: ReserveShopifyRaffleApplicantResultInput!) {
  reserveShopifyRaffleApplicantResult(input: $input) {
    applicant {
      id
      result
    }
  }
}
    `;
const CreateShopifyRaffleBannedCustomerDocument = (src_default()) `
    mutation CreateShopifyRaffleBannedCustomer($input: CreateShopifyRaffleBannedCustomerInput!) {
  createShopifyRaffleBannedCustomer(input: $input) {
    bannedCustomer {
      id
      mobileAdminCustomer {
        id
        shopifyCustomerID
        isRaffleBanned
      }
    }
  }
}
    `;
const ShopifyAddonRaffleApplicantPageDocument = (src_default()) `
    query ShopifyAddonRaffleApplicantPage($raffleID: ID!, $first: Int, $after: String, $result: ShopifyRaffleApplicantResult) {
  node(id: $raffleID) {
    id
    __typename
    ... on ShopifyProductRaffle {
      id
      paymentMethodKind
      isCompleted
      applicants(
        result: $result
        first: $first
        after: $after
        orderBy: {field: CREATED_AT, direction: DESC}
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        nodes {
          id
          mobileAdminCustomer {
            id
            displayName
          }
          result
        }
      }
    }
  }
}
    `;
const FindShopifyRaffleApplicantDocument = (src_default()) `
    query FindShopifyRaffleApplicant($raffleApplicantID: ID!) {
  node(id: $raffleApplicantID) {
    ... on ShopifyRaffleApplicant {
      id
    }
  }
}
    `;
const CreateShopifyProductRaffleDocument = (src_default()) `
    mutation CreateShopifyProductRaffle($input: CreateShopifyProductRaffleInput!) {
  createShopifyProductRaffle(input: $input) {
    productRaffle {
      id
      paymentMethodKind
    }
  }
}
    `;
const ShopifyAddonRafflePageDocument = (src_default()) `
    query ShopifyAddonRafflePage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        raffleAddon {
          id
          productRaffles(first: 30, orderBy: {field: CREATED_AT, direction: DESC}) {
            nodes {
              id
              paymentMethodKind
              windowStatus
              isExecuted
              isCompleted
              product {
                id
                title
                images(first: 1, maxWidth: 180, maxHeight: 180) {
                  nodes {
                    transformedSrc
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
const ShopifyAddonRaffleProductPaymentMethodOfflineDetailPageDocument = (src_default()) `
    query ShopifyAddonRaffleProductPaymentMethodOfflineDetailPage($id: ID!) {
  productRaffle: node(id: $id) {
    id
    __typename
    ... on ShopifyProductRaffle {
      ...ExecuteShopifyRaffleTaskButton
      id
      product {
        id
        title
        images(first: 1, maxWidth: 180, maxHeight: 180) {
          nodes {
            transformedSrc
          }
        }
      }
      isCompleted
      openDate
      closeDate
      windowStatus
      paymentMethod {
        __typename
        ... on ShopifyRafflePaymentMethodOffline {
          id
          setting {
            id
            pickupEndDate
            pickupStartDate
          }
          progress {
            id
            total {
              id
              applicantCount
              winnerCount
              loserCount
              pickedUpWinnerCount
              unpickedUpWinnerCount
            }
          }
        }
      }
    }
  }
}
    ${ExecuteShopifyRaffleTaskButtonFragmentDoc}`;
const ShopifyAddonRaffleProductPaymentMethodOfflineStatusDetailPageDocument = (src_default()) `
    query ShopifyAddonRaffleProductPaymentMethodOfflineStatusDetailPage($id: ID!) {
  productRaffle: node(id: $id) {
    id
    __typename
    ... on ShopifyProductRaffle {
      ...ExecuteShopifyRaffleTaskButton
      id
      product {
        id
        title
      }
      paymentMethod {
        __typename
        ... on ShopifyRafflePaymentMethodOffline {
          id
          setting {
            id
            pickupEndDate
            pickupStartDate
          }
          progress {
            id
            variants {
              id
              productVariant {
                id
                title
              }
              applicantCount
              winnerCount
              loserCount
              pickedUpWinnerCount
              unpickedUpWinnerCount
            }
          }
        }
      }
    }
  }
}
    ${ExecuteShopifyRaffleTaskButtonFragmentDoc}`;
const ShopifyAddonRaffleProductPaymentMethodOnlineDetailPageDocument = (src_default()) `
    query ShopifyAddonRaffleProductPaymentMethodOnlineDetailPage($id: ID!) {
  productRaffle: node(id: $id) {
    id
    __typename
    ... on ShopifyProductRaffle {
      ...ExecuteShopifyRaffleTaskButton
      id
      product {
        id
        title
        images(first: 1, maxWidth: 180, maxHeight: 180) {
          nodes {
            transformedSrc
          }
        }
      }
      isCompleted
      openDate
      closeDate
      windowStatus
      paymentMethod {
        __typename
        ... on ShopifyRafflePaymentMethodOnline {
          id
          setting {
            id
            purchaseDeadlineSecond
            isWaitingEnabled
          }
          progress {
            id
            total {
              id
              applicantCount
              winnerCount
              waitingCount
              loserCount
              paidWinnerCount
              unpaidWinnerCount
              overduedWinnerCount
            }
          }
        }
      }
    }
  }
}
    ${ExecuteShopifyRaffleTaskButtonFragmentDoc}`;
const ShopifyAddonRaffleProductPaymentMethodOnlineStatusDetailPageDocument = (src_default()) `
    query ShopifyAddonRaffleProductPaymentMethodOnlineStatusDetailPage($id: ID!) {
  productRaffle: node(id: $id) {
    id
    __typename
    ... on ShopifyProductRaffle {
      ...ExecuteShopifyRaffleTaskButton
      id
      product {
        id
        title
      }
      paymentMethod {
        __typename
        ... on ShopifyRafflePaymentMethodOnline {
          id
          setting {
            id
            purchaseDeadlineSecond
            isWaitingEnabled
          }
          progress {
            id
            variants {
              id
              productVariant {
                id
                title
              }
              applicantCount
              winnerCount
              waitingCount
              loserCount
              paidWinnerCount
              unpaidWinnerCount
              overduedWinnerCount
            }
          }
        }
      }
    }
  }
}
    ${ExecuteShopifyRaffleTaskButtonFragmentDoc}`;
const ShopifyAddonRaffleSettingPageDocument = (src_default()) `
    query ShopifyAddonRaffleSettingPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        raffleAddon {
          id
          setting {
            id
            winLimitDays
            winLimitCount
          }
        }
      }
    }
  }
}
    `;
const UpdateShopifyRaffleAddonSettingDocument = (src_default()) `
    mutation UpdateShopifyRaffleAddonSetting($input: UpdateShopifyRaffleAddonSettingInput!) {
  updateShopifyRaffleAddonSetting(input: $input) {
    raffleAddon {
      id
      setting {
        id
        winLimitDays
        winLimitCount
      }
    }
  }
}
    `;
const ShopifyAddonSignUpBonusPageDocument = (src_default()) `
    query ShopifyAddonSignUpBonusPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        signUpBonusAddon {
          ...ShopifySignUpBonusCouponAddonSettingStatus
          ...ShopifySignUpBonusCouponAddonSettingForm
        }
      }
    }
  }
}
    ${ShopifySignUpBonusCouponAddonSettingStatusFragmentDoc}
${ShopifySignUpBonusCouponAddonSettingFormFragmentDoc}`;
const UpdateShopifySignUpBonusAddonSettingDocument = (src_default()) `
    mutation UpdateShopifySignUpBonusAddonSetting($input: UpdateShopifySignUpBonusAddonSettingInput!) {
  updateShopifySignUpBonusAddonSetting(input: $input) {
    signUpBonusAddon {
      ...ShopifySignUpBonusCouponAddonSettingStatus
    }
  }
}
    ${ShopifySignUpBonusCouponAddonSettingStatusFragmentDoc}`;
const UpdateShopifySignUpBonusAddonCouponSettingDocument = (src_default()) `
    mutation UpdateShopifySignUpBonusAddonCouponSetting($input: UpdateShopifySignUpBonusAddonCouponSettingInput!) {
  updateShopifySignUpBonusAddonCouponSetting(input: $input) {
    signUpBonusAddon {
      ...ShopifySignUpBonusCouponAddonSettingForm
    }
  }
}
    ${ShopifySignUpBonusCouponAddonSettingFormFragmentDoc}`;
const ShopifyAddonStoreManagementCreatePageDocument = (src_default()) `
    query ShopifyAddonStoreManagementCreatePage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        offlineStoreManagementAddon {
          id
          areas {
            nodes {
              id
              name
            }
          }
          brands {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
const CreateShopifyOfflineStoreDocument = (src_default()) `
    mutation CreateShopifyOfflineStore($input: CreateShopifyOfflineStoreInput!) {
  createShopifyOfflineStore(input: $input) {
    offlineStore {
      id
      name
      zip
      address
      url1
      url2
      phone
      officeHour
      googleMapURL
      image {
        id
        url
      }
      brands {
        nodes {
          id
          name
        }
      }
      areas {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
const ShopifyAddonStoreManagementEditPageDocument = (src_default()) `
    query ShopifyAddonStoreManagementEditPage($offlineStoreID: ID!, $applicationID: ID!) {
  node(id: $offlineStoreID) {
    id
    __typename
    ... on ShopifyOfflineStore {
      id
      name
      zip
      address
      url1
      url2
      phone
      officeHour
      googleMapURL
      image {
        id
        url
      }
      brands {
        nodes {
          id
          name
        }
      }
      areas {
        nodes {
          id
          name
        }
      }
    }
  }
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        offlineStoreManagementAddon {
          id
          areas {
            nodes {
              id
              name
            }
          }
          brands {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
const UpdateShopifyOfflineStoreDocument = (src_default()) `
    mutation UpdateShopifyOfflineStore($input: UpdateShopifyOfflineStoreInput!) {
  updateShopifyOfflineStore(input: $input) {
    offlineStore {
      id
      name
      zip
      address
      url1
      url2
      phone
      officeHour
      googleMapURL
      image {
        id
        url
      }
      brands {
        nodes {
          id
        }
      }
      areas {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
const DeleteShopifyOfflineStoreDocument = (src_default()) `
    mutation DeleteShopifyOfflineStore($input: DeleteShopifyOfflineStoreInput!) {
  deleteShopifyOfflineStore(input: $input) {
    deletedID
  }
}
    `;
const ShopifyAddonStoreManagementPageDocument = (src_default()) `
    query ShopifyAddonStoreManagementPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        offlineStoreManagementAddon {
          id
          offlineStores {
            nodes {
              id
              name
              image {
                id
                url
              }
            }
          }
        }
      }
    }
  }
}
    `;
const ShopifyAppInstallCallbackPageDocument = (src_default()) `
    query ShopifyAppInstallCallbackPage($shopOrigin: String!, $scopes: String!) {
  publicViewer {
    id
    shopify {
      id
      appsState(shopOrigin: $shopOrigin) {
        id
        applicationID
        isMobileAppInstalled
        hasMobileAppScopes(scopes: $scopes)
      }
    }
  }
}
    `;
const ShopifyAppInstalledCallbackPageDocument = (src_default()) `
    query ShopifyAppInstalledCallbackPage($shopOrigin: String!, $scopes: String!) {
  publicViewer {
    id
    shopify {
      id
      appsState(shopOrigin: $shopOrigin) {
        id
        applicationID
        isMobileAppInstalled
        isMobileAppInstalledOnce
        hasMobileAppScopes(scopes: $scopes)
      }
    }
  }
}
    `;
const UpdateShopifyMobileAppApiTokenDocument = (src_default()) `
    mutation UpdateShopifyMobileAppAPIToken($input: UpdateShopifyMobileAppAPITokenInput!) {
  updateShopifyMobileAppAPIToken(input: $input) {
    application {
      id
      mobileApp {
        id
        shopify {
          id
          apiToken {
            id
            isAppInstalled
          }
        }
      }
    }
  }
}
    `;
const ShopifyAppReinstallPageDocument = (src_default()) `
    query ShopifyAppReinstallPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        apiToken {
          id
          shopOrigin
        }
      }
    }
  }
}
    `;
const ShopifyAppSubscriptionCallbackPageDocument = (src_default()) `
    query ShopifyAppSubscriptionCallbackPage($shopOrigin: String!) {
  publicViewer {
    id
    shopify {
      id
      appsState(shopOrigin: $shopOrigin) {
        id
        applicationID
      }
    }
  }
}
    `;
const ShopifyDashboardPageDocument = (src_default()) `
    query ShopifyDashboardPage($applicationID: ID!, $start: Date!, $end: Date!) {
  application(id: $applicationID) {
    id
    displayName
    ios {
      id
      releaseVersion
    }
    android {
      id
      releaseVersion
    }
    monthlyUser: statKindDiff(kindName: "User", base: $start, compare: $end) {
      kindName
      count: diffCount
      rate: diffRatePercent
    }
    totalUser: statKind(kindName: "User", date: $end) {
      id
      kindName
      count: totalCount
      createdAt
    }
    mobileApp {
      id
      activeAppSubscription {
        id
        isUpdateRequired
      }
      annualSales {
        id
        sales {
          amount
        }
      }
    }
  }
}
    `;
const ShopifyDashboardRedirectPageDocument = (src_default()) `
    query ShopifyDashboardRedirectPage($shopOrigin: String!) {
  publicViewer {
    id
    shopify {
      id
      appsState(shopOrigin: $shopOrigin) {
        id
        applicationID
      }
    }
  }
}
    `;
const ShopifyDesignEditorPageDocument = (src_default()) `
    query ShopifyDesignEditorPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    appAsset {
      id
      appLogoURL
    }
    ios {
      id
      releaseVersion
      inReviewVersion
    }
    mobileApp {
      id
      shopify {
        id
        design {
          id
          block {
            id
            saved {
              id
              blocks {
                nodes {
                  ...SavedShopifyDesignBlockNode
                }
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                  startCursor
                  endCursor
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${SavedShopifyDesignBlockNodeFragmentDoc}`;
const ShopifyDesignSearchEditorPageDocument = (src_default()) `
    query ShopifyDesignSearchEditorPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        design {
          id
          collectionGroup {
            id
            setting {
              id
              isEnabled
            }
            saved {
              id
              groups {
                nodes {
                  id
                  value {
                    ...SavedShopifyDesignCollectionGroupNode
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${SavedShopifyDesignCollectionGroupNodeFragmentDoc}`;
const ShopifyDesignStyleSectionPageQueryDocument = (src_default()) `
    query ShopifyDesignStyleSectionPageQuery($applicationID: ID!) {
  application(id: $applicationID) {
    id
    ...EditShopifyStyle_Application
    ...UpdateAppAssets_Application
  }
}
    ${EditShopifyStyle_ApplicationFragmentDoc}
${UpdateAppAssets_ApplicationFragmentDoc}`;
const ShopifyMarketingAnnouncementPageDocument = (src_default()) `
    query ShopifyMarketingAnnouncementPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        adminAnnouncementMasters(
          first: 40
          orderBy: {field: PUBLISH_TIME, direction: DESC}
        ) {
          nodes {
            __typename
            ... on ShopifyAnnouncementMasterText {
              ...ShopifyAnnouncementMasterText
            }
            ... on ShopifyAnnouncementMasterURL {
              ...ShopifyAnouncementMasterUrl
            }
          }
        }
      }
    }
  }
}
    ${ShopifyAnnouncementMasterTextFragmentDoc}
${ShopifyAnouncementMasterUrlFragmentDoc}`;
const CustomerCouponMerchantDeliveryRuleCreateDocument = (src_default()) `
    mutation CustomerCouponMerchantDeliveryRuleCreate($input: CreateShopifyCustomerCouponMerchantDeliveryRuleInput!) {
  createShopifyCustomerCouponMerchantDeliveryRule(input: $input) {
    shopifyCustomerCouponMerchantDeliveryRule {
      id
    }
  }
}
    `;
const ShopifyMarketingCustomerCouponMerchantDeliveryRulePageDocument = (src_default()) `
    query ShopifyMarketingCustomerCouponMerchantDeliveryRulePage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        customerCouponMerchantDeliveryRules(
          first: 20
          orderBy: {field: CREATED_AT, direction: DESC}
        ) {
          nodes {
            ...ShopifyStopCouponDeliveryRuleModal
          }
        }
      }
    }
  }
}
    ${ShopifyStopCouponDeliveryRuleModalFragmentDoc}`;
const ShopifyMarketingPushNotificationPageDocument = (src_default()) `
    query ShopifyMarketingPushNotificationPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    pushLogs(first: 40, orderBy: {direction: DESC, field: CREATED_AT}) {
      nodes {
        ...ShopifyMarketingPushNotification
      }
    }
  }
}
    ${ShopifyMarketingPushNotificationFragmentDoc}`;
const ShopifyMarketingSegmentCustomerInterestEditorPageDocument = (src_default()) `
    query ShopifyMarketingSegmentCustomerInterestEditorPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        segment {
          id
          customerInterest {
            id
            rules {
              nodes {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;
const UpdateShopifySegmentCustomerInterestRuleDocument = (src_default()) `
    mutation UpdateShopifySegmentCustomerInterestRule($input: UpdateShopifySegmentCustomerInterestRuleInput!) {
  updateShopifySegmentCustomerInterestRule(input: $input) {
    segmentCustomerInterestRule {
      id
      name
    }
  }
}
    `;
const DeleteShopifySegmentCustomerInterestRuleDocument = (src_default()) `
    mutation DeleteShopifySegmentCustomerInterestRule($input: DeleteShopifySegmentCustomerInterestRuleInput!) {
  deleteShopifySegmentCustomerInterestRule(input: $input) {
    segmentCustomerInterest {
      id
      rules {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
const ShopifyMobileAppCreateDocument = (src_default()) `
    mutation ShopifyMobileAppCreate($input: CreateShopifyMobileAppApplicationInput!) {
  createShopifyMobileAppApplication(input: $input) {
    application {
      id
    }
  }
}
    `;
const ShopifySettingInviteMemberPageDocument = (src_default()) `
    query ShopifySettingInviteMemberPage($applicationID: ID!) {
  application(id: $applicationID) {
    ...ShopifyApplicationMemberSetting
  }
}
    ${ShopifyApplicationMemberSettingFragmentDoc}`;
const InviteShopifyApplicationMemberDocument = (src_default()) `
    mutation InviteShopifyApplicationMember($input: InviteApplicationMemberInput!) {
  inviteApplicationMember(input: $input) {
    applicationMemberInvitation {
      id
    }
  }
}
    `;
const ShopifySettingPageDocument = (src_default()) `
    query ShopifySettingPage($applicationID: ID!) {
  adminViewer {
    ...ShopifySettingAccount
  }
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        setting {
          ...ShopifyCheckoutCustomerAccountConditionSetting
        }
      }
    }
    ...ShopifyApplicationMemberSetting
  }
}
    ${ShopifySettingAccountFragmentDoc}
${ShopifyCheckoutCustomerAccountConditionSettingFragmentDoc}
${ShopifyApplicationMemberSettingFragmentDoc}`;
const ShopifySettingShopTermPageDocument = (src_default()) `
    query ShopifySettingShopTermPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        setting {
          id
          termsOfUse
          privacyPolicy
          specifiedCommercialTransactionAct
          shippingPolicy
        }
      }
    }
  }
}
    `;
const UpdateShopifyShopTermsDocument = (src_default()) `
    mutation UpdateShopifyShopTerms($input: UpdateShopifyTermsInput!) {
  updateShopifyTerms(input: $input) {
    shopifySetting {
      id
      termsOfUse
      privacyPolicy
      specifiedCommercialTransactionAct
      shippingPolicy
    }
  }
}
    `;
const ShopifyUpdateTokenPageDocument = (src_default()) `
    query ShopifyUpdateTokenPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        apiToken {
          id
          shopOrigin
        }
      }
    }
  }
}
    `;
const UpdateShopifyChannelTalkAddonSettingPluginKeyDocument = (src_default()) `
    mutation UpdateShopifyChannelTalkAddonSettingPluginKey($input: UpdateShopifyChannelTalkAddonSettingPluginKeyInput!) {
  updateShopifyChannelTalkAddonSettingPluginKey(input: $input) {
    channelTalkAddon {
      id
      setting {
        id
        isActivated
        pluginKey
      }
    }
  }
}
    `;
const InstallShopifyAddonDocument = (src_default()) `
    mutation InstallShopifyAddon($input: InstallShopifyAddonInput!) {
  installShopifyAddon(input: $input) {
    addon {
      id
      master {
        id
        name
        addonType
      }
    }
  }
}
    `;
const ShopifyRaffleCreateModalDocument = (src_default()) `
    query ShopifyRaffleCreateModal($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        draftProducts {
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          nodes {
            ...ShopifyAddonRaffleCreateModal_ShopifyAdminProduct
          }
        }
      }
    }
  }
}
    ${ShopifyAddonRaffleCreateModal_ShopifyAdminProductFragmentDoc}`;
const ExecuteShopifyRaffleTaskDocument = (src_default()) `
    mutation ExecuteShopifyRaffleTask($input: ExecuteShopifyRaffleTaskInput!) {
  executeShopifyRaffleTask(input: $input) {
    productRaffle {
      ...ExecuteShopifyRaffleTaskButton
    }
  }
}
    ${ExecuteShopifyRaffleTaskButtonFragmentDoc}`;
const CreateShopifyRaffleApplicantCsvDownloadUrlDocument = (src_default()) `
    mutation CreateShopifyRaffleApplicantCsvDownloadURL($input: CreateShopifyRaffleApplicantCsvDownloadURLInput!) {
  createShopifyRaffleApplicantCsvDownloadURL(input: $input) {
    downloadURL
  }
}
    `;
const CreateShopifyRaffleApplicantCsvUploadUrlDocument = (src_default()) `
    mutation CreateShopifyRaffleApplicantCsvUploadURL($input: CreateShopifyRaffleApplicantCsvUploadURLInput!) {
  createShopifyRaffleApplicantCsvUploadURL(input: $input) {
    uploadURL
  }
}
    `;
const ImportShopifyRaffleApplicantCsvDocument = (src_default()) `
    mutation ImportShopifyRaffleApplicantCsv($input: ImportShopifyRaffleApplicantCsvInput!) {
  importShopifyRaffleApplicantCsv(input: $input) {
    success
  }
}
    `;
const ShopifyAddonStoreManagementCreateAreaModalDocument = (src_default()) `
    query ShopifyAddonStoreManagementCreateAreaModal($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        offlineStoreManagementAddon {
          id
          areas {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
const CreateShopifyOfflineStoreAreaDocument = (src_default()) `
    mutation CreateShopifyOfflineStoreArea($input: CreateShopifyOfflineStoreAreaInput!) {
  createShopifyOfflineStoreArea(input: $input) {
    offlineStoreArea {
      id
      name
    }
  }
}
    `;
const ShopifyAddonStoreManagementCreateBrandModalDocument = (src_default()) `
    query ShopifyAddonStoreManagementCreateBrandModal($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        offlineStoreManagementAddon {
          id
          brands {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
const CreateShopifyOfflineStoreBrandDocument = (src_default()) `
    mutation CreateShopifyOfflineStoreBrand($input: CreateShopifyOfflineStoreBrandInput!) {
  createShopifyOfflineStoreBrand(input: $input) {
    offlineStoreBrand {
      id
      name
      image {
        id
        url
      }
    }
  }
}
    `;
const ShopifyAppSubmissionReadyToSubmitBannerDocument = (src_default()) `
    query ShopifyAppSubmissionReadyToSubmitBanner($applicationID: ID!) {
  application(id: $applicationID) {
    id
    appAsset {
      id
      iconImageURL
    }
    ios {
      id
      existAllAppStoreInfo
      organizationName
    }
    android {
      id
      existAllGooglePlayStoreInfo
      developerAccountID
    }
  }
}
    `;
const ShopifyAppSubmissionSetupDesignStepDocument = (src_default()) `
    query ShopifyAppSubmissionSetupDesignStep($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        design {
          id
          block {
            id
            released {
              id
              blocks {
                nodes {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
const ShopifyAppSubmissionUploadLogoStepDocument = (src_default()) `
    query ShopifyAppSubmissionUploadLogoStep($applicationID: ID!) {
  application(id: $applicationID) {
    id
    appAsset {
      id
      iconImageURL
    }
  }
}
    `;
const ShopifyAppSubmissionEditStoreInformationStepDocument = (src_default()) `
    query ShopifyAppSubmissionEditStoreInformationStep($applicationID: ID!) {
  application(id: $applicationID) {
    id
    ios {
      id
      existAllAppStoreInfo
    }
    android {
      id
      existAllGooglePlayStoreInfo
    }
  }
}
    `;
const ShopifyAppSubmissionDeveloperAccountIntegrationStepDocument = (src_default()) `
    query ShopifyAppSubmissionDeveloperAccountIntegrationStep($applicationID: ID!) {
  application(id: $applicationID) {
    id
    ios {
      id
      organizationName
    }
    android {
      id
      developerAccountID
    }
  }
}
    `;
const CreateShopifyMobileAppSubscriptionDocument = (src_default()) `
    mutation CreateShopifyMobileAppSubscription($input: CreateShopifyMobileAppSubscriptionInput!) {
  createShopifyMobileAppSubscription(input: $input) {
    confirmationURL
    shopOrigin
  }
}
    `;
const UpdateShopifyMobileAppSubscriptionDocument = (src_default()) `
    mutation UpdateShopifyMobileAppSubscription($input: UpdateShopifyMobileAppSubscriptionInput!) {
  updateShopifyMobileAppSubscription(input: $input) {
    confirmationURL
    shopOrigin
  }
}
    `;
const ShopifyDesignShopPageSectionDocument = (src_default()) `
    query ShopifyDesignShopPageSection($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        design {
          id
          block {
            id
            saved {
              id
              blocks {
                nodes {
                  id
                  updatedAt
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
const UpdateShopifyDesignStyleDocument = (src_default()) `
    mutation UpdateShopifyDesignStyle($input: UpdateShopifyDesignStyleInput!) {
  updateShopifyDesignStyle(input: $input) {
    shopifyDesign {
      id
      style {
        id
        productImageRatio
        color {
          primaryColor
        }
        isDisplayComparedAtPrice
      }
    }
  }
}
    `;
const ShopifyDesignSearchPageSectionDocument = (src_default()) `
    query ShopifyDesignSearchPageSection($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        design {
          id
          collectionGroup {
            id
            setting {
              id
              isEnabled
            }
          }
        }
      }
    }
  }
}
    `;
const ShopifyDesignProductPageSectionDocument = (src_default()) `
    query ShopifyDesignProductPageSection($applicationID: ID!) {
  application(id: $applicationID) {
    id
    shopifyAppExtension {
      id
      shopify {
        id
        design {
          id
          product {
            id
            isDisplayVendor
            productVariant {
              id
              isDisplayImage
            }
          }
        }
      }
    }
  }
}
    `;
const ShopifyDesignCartPageSectionDocument = (src_default()) `
    query ShopifyDesignCartPageSection($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        design {
          id
          cart {
            id
            isDisplayEstimatedOrderPointEnabled
          }
        }
      }
    }
  }
}
    `;
const UpdateShopifyDesignCartDocument = (src_default()) `
    mutation UpdateShopifyDesignCart($input: UpdateShopifyDesignCartInput!) {
  updateShopifyDesignCart(input: $input) {
    design {
      id
      cart {
        id
        isDisplayEstimatedOrderPointEnabled
      }
    }
  }
}
    `;
const UpdateAppLogoDocument = (src_default()) `
    mutation UpdateAppLogo($input: UpdateAppAssetAppLogoInput!) {
  updateAppAssetAppLogo(input: $input) {
    application {
      id
      appAsset {
        id
        appLogoURL
      }
    }
  }
}
    `;
const UpdateShopifyAppDesignCollectionGroupSettingDocument = (src_default()) `
    mutation UpdateShopifyAppDesignCollectionGroupSetting($input: UpdateShopifyAppDesignCollectionGroupSettingInput!) {
  updateShopifyAppDesignCollectionGroupSetting(input: $input) {
    shopifyDesign {
      id
      collectionGroup {
        id
        setting {
          isEnabled
          id
        }
      }
    }
  }
}
    `;
const MemberCardDocument = (src_default()) `
    query MemberCard($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        design {
          id
          memberCard {
            id
            isDisplayed
            memberIDProviderKind
            isDisplayedCustomerPoint
            isDisplayedCustomerRank
          }
        }
      }
    }
    vipApp {
      id
      apiToken {
        id
        isAppInstalled
      }
    }
  }
}
    `;
const UpdateShopifyDesignMemberCardDocument = (src_default()) `
    mutation UpdateShopifyDesignMemberCard($input: UpdateShopifyDesignMemberCardInput!) {
  updateShopifyDesignMemberCard(input: $input) {
    design {
      id
      memberCard {
        id
        isDisplayed
        memberIDProviderKind
        isDisplayedCustomerPoint
        isDisplayedCustomerRank
      }
    }
  }
}
    `;
const ShopifyDesignAppAssetsSectionDocument = (src_default()) `
    query ShopifyDesignAppAssetsSection($applicationID: ID!) {
  application(id: $applicationID) {
    id
    appAsset {
      id
      iconImageURL
      launchScreenImageURL
    }
  }
}
    `;
const UpdateShopifyDesignProductDocument = (src_default()) `
    mutation UpdateShopifyDesignProduct($input: UpdateShopifyDesignProductInput!) {
  updateShopifyDesignProduct(input: $input) {
    design {
      id
      product {
        id
        isDisplayVendor
        productVariant {
          id
          isDisplayImage
        }
      }
    }
  }
}
    `;
const ShopifySelectCollectionsDocument = (src_default()) `
    query ShopifySelectCollections($ids: [ID!]!) {
  collections: nodes(ids: $ids) {
    ... on ShopifyCollection {
      ...ShopifySelectedDesignBlockCollection
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionFragmentDoc}`;
const ShopifySelectProductsDocument = (src_default()) `
    query ShopifySelectProducts($ids: [ID!]!) {
  products: nodes(ids: $ids) {
    ... on ShopifyProduct {
      ...ShopifySelectedDesignBlockProduct
    }
  }
}
    ${ShopifySelectedDesignBlockProductFragmentDoc}`;
const GetShopifyCollectionsByAdminApiiDsDocument = (src_default()) `
    query GetShopifyCollectionsByAdminAPIIDs($applicationID: ID!, $collectionAdminAPIIDs: [String!]!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        collectionsByAdminAPIIDs(collectionAdminAPIIDs: $collectionAdminAPIIDs) {
          ... on ShopifyCollection {
            id
            collectionAdminAPIID
            ...ShopifySelectedDesignBlockCollection
          }
        }
      }
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionFragmentDoc}`;
const ShopifySelectCollectionDocument = (src_default()) `
    query ShopifySelectCollection($id: ID!) {
  collection: node(id: $id) {
    ... on ShopifyCollection {
      ...ShopifySelectedDesignBlockCollection
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionFragmentDoc}`;
const ShopifySelectProductDocument = (src_default()) `
    query ShopifySelectProduct($id: ID!) {
  product: node(id: $id) {
    ... on ShopifyProduct {
      ...ShopifySelectedDesignBlockProduct
    }
  }
}
    ${ShopifySelectedDesignBlockProductFragmentDoc}`;
const GetShopifyProductByAdminIdDocument = (src_default()) `
    query GetShopifyProductByAdminID($applicationID: ID!, $productAdminAPIID: String!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        product(productAdminAPIID: $productAdminAPIID) {
          ... on ShopifyProduct {
            ...ShopifySelectedDesignBlockProduct
          }
        }
      }
    }
  }
}
    ${ShopifySelectedDesignBlockProductFragmentDoc}`;
const GetShopifyCollectionByAdminIdDocument = (src_default()) `
    query GetShopifyCollectionByAdminID($applicationID: ID!, $collectionAdminAPIID: String!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        collection(collectionAdminAPIID: $collectionAdminAPIID) {
          ... on ShopifyCollection {
            ...ShopifySelectedDesignBlockCollection
          }
        }
      }
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionFragmentDoc}`;
const ShopifyDesignReleaseButtonDocument = (src_default()) `
    query ShopifyDesignReleaseButton($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        design {
          id
          block {
            id
            saved {
              id
              isUpdated
            }
          }
        }
      }
    }
  }
}
    `;
const SaveShopifyDesignDocument = (src_default()) `
    mutation SaveShopifyDesign($applicationID: ID!, $blocks: [UpdateShopifyDesignBlock!]!) {
  updateShopifyDesignBlocks(
    input: {applicationID: $applicationID, blocks: $blocks}
  ) {
    shopifyDesign {
      id
      block {
        id
        saved {
          id
          isUpdated
          blocks {
            nodes {
              id
              order
              block {
                ...ShopifyDesignBlock
              }
            }
            pageInfo {
              ...ShopifyDesignBlockPageInfo
            }
          }
        }
      }
    }
  }
}
    ${ShopifyDesignBlockFragmentDoc}
${ShopifyDesignBlockPageInfoFragmentDoc}`;
const ReleaseShopifyDesignDocument = (src_default()) `
    mutation ReleaseShopifyDesign($applicationID: ID!) {
  releaseShopifyDesignBlocks(input: {applicationID: $applicationID}) {
    shopifyDesign {
      id
      block {
        id
        saved {
          id
          isUpdated
        }
        released {
          id
          blocks {
            nodes {
              id
              order
              block {
                ...ShopifyDesignBlock
              }
            }
            pageInfo {
              ...ShopifyDesignBlockPageInfo
            }
          }
        }
      }
    }
  }
}
    ${ShopifyDesignBlockFragmentDoc}
${ShopifyDesignBlockPageInfoFragmentDoc}`;
const ShopifySelectedDesignBlockCollectionsDocument = (src_default()) `
    query ShopifySelectedDesignBlockCollections($ids: [ID!]!) {
  collections: nodes(ids: $ids) {
    ... on ShopifyCollection {
      ...ShopifySelectedDesignBlockCollection
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionFragmentDoc}`;
const GetSelectedDesignBlockCollectionsByAdminApiiDsDocument = (src_default()) `
    query GetSelectedDesignBlockCollectionsByAdminAPIIDs($applicationID: ID!, $collectionAdminAPIIDs: [String!]!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        collectionsByAdminAPIIDs(collectionAdminAPIIDs: $collectionAdminAPIIDs) {
          ... on ShopifyCollection {
            id
            ...ShopifySelectedDesignBlockCollection
          }
        }
      }
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionFragmentDoc}`;
const ShopifySelectedDesignBlockProductsDocument = (src_default()) `
    query ShopifySelectedDesignBlockProducts($ids: [ID!]!) {
  products: nodes(ids: $ids) {
    ... on ShopifyProduct {
      ...ShopifySelectedDesignBlockProduct
    }
  }
}
    ${ShopifySelectedDesignBlockProductFragmentDoc}`;
const ShopifySelectedDesignBlockCollectionProductsDocument = (src_default()) `
    query ShopifySelectedDesignBlockCollectionProducts($applicationID: ID!, $collectionAdminAPIID: String!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        collection(collectionAdminAPIID: $collectionAdminAPIID) {
          ... on ShopifyCollection {
            id
            ...ShopifySelectedDesignBlockCollectionProduct
          }
        }
      }
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionProductFragmentDoc}`;
const ShopifySelectedDesignBlockCollectionProducts2Document = (src_default()) `
    query ShopifySelectedDesignBlockCollectionProducts2($applicationID: ID!, $collectionAdminAPIID: String!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        collection(collectionAdminAPIID: $collectionAdminAPIID) {
          ... on ShopifyCollection {
            id
            ...ShopifySelectedDesignBlockCollectionProduct2
          }
        }
      }
    }
  }
}
    ${ShopifySelectedDesignBlockCollectionProduct2FragmentDoc}`;
const ShopifyDesignMerchantSectionDocument = (src_default()) `
    query ShopifyDesignMerchantSection($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        design {
          id
          merchantSection {
            id
            title
            items {
              nodes {
                id
                title
                link
              }
            }
          }
        }
      }
    }
  }
}
    `;
const UpdateShopifyDesignMerchantSectionDocument = (src_default()) `
    mutation UpdateShopifyDesignMerchantSection($input: UpdateShopifyDesignMerchantSectionInput!) {
  updateShopifyDesignMerchantSection(input: $input) {
    application {
      id
      mobileApp {
        id
        shopify {
          id
          design {
            id
            merchantSection {
              id
              title
              items {
                nodes {
                  id
                  title
                  link
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
const CreateShopifyAnnouncementFormDocument = (src_default()) `
    query CreateShopifyAnnouncementForm($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        segment {
          id
          customerInterest {
            id
            rules {
              nodes {
                id
                name
              }
            }
          }
        }
      }
    }
    vipApp {
      id
      rank {
        id
        rules {
          nodes {
            id
            name
          }
        }
      }
    }
  }
}
    `;
const CreateShopifyAnnouncementDocument = (src_default()) `
    mutation CreateShopifyAnnouncement($input: CreateShopifyAnnouncementInput!) {
  createShopifyAnnouncement(input: $input) {
    shopifyAnnouncementMaster {
      __typename
      ... on ShopifyAnnouncementMasterText {
        ...ShopifyAnnouncementMasterText
      }
      ... on ShopifyAnnouncementMasterURL {
        ...ShopifyAnouncementMasterUrl
      }
    }
  }
}
    ${ShopifyAnnouncementMasterTextFragmentDoc}
${ShopifyAnouncementMasterUrlFragmentDoc}`;
const UpdateShopifyCustomerCouponMerchantDeliveryRuleIsPausedDocument = (src_default()) `
    mutation UpdateShopifyCustomerCouponMerchantDeliveryRuleIsPaused($input: UpdateShopifyCustomerCouponMerchantDeliveryRuleIsPausedInput!) {
  updateShopifyCustomerCouponMerchantDeliveryRuleIsPaused(input: $input) {
    shopifyCustomerCouponMerchantDeliveryRule {
      id
      status
      couponTitle
      redeemCode
      startsAt
      isDeliveryNewMobileAppCustomerEnabled
      pushNotificationMessage
      endsAt
    }
  }
}
    `;
const ShopifyMarketingPushNotificationCancelDocument = (src_default()) `
    mutation ShopifyMarketingPushNotificationCancel($input: CancelPushNotificationInput!) {
  cancelPushNotification(input: $input) {
    success
  }
}
    `;
const ShopifyMarketingPushNotificationAudienceDocument = (src_default()) `
    query ShopifyMarketingPushNotificationAudience($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        segment {
          id
          customerInterest {
            id
            rules {
              nodes {
                id
                name
              }
            }
          }
        }
      }
    }
    vipApp {
      id
      rank {
        id
        rules {
          nodes {
            id
            name
          }
        }
      }
    }
  }
}
    `;
const ShopifyPushNotificationCreateDocument = (src_default()) `
    mutation ShopifyPushNotificationCreate($input: SendPushNotificationInput!) {
  sendPushNotification(input: $input) {
    pushLog {
      ...PushLog
    }
  }
}
    ${PushLogFragmentDoc}`;
const CreateShopifySegmentCustomerInterestRuleDocument = (src_default()) `
    mutation CreateShopifySegmentCustomerInterestRule($input: CreateShopifySegmentCustomerInterestRuleInput!) {
  createShopifySegmentCustomerInterestRule(input: $input) {
    segmentCustomerInterest {
      id
      rules {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
const ShopifyNavigationDocument = (src_default()) `
    query ShopifyNavigation($applicationID: ID!) {
  application(id: $applicationID) {
    id
    mobileApp {
      id
      shopify {
        id
        addon {
          id
          installeds(orderBy: {field: CREATED_AT, direction: DESC}) {
            nodes {
              id
              master {
                id
                addonType
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;
const SaveShopifyDesignCollectionGroupDocument = (src_default()) `
    mutation SaveShopifyDesignCollectionGroup($input: UpdateShopifyDesignCollectionGroupInput!) {
  updateShopifyDesignCollectionGroup(input: $input) {
    shopifyDesign {
      id
      collectionGroup {
        id
        saved {
          id
          groups {
            pageInfo {
              ...ShopifyCollectionGroupPageInfo
            }
            nodes {
              id
              value {
                ...SavedShopifyDesignCollectionGroupNode
              }
            }
          }
        }
      }
    }
  }
}
    ${ShopifyCollectionGroupPageInfoFragmentDoc}
${SavedShopifyDesignCollectionGroupNodeFragmentDoc}`;
const ReleaseShopifyDesignCollectionGroupDocument = (src_default()) `
    mutation ReleaseShopifyDesignCollectionGroup($input: ReleaseShopifyDesignCollectionGroupInput!) {
  releaseShopifyDesignCollectionGroup(input: $input) {
    shopifyDesign {
      id
      collectionGroup {
        id
        saved {
          id
          groups {
            pageInfo {
              ...ShopifyCollectionGroupPageInfo
            }
            nodes {
              id
              value {
                ...SavedShopifyDesignCollectionGroupNode
              }
            }
          }
        }
      }
    }
  }
}
    ${ShopifyCollectionGroupPageInfoFragmentDoc}
${SavedShopifyDesignCollectionGroupNodeFragmentDoc}`;
const UpdateShopifyCheckoutCustomerAccountConditionDocument = (src_default()) `
    mutation UpdateShopifyCheckoutCustomerAccountCondition($input: UpdateShopifyCheckoutCustomerAccountConditionInput!) {
  updateShopifyCheckoutCustomerAccountCondition(input: $input) {
    shopifySetting {
      ...ShopifyCheckoutCustomerAccountConditionSetting
    }
  }
}
    ${ShopifyCheckoutCustomerAccountConditionSettingFragmentDoc}`;
const DeleteApplicationMemberInvitationDocument = (src_default()) `
    mutation DeleteApplicationMemberInvitation($input: DeleteApplicationMemberInvitationInput!) {
  deleteApplicationMemberInvitation(input: $input) {
    application {
      ...ShopifyApplicationMemberSetting
    }
  }
}
    ${ShopifyApplicationMemberSettingFragmentDoc}`;
const ShopifyApplicationModeSettingDocument = (src_default()) `
    query ShopifyApplicationModeSetting($id: ID!) {
  application(id: $id) {
    id
    mobileApp {
      id
      mode
    }
  }
}
    `;
const UpdateShopifyMobileAppModeDocument = (src_default()) `
    mutation UpdateShopifyMobileAppMode($input: UpdateShopifyMobileAppModeInput!) {
  updateShopifyMobileAppMode(input: $input) {
    application {
      id
      mobileApp {
        id
        mode
      }
    }
  }
}
    `;
const ShopifyAppStoreSettingButtonDocument = (src_default()) `
    query ShopifyAppStoreSettingButton($applicationID: ID!) {
  application(id: $applicationID) {
    id
    ios {
      ...UpdateAppStoreModal
    }
  }
}
    ${UpdateAppStoreModalFragmentDoc}`;
const ShopifyGooglePlayStoreSettingButtonDocument = (src_default()) `
    query ShopifyGooglePlayStoreSettingButton($applicationID: ID!) {
  application(id: $applicationID) {
    id
    android {
      ...UpdateGooglePlayStoreModal
    }
  }
}
    ${UpdateGooglePlayStoreModalFragmentDoc}`;
const ShopifyVipAppRedirectUrlDocument = (src_default()) `
    query ShopifyVIPAppRedirectURL($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    apiToken {
      id
      isAppInstalled
    }
  }
}
    `;
const UseVipAdminLoginDocument = (src_default()) `
    mutation UseVIPAdminLogin($input: SignInWithEmailAndPasswordInput!) {
  signInWithEmailAndPassword(input: $input) {
    identityPlatformToken {
      idToken
      email
      expiresIn
      refreshToken
    }
  }
}
    `;
const CreateShopifyVipAppDocument = (src_default()) `
    mutation CreateShopifyVIPApp($input: CreateShopifyVIPAppApplicationInput!) {
  createShopifyVIPAppApplication(input: $input) {
    application {
      id
      vipApp {
        id
      }
    }
  }
}
    `;
const ShopifyVipAppCustomerPageDocument = (src_default()) `
    query ShopifyVIPAppCustomerPage($vipAppID: ID!, $first: Int, $last: Int, $before: String, $after: String, $query: String) {
  shopifyVIPApp(id: $vipAppID) {
    id
    customers(
      first: $first
      last: $last
      before: $before
      after: $after
      query: $query
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
}
    `;
const ShopifyVipAppInstalledCallbackPageDocument = (src_default()) `
    query ShopifyVIPAppInstalledCallbackPage($shopOrigin: String!, $scopes: String!) {
  publicViewer {
    id
    shopify {
      id
      appsState(shopOrigin: $shopOrigin) {
        id
        applicationID
        shopifyVIPAppID
        isVIPAppInstalled
        isVIPAppInstalledOnce
        hasVIPAppScopes(scopes: $scopes)
      }
    }
  }
}
    `;
const UpdateShopifyVipapiTokenDocument = (src_default()) `
    mutation UpdateShopifyVIPAPIToken($input: UpdateShopifyVIPAppAPITokenInput!) {
  updateShopifyVIPAPIToken(input: $input) {
    application {
      id
      vipApp {
        id
        apiToken {
          id
          isAppInstalled
        }
      }
    }
  }
}
    `;
const ShopifyVipAppPointProgramPageDocument = (src_default()) `
    query ShopifyVIPAppPointProgramPage($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    setting {
      id
      isPointConsumptionEnabled
      isPointServiceEnabled
    }
    pointPrivateAppAdminAPICredential {
      id
    }
  }
}
    `;
const ShopifyVipAppPointProgramPointAddRuleOrderCreatePageDocument = (src_default()) `
    query ShopifyVIPAppPointProgramPointAddRuleOrderCreatePage($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    rank {
      id
      rules {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
const UpdateShopifyVipAppPointAddRuleOrderDocument = (src_default()) `
    mutation UpdateShopifyVIPAppPointAddRuleOrder($input: UpdateShopifyVIPAppPointAddRuleOrderInput!) {
  updateShopifyVIPAppPointAddRuleOrder(input: $input) {
    vipApp {
      id
      pointAddRuleOrder {
        id
        isEnabled
        title
        basePoint
        basePrice
        expiresIn
        rankRuleMultiples {
          rankRule {
            id
            name
          }
          multiple
        }
        minimumRequirementSubtotal
      }
    }
  }
}
    `;
const ShopifyVipAppPointProgramPointAddRuleOrderUpdatePageDocument = (src_default()) `
    query ShopifyVIPAppPointProgramPointAddRuleOrderUpdatePage($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    ...ShopifyVIPAppPointProgramPointAddRuleOrderUpdateForm
  }
}
    ${ShopifyVipAppPointProgramPointAddRuleOrderUpdateFormFragmentDoc}`;
const DeleteShopifyVipAppPointAddRuleOrderDocument = (src_default()) `
    mutation DeleteShopifyVIPAppPointAddRuleOrder($input: DeleteShopifyVIPAppPointAddRuleOrderInput!) {
  deleteShopifyVIPAppPointAddRuleOrder(input: $input) {
    vipApp {
      id
      pointAddRuleOrder {
        id
        title
        isEnabled
        basePoint
        basePrice
        expiresIn
        rankRuleMultiples {
          rankRule {
            id
            name
          }
          multiple
        }
        minimumRequirementSubtotal
      }
    }
  }
}
    `;
const UpdateShopifyVipAppPointAddRuleSignUpDocument = (src_default()) `
    mutation UpdateShopifyVIPAppPointAddRuleSignUp($input: UpdateShopifyVIPAppPointAddRuleSignUpInput!) {
  updateShopifyVIPAppPointAddRuleSignUp(input: $input) {
    vipApp {
      id
      pointAddRuleSignUp {
        id
        isEnabled
        title
        expiresIn
        point
      }
    }
  }
}
    `;
const ShopifyVipAppPointProgramPointAddRuleSignUpUpdatePageDocument = (src_default()) `
    query ShopifyVIPAppPointProgramPointAddRuleSignUpUpdatePage($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    pointAddRuleSignUp {
      ...ShopifyVIPAppPointProgramPointAddRuleSignUpUpdateForm
    }
  }
}
    ${ShopifyVipAppPointProgramPointAddRuleSignUpUpdateFormFragmentDoc}`;
const DeleteShopifyVipAppPointAddRuleSignUpDocument = (src_default()) `
    mutation DeleteShopifyVIPAppPointAddRuleSignUp($input: DeleteShopifyVIPAppPointAddRuleSignUpInput!) {
  deleteShopifyVIPAppPointAddRuleSignUp(input: $input) {
    vipApp {
      id
      pointAddRuleSignUp {
        id
        isEnabled
        title
        expiresIn
        point
      }
    }
  }
}
    `;
const ShopifyVipProgramPointSettingPageDocument = (src_default()) `
    query ShopifyVIPProgramPointSettingPage($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    setting {
      id
      pointAvailableIn
      isPointConsumptionEnabled
      isShopifyFlowEnabled
      isPointServiceEnabled
    }
  }
}
    `;
const UpdateShopifyVipAppSettingDocument = (src_default()) `
    mutation UpdateShopifyVIPAppSetting($input: UpdateShopifyVIPAppSettingInput!) {
  updateShopifyVIPAppSetting(input: $input) {
    vipApp {
      id
      setting {
        id
        pointAvailableIn
        isPointConsumptionEnabled
        isShopifyFlowEnabled
        isPointServiceEnabled
      }
    }
  }
}
    `;
const ShopifyVipAppRankProgramCreatePageDocument = (src_default()) `
    mutation ShopifyVIPAppRankProgramCreatePage($input: CreateShopifyVIPAppRankRuleInput!) {
  createShopifyVIPAppRankRule(input: $input) {
    rank {
      id
      rules(first: 10) {
        nodes {
          id
          name
          threshold
        }
      }
    }
  }
}
    `;
const ShopifyVipAppRankProgramEditPageDocument = (src_default()) `
    query ShopifyVIPAppRankProgramEditPage($rankRuleID: ID!) {
  node(id: $rankRuleID) {
    ... on ShopifyVIPAppRankRule {
      ...ShopifyVIPAppRankProgramEditForm
    }
  }
}
    ${ShopifyVipAppRankProgramEditFormFragmentDoc}`;
const UpdateShopifyVipAppRankRuleDocument = (src_default()) `
    mutation UpdateShopifyVIPAppRankRule($input: UpdateShopifyVIPAppRankRuleInput!) {
  updateShopifyVIPAppRankRule(input: $input) {
    rank {
      id
      rules(first: 10) {
        nodes {
          id
          name
          threshold
        }
      }
    }
  }
}
    `;
const DeleteShopifyVipAppRankRuleDocument = (src_default()) `
    mutation DeleteShopifyVIPAppRankRule($input: DeleteShopifyVIPAppRankRuleInput!) {
  deleteShopifyVIPAppRankRule(input: $input) {
    rank {
      id
      rules(first: 10) {
        nodes {
          id
          name
          threshold
        }
      }
    }
  }
}
    `;
const ShopifyVipAppRankProgramPageDocument = (src_default()) `
    query ShopifyVIPAppRankProgramPage($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    ...ShopifyVIPAppRankList
  }
}
    ${ShopifyVipAppRankListFragmentDoc}`;
const ShopifyVipAppRankProgramSettingPageDocument = (src_default()) `
    query ShopifyVIPAppRankProgramSettingPage($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    rank {
      id
      rankDecisionSetting {
        id
        rankDecisionMethod
        rankDecisionMethodSettingEarnedPoint {
          id
          isRankDecisionPeriodSpecified
          rankDecisionPeriodYear
        }
        rankDecisionMethodSettingPurchasePrice {
          id
          isRankDecisionPeriodSpecified
          rankDecisionPeriodYear
        }
      }
    }
  }
}
    `;
const UpdateShopifyVipAppRankDecisionSettingDocument = (src_default()) `
    mutation UpdateShopifyVIPAppRankDecisionSetting($input: UpdateShopifyVIPAppRankDecisionSettingInput!) {
  updateShopifyVIPAppRankDecisionSetting(input: $input) {
    rank {
      id
      rankDecisionSetting {
        id
        rankDecisionMethod
        rankDecisionMethodSettingEarnedPoint {
          id
          isRankDecisionPeriodSpecified
          rankDecisionPeriodYear
        }
        rankDecisionMethodSettingPurchasePrice {
          id
          isRankDecisionPeriodSpecified
          rankDecisionPeriodYear
        }
      }
    }
  }
}
    `;
const ShopifyVipAppReInstallPageDocument = (src_default()) `
    query ShopifyVIPAppReInstallPage($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    apiToken {
      id
      shopOrigin
    }
  }
}
    `;
const ShopifyVipAppRedirectPageDocument = (src_default()) `
    query ShopifyVIPAppRedirectPage {
  adminViewer {
    id
    vipApps(first: 1) {
      nodes {
        id
      }
    }
  }
}
    `;
const ShopifyVipAppSettingInviteMemberPageDocument = (src_default()) `
    query ShopifyVIPAppSettingInviteMemberPage($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    application {
      id
    }
  }
}
    `;
const InviteApplicationMemberDocument = (src_default()) `
    mutation InviteApplicationMember($input: InviteApplicationMemberInput!) {
  inviteApplicationMember(input: $input) {
    applicationMemberInvitation {
      id
      email
    }
  }
}
    `;
const ShopifyVipAppSettingPageDocument = (src_default()) `
    query ShopifyVIPAppSettingPage($vipAppID: ID!) {
  adminViewer {
    ...ShopifyVIPAppSettingAccount
  }
  shopifyVIPApp(id: $vipAppID) {
    id
    ...ShopifyVIPAppSettingMetafieldsSyncSection
    ...ShopifyVIPAppSettingMemberSection
  }
}
    ${ShopifyVipAppSettingAccountFragmentDoc}
${ShopifyVipAppSettingMetafieldsSyncSectionFragmentDoc}
${ShopifyVipAppSettingMemberSectionFragmentDoc}`;
const ShopifyVipAppSubscriptionCallbackPageDocument = (src_default()) `
    query ShopifyVIPAppSubscriptionCallbackPage($shopOrigin: String!) {
  publicViewer {
    id
    shopify {
      id
      appsState(shopOrigin: $shopOrigin) {
        id
        shopifyVIPAppID
      }
    }
  }
}
    `;
const ShopifyVipAppThemeInstallationGuidePageDocument = (src_default()) `
    query ShopifyVIPAppThemeInstallationGuidePage($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    application {
      id
    }
  }
}
    `;
const ShopifyVipAppCustomerDetailPageDocument = (src_default()) `
    query ShopifyVipAppCustomerDetailPage($customerID: ID!) {
  node(id: $customerID) {
    ... on ShopifyVIPAppCustomer {
      id
      firstName
      lastName
      email
      approvedPoint
      holdPoint
      pendingPoint
      lifetimePoint
      spentPoint
      expiredPoint
      pointLogs(first: 40, orderBy: {field: CREATED_AT, direction: DESC}) {
        nodes {
          id
          title
          point
          expiredAt
          createdAt
        }
      }
      pendingPointLogs(first: 40, orderBy: {field: CREATED_AT, direction: DESC}) {
        nodes {
          id
          title
          point
          createdAt
        }
      }
      rank {
        id
        name
      }
    }
  }
}
    `;
const UpdateShopifyVipAppCustomerPointDocument = (src_default()) `
    mutation UpdateShopifyVipAppCustomerPoint($input: UpdateShopifyVIPAppCustomerPointInput!) {
  updateShopifyVIPAppCustomerPoint(input: $input) {
    success
  }
}
    `;
const AddShopifyVipAppManualPointDocument = (src_default()) `
    mutation AddShopifyVIPAppManualPoint($input: AddShopifyVIPAppManualPointInput!) {
  addShopifyVIPAppManualPoint(input: $input) {
    vipAppCustomer {
      id
      approvedPoint
      pointLogs(first: 20, orderBy: {field: CREATED_AT, direction: DESC}) {
        nodes {
          id
          title
          point
          createdAt
        }
      }
      rank {
        id
        name
      }
    }
  }
}
    `;
const AddShopifyVipAppConsumptionPointDocument = (src_default()) `
    mutation AddShopifyVIPAppConsumptionPoint($input: AddShopifyVIPAppConsumptionPointInput!) {
  addShopifyVIPAppConsumptionPoint(input: $input) {
    vipAppCustomer {
      id
      approvedPoint
      pointLogs(first: 20, orderBy: {field: CREATED_AT, direction: DESC}) {
        nodes {
          id
          title
          point
          createdAt
        }
      }
      rank {
        id
        name
      }
    }
  }
}
    `;
const ShopifyVipAppHomeDocument = (src_default()) `
    query ShopifyVIPAppHome($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    application {
      id
      displayName
    }
    activeAppSubscription {
      id
    }
  }
}
    `;
const CreateShopifyVipAppSubscriptionDocument = (src_default()) `
    mutation CreateShopifyVIPAppSubscription($input: CreateShopifyVIPAppSubscriptionInput!) {
  createShopifyVIPAppSubscription(input: $input) {
    confirmationURL
    shopOrigin
  }
}
    `;
const ShopifyVipAppInstallCallbackDocument = (src_default()) `
    query ShopifyVIPAppInstallCallback($shopOrigin: String!, $scopes: String!) {
  publicViewer {
    id
    shopify {
      id
      appsState(shopOrigin: $shopOrigin) {
        id
        shopifyVIPAppID
        isVIPAppInstalled
        hasVIPAppScopes(scopes: $scopes)
      }
    }
  }
}
    `;
const UpdateShopifyVipAppPointPrivateAppAdminApiCredentialDocument = (src_default()) `
    mutation UpdateShopifyVIPAppPointPrivateAppAdminAPICredential($input: UpdateShopifyVIPAppPointPrivateAppAdminAPICredentialInput!) {
  updateShopifyVIPAppPointPrivateAppAdminAPICredential(input: $input) {
    vipApp {
      id
      pointPrivateAppAdminAPICredential {
        id
        discountCreateCredential {
          id
          apiKey
          password
          sharedSecret
        }
        discountDeleteCredential {
          id
          apiKey
          password
          sharedSecret
        }
      }
    }
  }
}
    `;
const GetShopifyVipAppPointPrivateAppAdminApiCredentialDocument = (src_default()) `
    query GetShopifyVIPAppPointPrivateAppAdminAPICredential($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    pointPrivateAppAdminAPICredential {
      id
      discountCreateCredential {
        id
        apiKey
        password
        sharedSecret
      }
      discountDeleteCredential {
        id
        apiKey
        password
        sharedSecret
      }
    }
  }
}
    `;
const ShopifyVipProgramPointCreateDocument = (src_default()) `
    query ShopifyVIPProgramPointCreate($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    pointAddRuleOrder {
      id
      title
      minimumRequirementSubtotal
      basePrice
      basePoint
    }
    pointAddRuleSignUp {
      id
      title
      point
    }
  }
}
    `;
const ShopifyVipAppPointProgramCreateModalDocument = (src_default()) `
    query ShopifyVIPAppPointProgramCreateModal($vipAppID: ID!) {
  shopifyVIPApp(id: $vipAppID) {
    id
    pointAddRuleOrder {
      id
    }
    pointAddRuleSignUp {
      id
    }
  }
}
    `;
const UpdateShopifyVipAppMetafieldsSyncPrivateAppAdminApiCredentialDocument = (src_default()) `
    mutation UpdateShopifyVIPAppMetafieldsSyncPrivateAppAdminAPICredential($input: UpdateShopifyVIPAppMetafieldsSyncPrivateAppAdminAPICredentialInput!) {
  updateShopifyVIPAppMetafieldsSyncPrivateAppAdminAPICredential(input: $input) {
    vipApp {
      ...ShopifyVIPAppSettingMetafieldsSyncSection
    }
  }
}
    ${ShopifyVipAppSettingMetafieldsSyncSectionFragmentDoc}`;
const DeleteVipApplicationMemberInvitationDocument = (src_default()) `
    mutation DeleteVIPApplicationMemberInvitation($input: DeleteApplicationMemberInvitationInput!) {
  deleteApplicationMemberInvitation(input: $input) {
    application {
      id
      memberInvitations {
        nodes {
          id
          email
        }
      }
    }
  }
}
    `;
const StartShopifyMetafieldsSyncForAllCustomersDocument = (src_default()) `
    mutation StartShopifyMetafieldsSyncForAllCustomers($input: StartShopifyMetafieldsSyncForAllCustomersInput!) {
  startShopifyMetafieldsSyncForAllCustomers(input: $input) {
    vipApp {
      ...ShopifyVIPAppSettingMetafieldsSyncSection
    }
  }
}
    ${ShopifyVipAppSettingMetafieldsSyncSectionFragmentDoc}`;
const UseMobileCsLoginDocument = (src_default()) `
    mutation UseMobileCSLogin($input: SignInWithEmailAndPasswordInput!) {
  signInWithEmailAndPassword(input: $input) {
    identityPlatformToken {
      idToken
      email
      expiresIn
      refreshToken
    }
  }
}
    `;
const ApplicationMobileDetailApplePageDocument = (src_default()) `
    query ApplicationMobileDetailApplePage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    ios {
      id
      inReviewVersion
      releaseVersion
      ...ApplicationMobileDetailAppleIos
      ...ApplicationMobileDetailAppleFirebase
      ...ApplicationMobileDetailAppleAppStore
      ...ApplicationMobileDetailAppleUpdateIosModal
    }
  }
}
    ${ApplicationMobileDetailAppleIosFragmentDoc}
${ApplicationMobileDetailAppleFirebaseFragmentDoc}
${ApplicationMobileDetailAppleAppStoreFragmentDoc}
${ApplicationMobileDetailAppleUpdateIosModalFragmentDoc}`;
const ReviewIosApplicationDocument = (src_default()) `
    mutation ReviewIOSApplication($input: StartReviewIOSApplicationInput!) {
  startReviewIOSApplication(input: $input) {
    application {
      id
      ios {
        id
        inReviewVersion
        releaseVersion
      }
    }
  }
}
    `;
const ReleaseIosApplicationDocument = (src_default()) `
    mutation ReleaseIOSApplication($input: ReleaseIOSApplicationInput!) {
  releaseIOSApplication(input: $input) {
    application {
      id
      ios {
        id
        inReviewVersion
        releaseVersion
      }
    }
  }
}
    `;
const ApplicationMobileDetailGooglePageDocument = (src_default()) `
    query ApplicationMobileDetailGooglePage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    android {
      id
      inReviewVersion
      releaseVersion
      ...ApplicationMobileDetailGoogleAndroid
      ...ApplicationMobileDetailGoogleFirebase
      ...ApplicationMobileDetailGooglePlayStore
      ...ApplicationMobileDetailGoogleUpdateAndroidModal
    }
  }
}
    ${ApplicationMobileDetailGoogleAndroidFragmentDoc}
${ApplicationMobileDetailGoogleFirebaseFragmentDoc}
${ApplicationMobileDetailGooglePlayStoreFragmentDoc}
${ApplicationMobileDetailGoogleUpdateAndroidModalFragmentDoc}`;
const ReviewAndroidApplicationDocument = (src_default()) `
    mutation ReviewAndroidApplication($input: StartReviewAndroidApplicationInput!) {
  startReviewAndroidApplication(input: $input) {
    application {
      id
      android {
        id
        inReviewVersion
        releaseVersion
      }
    }
  }
}
    `;
const ReleaseAndroidApplicationDocument = (src_default()) `
    mutation ReleaseAndroidApplication($input: ReleaseAndroidApplicationInput!) {
  releaseAndroidApplication(input: $input) {
    application {
      id
      android {
        id
        inReviewVersion
        releaseVersion
      }
    }
  }
}
    `;
const ApplicationMobileDetailPageDocument = (src_default()) `
    query ApplicationMobileDetailPage($applicationID: ID!, $start: Date!, $end: Date!) {
  application(id: $applicationID) {
    id
    displayName
    mobileApp {
      id
      shopify {
        id
        addon {
          id
          isAppsFlyerAddonInstalled: isInstalled(addonType: APPSFLYER)
          isAppsChannelTalkAddonInstalled: isInstalled(addonType: CHANNEL_TALK)
        }
      }
    }
    ...ApplicationMobileDetailApplication
    ...ApplicationMobileDetailMobileApp
    ...ApplicationMobileDetailAnalytics
    ...ApplicationMobileSubscriptionPricing
    ...ApplicationMobileDetailAsset
    ...ApplicationMobileDetailAppsFlyer
    ...ApplicationMobileDetailChannelTalk
    ...ApplicationMobileDetailMember
    ...ApplicationMobileDetailFirebaseProject
    ...ApplicationMobileDetailTestPushNotification
  }
}
    ${ApplicationMobileDetailApplicationFragmentDoc}
${ApplicationMobileDetailMobileAppFragmentDoc}
${ApplicationMobileDetailAnalyticsFragmentDoc}
${ApplicationMobileSubscriptionPricingFragmentDoc}
${ApplicationMobileDetailAssetFragmentDoc}
${ApplicationMobileDetailAppsFlyerFragmentDoc}
${ApplicationMobileDetailChannelTalkFragmentDoc}
${ApplicationMobileDetailMemberFragmentDoc}
${ApplicationMobileDetailFirebaseProjectFragmentDoc}
${ApplicationMobileDetailTestPushNotificationFragmentDoc}`;
const ApplicationMobilePageDocument = (src_default()) `
    query ApplicationMobilePage($first: Int, $after: String) {
  csUserViewer {
    id
    mobileApps(
      first: $first
      after: $after
      orderBy: {direction: DESC, field: CREATED_AT}
    ) {
      ...ApplicationMobileDataTable
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${ApplicationMobileDataTableFragmentDoc}`;
const SearchMobileApplicationDocument = (src_default()) `
    query SearchMobileApplication($applicationID: ID!) {
  application(id: $applicationID) {
    id
  }
}
    `;
const ApplicationVipDetailPageDocument = (src_default()) `
    query ApplicationVIPDetailPage($applicationID: ID!) {
  application(id: $applicationID) {
    id
    displayName
    vipApp {
      id
    }
    ...ApplicationVIPDetailApplication
    ...ApplicationVIPDetailSubscriptionPricing
    ...ApplicationVIPDetailMember
  }
}
    ${ApplicationVipDetailApplicationFragmentDoc}
${ApplicationVipDetailSubscriptionPricingFragmentDoc}
${ApplicationVipDetailMemberFragmentDoc}`;
const ApplicationVipPageDocument = (src_default()) `
    query ApplicationVIPPage($first: Int, $after: String) {
  csUserViewer {
    id
    vipApps(
      first: $first
      after: $after
      orderBy: {direction: DESC, field: CREATED_AT}
    ) {
      ...ApplicationVIPDataTable
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${ApplicationVipDataTableFragmentDoc}`;
const SearchVipApplicationDocument = (src_default()) `
    query SearchVIPApplication($applicationID: ID!) {
  application(id: $applicationID) {
    id
  }
}
    `;
const DashboardPageDocument = (src_default()) `
    query DashboardPage($date: Date!) {
  csUserViewer {
    id
    mobile: statKind(kindName: "ShopifyAppExtension", date: $date) {
      id
      totalCount
    }
    vip: statKind(kindName: "ShopifyVIPApp", date: $date) {
      id
      totalCount
    }
  }
}
    `;
const SettingPageDocument = (src_default()) `
    query SettingPage {
  publicViewer {
    id
    app {
      id
      ...SettingLatestAppVersions
    }
  }
}
    ${SettingLatestAppVersionsFragmentDoc}`;
const UpdateShopifyMobileAppSubscriptionPricingDocument = (src_default()) `
    mutation UpdateShopifyMobileAppSubscriptionPricing($input: UpdateShopifyMobileAppSubscriptionPricingInput!) {
  updateShopifyMobileAppSubscriptionPricing(input: $input) {
    shopifyMobileAppSubscriptionPricing {
      id
      price
      startDate
    }
  }
}
    `;
const UpdateShopifyAppsflyerAddonSettingDocument = (src_default()) `
    mutation UpdateShopifyAppsflyerAddonSetting($input: UpdateShopifyAppsflyerAddonSettingIsActivatedInput!) {
  updateShopifyAppsflyerAddonSettingIsActivated(input: $input) {
    appsflyerAddon {
      id
      setting {
        id
        isActivated
      }
    }
  }
}
    `;
const UpdateShopifyChannelTalkAddonSettingDocument = (src_default()) `
    mutation UpdateShopifyChannelTalkAddonSetting($input: UpdateShopifyChannelTalkAddonSettingIsActivatedInput!) {
  updateShopifyChannelTalkAddonSettingIsActivated(input: $input) {
    channelTalkAddon {
      id
      setting {
        id
        isActivated
      }
    }
  }
}
    `;
const SendTestPushNotificationDocument = (src_default()) `
    mutation SendTestPushNotification($input: SendPushNotificationTestInput!) {
  sendPushNotificationTest(input: $input) {
    success
  }
}
    `;
const CreateShopifyApplicationFirebaseProjectDocument = (src_default()) `
    mutation CreateShopifyApplicationFirebaseProject($input: CreateGCPProjectInput!) {
  createGCPProject(input: $input) {
    application {
      ...ApplicationMobileDetailFirebaseProject
    }
  }
}
    ${ApplicationMobileDetailFirebaseProjectFragmentDoc}`;
const UpdateAppStoreAccountInfoDocument = (src_default()) `
    mutation UpdateAppStoreAccountInfo($input: UpdateAppleStoreInfoInput!) {
  updateAppleStoreInfo(input: $input) {
    application {
      id
      ios {
        ...ApplicationMobileDetailAppleUpdateIosModal
      }
    }
  }
}
    ${ApplicationMobileDetailAppleUpdateIosModalFragmentDoc}`;
const UpdateGooglePlayStoreAccountInfoDocument = (src_default()) `
    mutation UpdateGooglePlayStoreAccountInfo($input: UpdateGooglePlayStoreInfoInput!) {
  updateGooglePlayStoreInfo(input: $input) {
    application {
      id
      android {
        ...ApplicationMobileDetailGoogleUpdateAndroidModal
      }
    }
  }
}
    ${ApplicationMobileDetailGoogleUpdateAndroidModalFragmentDoc}`;
const UpdateShopifyVipAppSubscriptionPricingDocument = (src_default()) `
    mutation UpdateShopifyVIPAppSubscriptionPricing($input: UpdateShopifyVIPAppSubscriptionPricingInput!) {
  updateShopifyVIPAppSubscriptionPricing(input: $input) {
    shopifyVIPAppSubscriptionPricing {
      id
      price
      startDate
    }
  }
}
    `;
const SettingUpdateLatestAppVersionsDocument = (src_default()) `
    mutation SettingUpdateLatestAppVersions($input: UpdateLatestAppVersionsInput!) {
  updateLatestAppVersions(input: $input) {
    appIOS {
      id
      latestVersion
    }
    appAndroid {
      id
      latestVersion
    }
  }
}
    `;
const RefreshIdTokenDocument = (src_default()) `
    mutation RefreshIDToken($input: RefreshIDTokenInput!) {
  refreshIDToken(input: $input) {
    identityPlatformToken {
      idToken
      email
      expiresIn
      refreshToken
    }
  }
}
    `;
const CreateImageUploadUrlDocument = (src_default()) `
    mutation CreateImageUploadURL($input: CreateUploadURLInput!) {
  createUploadURL(input: $input) {
    uploadURL
    readURL
  }
}
    `;
const SignUpWithEmailAndPasswordDocument = (src_default()) `
    mutation SignUpWithEmailAndPassword($input: SignUpWithEmailAndPasswordInput!) {
  signUpWithEmailAndPassword(input: $input) {
    identityPlatformToken {
      idToken
      email
      expiresIn
      refreshToken
    }
  }
}
    `;
const CreateAdminDocument = (src_default()) `
    mutation CreateAdmin($input: CreateAdminInput!) {
  createAdmin(input: $input) {
    admin {
      id
      privacy {
        id
        name
      }
    }
  }
}
    `;
const AdminDocument = (src_default()) `
    query Admin {
  adminViewer {
    id
    privacy {
      id
      name
    }
  }
}
    `;
const GetUserEstimatedOrderPointDocument = (src_default()) `
    query GetUserEstimatedOrderPoint($input: ShopifyVIPAppEstimatedOrderPointInput!) {
  shopifyUserViewer {
    id
    vip {
      id
      pointAddRuleOrder {
        id
        minimumRequirementSubtotal
      }
      estimatedOrderPoint(input: $input)
    }
  }
}
    `;
const GetPublicEstimatedOrderPointDocument = (src_default()) `
    query GetPublicEstimatedOrderPoint($shopOrigin: String!, $input: ShopifyPublicVIPAppEstimatedOrderPointInput!) {
  publicViewer {
    id
    shopify {
      id
      vipApp(shopOrigin: $shopOrigin) {
        pointAddRuleOrder {
          id
          minimumRequirementSubtotal
        }
        estimatedOrderPoint(input: $input)
      }
    }
  }
}
    `;
const GetUserPendingPointLogsDocument = (src_default()) `
    query GetUserPendingPointLogs {
  shopifyUserViewer {
    id
    vip {
      id
      pendingPointLogs(first: 100, orderBy: {field: CREATED_AT, direction: DESC}) {
        nodes {
          ...PendingPointLog
        }
      }
    }
  }
}
    ${PendingPointLogFragmentDoc}`;
const GetUserPointLogsDocument = (src_default()) `
    query GetUserPointLogs {
  shopifyUserViewer {
    id
    vip {
      id
      pointLogs(first: 100, orderBy: {field: CREATED_AT, direction: DESC}) {
        nodes {
          ...PointLog
        }
      }
    }
  }
}
    ${PointLogFragmentDoc}`;
const CreateDiscountCodeDocument = (src_default()) `
    mutation CreateDiscountCode($input: CreateShopifyVIPAppHoldPointDiscountCodeInput!) {
  createShopifyVIPAppHoldPointDiscountCode(input: $input) {
    holdPointDiscountCode {
      id
      code
    }
  }
}
    `;
const DeleteShopifyVipAppHoldPointDiscountCodeDocument = (src_default()) `
    mutation DeleteShopifyVIPAppHoldPointDiscountCode {
  deleteShopifyVIPAppHoldPointDiscountCode
}
    `;
const GetUserHeldPointDocument = (src_default()) `
    query GetUserHeldPoint {
  shopifyUserViewer {
    id
    vip {
      id
      approvedPoint
      pointHoldState {
        id
        pointDiscountCode {
          id
          code
          point
        }
      }
    }
  }
}
    `;
const CheckoutCreateGiftCardDocument = (src_default()) `
    mutation CheckoutCreateGiftCard($input: CreateShopifyVIPAppHoldPointGiftCardInput!) {
  createShopifyVIPAppHoldPointGiftCard(input: $input) {
    holdPointGiftCard {
      id
      code
    }
  }
}
    `;
const CheckoutDisableShopifyVipAppHoldPointGiftCardDocument = (src_default()) `
    mutation CheckoutDisableShopifyVIPAppHoldPointGiftCard {
  disableShopifyVIPAppHoldPointGiftCard
}
    `;
const CheckoutGetUserHeldPointDocument = (src_default()) `
    query CheckoutGetUserHeldPoint {
  shopifyUserViewer {
    id
    vip {
      id
      approvedPoint
      pointHoldState {
        id
        holdPointGiftCard {
          id
          code
          point
        }
      }
    }
  }
}
    `;
const defaultWrapper = (action, _operationName) => action();
function getSdk(client, withWrapper = defaultWrapper) {
    return {
        BaseItems(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(BaseItemsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'BaseItems');
        },
        UseBaseRedirectURL(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UseBaseRedirectUrlDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UseBaseRedirectURL');
        },
        BaseDesignPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(BaseDesignPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'BaseDesignPage');
        },
        UpdateBaseToken(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateBaseTokenDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateBaseToken');
        },
        AdminBaseNavigationMenu(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AdminBaseNavigationMenuDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'AdminBaseNavigationMenu');
        },
        BaseAnnouncement(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(BaseAnnouncementDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'BaseAnnouncement');
        },
        CreateBaseAnnouncement(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateBaseAnnouncementDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateBaseAnnouncement');
        },
        CreateBaseAnnouncementAndSendPushNotification(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateBaseAnnouncementAndSendPushNotificationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateBaseAnnouncementAndSendPushNotification');
        },
        BaseDashboard(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(BaseDashboardDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'BaseDashboard');
        },
        BaseCategories(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(BaseCategoriesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'BaseCategories');
        },
        SaveBaseDesign(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SaveBaseDesignDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SaveBaseDesign');
        },
        ReleaseBaseDesign(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ReleaseBaseDesignDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReleaseBaseDesign');
        },
        BaseSelectedDesignBlockCategoryItems(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(BaseSelectedDesignBlockCategoryItemsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'BaseSelectedDesignBlockCategoryItems');
        },
        BaseSelectedDesignBlockCategoryItems2(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(BaseSelectedDesignBlockCategoryItems2Document, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'BaseSelectedDesignBlockCategoryItems2');
        },
        BasePushNotifications(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(BasePushNotificationsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'BasePushNotifications');
        },
        BaseSendPushNotification(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(BaseSendPushNotificationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'BaseSendPushNotification');
        },
        CreateStripeCheckoutSessionForBaseStandardPlan(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateStripeCheckoutSessionForBaseStandardPlanDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateStripeCheckoutSessionForBaseStandardPlan');
        },
        FallbackPageTopBar(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(FallbackPageTopBarDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'FallbackPageTopBar');
        },
        AcceptApplicationMemberInvitation(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AcceptApplicationMemberInvitationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'AcceptApplicationMemberInvitation');
        },
        LoggedInRoot(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(LoggedInRootDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'LoggedInRoot');
        },
        AccountMenu(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AccountMenuDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'AccountMenu');
        },
        AppAssetIconImageUploader(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AppAssetIconImageUploaderDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'AppAssetIconImageUploader');
        },
        UpdateAppAssetIcon(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateAppAssetIconDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateAppAssetIcon');
        },
        AppAssetLaunchScreenImageUploader(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AppAssetLaunchScreenImageUploaderDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'AppAssetLaunchScreenImageUploader');
        },
        UpdateAppAssetLaunchScreen(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateAppAssetLaunchScreenDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateAppAssetLaunchScreen');
        },
        UpdateAppStore(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateAppStoreDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateAppStore');
        },
        AppifyChannelTalk(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AppifyChannelTalkDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'AppifyChannelTalk');
        },
        ApplicationSelector(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ApplicationSelectorDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ApplicationSelector');
        },
        UpdateGooglePlayStore(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateGooglePlayStoreDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateGooglePlayStore');
        },
        PushNotifications(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(PushNotificationsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'PushNotifications');
        },
        CancelPushNotification(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CancelPushNotificationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CancelPushNotification');
        },
        CreditCardSetting(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreditCardSettingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreditCardSetting');
        },
        CreateStripeCustomerPortalSession(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateStripeCustomerPortalSessionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateStripeCustomerPortalSession');
        },
        UseMobileAdminLogin(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UseMobileAdminLoginDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UseMobileAdminLogin');
        },
        ShopifyCollection(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyCollectionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyCollection');
        },
        ShopifyProduct(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyProductDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyProduct');
        },
        ShopifyRedirectURL(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyRedirectUrlDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyRedirectURL');
        },
        ShopifyAddonAppsflyerPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonAppsflyerPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonAppsflyerPage');
        },
        CreateShopifyAutoPushNotificationCustomerCreatedRule(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyAutoPushNotificationCustomerCreatedRuleDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyAutoPushNotificationCustomerCreatedRule');
        },
        ShopifyAddonAutoPushNotificationCustomerCreatedRulePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonAutoPushNotificationCustomerCreatedRulePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonAutoPushNotificationCustomerCreatedRulePage');
        },
        ShopifyAddonAutoPushNotificationEditPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonAutoPushNotificationEditPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonAutoPushNotificationEditPage');
        },
        UpdateShopifyAutoPushNotificationCustomerCreatedRule(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyAutoPushNotificationCustomerCreatedRuleDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyAutoPushNotificationCustomerCreatedRule');
        },
        DeleteShopifyAutoPushNotificationCustomerCreatedRule(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(DeleteShopifyAutoPushNotificationCustomerCreatedRuleDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'DeleteShopifyAutoPushNotificationCustomerCreatedRule');
        },
        ShopifyAddonChannelTalkPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonChannelTalkPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonChannelTalkPage');
        },
        ShopifyAddonPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonPage');
        },
        ShopifyAddonRaffleApplicantDetailPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonRaffleApplicantDetailPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonRaffleApplicantDetailPage');
        },
        ReserveShopifyRaffleApplicantResult(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ReserveShopifyRaffleApplicantResultDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReserveShopifyRaffleApplicantResult');
        },
        CreateShopifyRaffleBannedCustomer(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyRaffleBannedCustomerDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyRaffleBannedCustomer');
        },
        ShopifyAddonRaffleApplicantPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonRaffleApplicantPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonRaffleApplicantPage');
        },
        FindShopifyRaffleApplicant(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(FindShopifyRaffleApplicantDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'FindShopifyRaffleApplicant');
        },
        CreateShopifyProductRaffle(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyProductRaffleDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyProductRaffle');
        },
        ShopifyAddonRafflePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonRafflePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonRafflePage');
        },
        ShopifyAddonRaffleProductPaymentMethodOfflineDetailPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonRaffleProductPaymentMethodOfflineDetailPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonRaffleProductPaymentMethodOfflineDetailPage');
        },
        ShopifyAddonRaffleProductPaymentMethodOfflineStatusDetailPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonRaffleProductPaymentMethodOfflineStatusDetailPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonRaffleProductPaymentMethodOfflineStatusDetailPage');
        },
        ShopifyAddonRaffleProductPaymentMethodOnlineDetailPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonRaffleProductPaymentMethodOnlineDetailPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonRaffleProductPaymentMethodOnlineDetailPage');
        },
        ShopifyAddonRaffleProductPaymentMethodOnlineStatusDetailPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonRaffleProductPaymentMethodOnlineStatusDetailPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonRaffleProductPaymentMethodOnlineStatusDetailPage');
        },
        ShopifyAddonRaffleSettingPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonRaffleSettingPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonRaffleSettingPage');
        },
        UpdateShopifyRaffleAddonSetting(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyRaffleAddonSettingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyRaffleAddonSetting');
        },
        ShopifyAddonSignUpBonusPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonSignUpBonusPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonSignUpBonusPage');
        },
        UpdateShopifySignUpBonusAddonSetting(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifySignUpBonusAddonSettingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifySignUpBonusAddonSetting');
        },
        UpdateShopifySignUpBonusAddonCouponSetting(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifySignUpBonusAddonCouponSettingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifySignUpBonusAddonCouponSetting');
        },
        ShopifyAddonStoreManagementCreatePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonStoreManagementCreatePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonStoreManagementCreatePage');
        },
        CreateShopifyOfflineStore(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyOfflineStoreDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyOfflineStore');
        },
        ShopifyAddonStoreManagementEditPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonStoreManagementEditPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonStoreManagementEditPage');
        },
        UpdateShopifyOfflineStore(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyOfflineStoreDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyOfflineStore');
        },
        DeleteShopifyOfflineStore(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(DeleteShopifyOfflineStoreDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'DeleteShopifyOfflineStore');
        },
        ShopifyAddonStoreManagementPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonStoreManagementPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonStoreManagementPage');
        },
        ShopifyAppInstallCallbackPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAppInstallCallbackPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAppInstallCallbackPage');
        },
        ShopifyAppInstalledCallbackPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAppInstalledCallbackPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAppInstalledCallbackPage');
        },
        UpdateShopifyMobileAppAPIToken(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyMobileAppApiTokenDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyMobileAppAPIToken');
        },
        ShopifyAppReinstallPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAppReinstallPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAppReinstallPage');
        },
        ShopifyAppSubscriptionCallbackPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAppSubscriptionCallbackPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAppSubscriptionCallbackPage');
        },
        ShopifyDashboardPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDashboardPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDashboardPage');
        },
        ShopifyDashboardRedirectPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDashboardRedirectPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDashboardRedirectPage');
        },
        ShopifyDesignEditorPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDesignEditorPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDesignEditorPage');
        },
        ShopifyDesignSearchEditorPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDesignSearchEditorPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDesignSearchEditorPage');
        },
        ShopifyDesignStyleSectionPageQuery(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDesignStyleSectionPageQueryDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDesignStyleSectionPageQuery');
        },
        ShopifyMarketingAnnouncementPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyMarketingAnnouncementPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyMarketingAnnouncementPage');
        },
        CustomerCouponMerchantDeliveryRuleCreate(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CustomerCouponMerchantDeliveryRuleCreateDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CustomerCouponMerchantDeliveryRuleCreate');
        },
        ShopifyMarketingCustomerCouponMerchantDeliveryRulePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyMarketingCustomerCouponMerchantDeliveryRulePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyMarketingCustomerCouponMerchantDeliveryRulePage');
        },
        ShopifyMarketingPushNotificationPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyMarketingPushNotificationPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyMarketingPushNotificationPage');
        },
        ShopifyMarketingSegmentCustomerInterestEditorPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyMarketingSegmentCustomerInterestEditorPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyMarketingSegmentCustomerInterestEditorPage');
        },
        UpdateShopifySegmentCustomerInterestRule(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifySegmentCustomerInterestRuleDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifySegmentCustomerInterestRule');
        },
        DeleteShopifySegmentCustomerInterestRule(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(DeleteShopifySegmentCustomerInterestRuleDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'DeleteShopifySegmentCustomerInterestRule');
        },
        ShopifyMobileAppCreate(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyMobileAppCreateDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyMobileAppCreate');
        },
        ShopifySettingInviteMemberPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySettingInviteMemberPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySettingInviteMemberPage');
        },
        InviteShopifyApplicationMember(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(InviteShopifyApplicationMemberDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'InviteShopifyApplicationMember');
        },
        ShopifySettingPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySettingPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySettingPage');
        },
        ShopifySettingShopTermPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySettingShopTermPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySettingShopTermPage');
        },
        UpdateShopifyShopTerms(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyShopTermsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyShopTerms');
        },
        ShopifyUpdateTokenPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyUpdateTokenPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyUpdateTokenPage');
        },
        UpdateShopifyChannelTalkAddonSettingPluginKey(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyChannelTalkAddonSettingPluginKeyDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyChannelTalkAddonSettingPluginKey');
        },
        InstallShopifyAddon(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(InstallShopifyAddonDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'InstallShopifyAddon');
        },
        ShopifyRaffleCreateModal(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyRaffleCreateModalDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyRaffleCreateModal');
        },
        ExecuteShopifyRaffleTask(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ExecuteShopifyRaffleTaskDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ExecuteShopifyRaffleTask');
        },
        CreateShopifyRaffleApplicantCsvDownloadURL(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyRaffleApplicantCsvDownloadUrlDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyRaffleApplicantCsvDownloadURL');
        },
        CreateShopifyRaffleApplicantCsvUploadURL(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyRaffleApplicantCsvUploadUrlDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyRaffleApplicantCsvUploadURL');
        },
        ImportShopifyRaffleApplicantCsv(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ImportShopifyRaffleApplicantCsvDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ImportShopifyRaffleApplicantCsv');
        },
        ShopifyAddonStoreManagementCreateAreaModal(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonStoreManagementCreateAreaModalDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonStoreManagementCreateAreaModal');
        },
        CreateShopifyOfflineStoreArea(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyOfflineStoreAreaDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyOfflineStoreArea');
        },
        ShopifyAddonStoreManagementCreateBrandModal(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAddonStoreManagementCreateBrandModalDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAddonStoreManagementCreateBrandModal');
        },
        CreateShopifyOfflineStoreBrand(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyOfflineStoreBrandDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyOfflineStoreBrand');
        },
        ShopifyAppSubmissionReadyToSubmitBanner(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAppSubmissionReadyToSubmitBannerDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAppSubmissionReadyToSubmitBanner');
        },
        ShopifyAppSubmissionSetupDesignStep(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAppSubmissionSetupDesignStepDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAppSubmissionSetupDesignStep');
        },
        ShopifyAppSubmissionUploadLogoStep(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAppSubmissionUploadLogoStepDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAppSubmissionUploadLogoStep');
        },
        ShopifyAppSubmissionEditStoreInformationStep(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAppSubmissionEditStoreInformationStepDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAppSubmissionEditStoreInformationStep');
        },
        ShopifyAppSubmissionDeveloperAccountIntegrationStep(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAppSubmissionDeveloperAccountIntegrationStepDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAppSubmissionDeveloperAccountIntegrationStep');
        },
        CreateShopifyMobileAppSubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyMobileAppSubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyMobileAppSubscription');
        },
        UpdateShopifyMobileAppSubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyMobileAppSubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyMobileAppSubscription');
        },
        ShopifyDesignShopPageSection(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDesignShopPageSectionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDesignShopPageSection');
        },
        UpdateShopifyDesignStyle(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyDesignStyleDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyDesignStyle');
        },
        ShopifyDesignSearchPageSection(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDesignSearchPageSectionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDesignSearchPageSection');
        },
        ShopifyDesignProductPageSection(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDesignProductPageSectionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDesignProductPageSection');
        },
        ShopifyDesignCartPageSection(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDesignCartPageSectionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDesignCartPageSection');
        },
        UpdateShopifyDesignCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyDesignCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyDesignCart');
        },
        UpdateAppLogo(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateAppLogoDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateAppLogo');
        },
        UpdateShopifyAppDesignCollectionGroupSetting(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyAppDesignCollectionGroupSettingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyAppDesignCollectionGroupSetting');
        },
        MemberCard(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(MemberCardDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'MemberCard');
        },
        UpdateShopifyDesignMemberCard(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyDesignMemberCardDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyDesignMemberCard');
        },
        ShopifyDesignAppAssetsSection(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDesignAppAssetsSectionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDesignAppAssetsSection');
        },
        UpdateShopifyDesignProduct(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyDesignProductDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyDesignProduct');
        },
        ShopifySelectCollections(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySelectCollectionsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySelectCollections');
        },
        ShopifySelectProducts(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySelectProductsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySelectProducts');
        },
        GetShopifyCollectionsByAdminAPIIDs(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetShopifyCollectionsByAdminApiiDsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetShopifyCollectionsByAdminAPIIDs');
        },
        ShopifySelectCollection(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySelectCollectionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySelectCollection');
        },
        ShopifySelectProduct(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySelectProductDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySelectProduct');
        },
        GetShopifyProductByAdminID(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetShopifyProductByAdminIdDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetShopifyProductByAdminID');
        },
        GetShopifyCollectionByAdminID(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetShopifyCollectionByAdminIdDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetShopifyCollectionByAdminID');
        },
        ShopifyDesignReleaseButton(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDesignReleaseButtonDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDesignReleaseButton');
        },
        SaveShopifyDesign(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SaveShopifyDesignDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SaveShopifyDesign');
        },
        ReleaseShopifyDesign(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ReleaseShopifyDesignDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReleaseShopifyDesign');
        },
        ShopifySelectedDesignBlockCollections(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySelectedDesignBlockCollectionsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySelectedDesignBlockCollections');
        },
        GetSelectedDesignBlockCollectionsByAdminAPIIDs(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetSelectedDesignBlockCollectionsByAdminApiiDsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetSelectedDesignBlockCollectionsByAdminAPIIDs');
        },
        ShopifySelectedDesignBlockProducts(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySelectedDesignBlockProductsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySelectedDesignBlockProducts');
        },
        ShopifySelectedDesignBlockCollectionProducts(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySelectedDesignBlockCollectionProductsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySelectedDesignBlockCollectionProducts');
        },
        ShopifySelectedDesignBlockCollectionProducts2(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifySelectedDesignBlockCollectionProducts2Document, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifySelectedDesignBlockCollectionProducts2');
        },
        ShopifyDesignMerchantSection(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyDesignMerchantSectionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyDesignMerchantSection');
        },
        UpdateShopifyDesignMerchantSection(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyDesignMerchantSectionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyDesignMerchantSection');
        },
        CreateShopifyAnnouncementForm(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyAnnouncementFormDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyAnnouncementForm');
        },
        CreateShopifyAnnouncement(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyAnnouncementDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyAnnouncement');
        },
        UpdateShopifyCustomerCouponMerchantDeliveryRuleIsPaused(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyCustomerCouponMerchantDeliveryRuleIsPausedDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyCustomerCouponMerchantDeliveryRuleIsPaused');
        },
        ShopifyMarketingPushNotificationCancel(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyMarketingPushNotificationCancelDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyMarketingPushNotificationCancel');
        },
        ShopifyMarketingPushNotificationAudience(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyMarketingPushNotificationAudienceDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyMarketingPushNotificationAudience');
        },
        ShopifyPushNotificationCreate(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyPushNotificationCreateDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyPushNotificationCreate');
        },
        CreateShopifySegmentCustomerInterestRule(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifySegmentCustomerInterestRuleDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifySegmentCustomerInterestRule');
        },
        ShopifyNavigation(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyNavigationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyNavigation');
        },
        SaveShopifyDesignCollectionGroup(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SaveShopifyDesignCollectionGroupDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SaveShopifyDesignCollectionGroup');
        },
        ReleaseShopifyDesignCollectionGroup(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ReleaseShopifyDesignCollectionGroupDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReleaseShopifyDesignCollectionGroup');
        },
        UpdateShopifyCheckoutCustomerAccountCondition(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyCheckoutCustomerAccountConditionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyCheckoutCustomerAccountCondition');
        },
        DeleteApplicationMemberInvitation(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(DeleteApplicationMemberInvitationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'DeleteApplicationMemberInvitation');
        },
        ShopifyApplicationModeSetting(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyApplicationModeSettingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyApplicationModeSetting');
        },
        UpdateShopifyMobileAppMode(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyMobileAppModeDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyMobileAppMode');
        },
        ShopifyAppStoreSettingButton(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyAppStoreSettingButtonDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyAppStoreSettingButton');
        },
        ShopifyGooglePlayStoreSettingButton(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyGooglePlayStoreSettingButtonDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyGooglePlayStoreSettingButton');
        },
        ShopifyVIPAppRedirectURL(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppRedirectUrlDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppRedirectURL');
        },
        UseVIPAdminLogin(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UseVipAdminLoginDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UseVIPAdminLogin');
        },
        CreateShopifyVIPApp(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyVipAppDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyVIPApp');
        },
        ShopifyVIPAppCustomerPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppCustomerPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppCustomerPage');
        },
        ShopifyVIPAppInstalledCallbackPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppInstalledCallbackPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppInstalledCallbackPage');
        },
        UpdateShopifyVIPAPIToken(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyVipapiTokenDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyVIPAPIToken');
        },
        ShopifyVIPAppPointProgramPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppPointProgramPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppPointProgramPage');
        },
        ShopifyVIPAppPointProgramPointAddRuleOrderCreatePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppPointProgramPointAddRuleOrderCreatePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppPointProgramPointAddRuleOrderCreatePage');
        },
        UpdateShopifyVIPAppPointAddRuleOrder(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyVipAppPointAddRuleOrderDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyVIPAppPointAddRuleOrder');
        },
        ShopifyVIPAppPointProgramPointAddRuleOrderUpdatePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppPointProgramPointAddRuleOrderUpdatePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppPointProgramPointAddRuleOrderUpdatePage');
        },
        DeleteShopifyVIPAppPointAddRuleOrder(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(DeleteShopifyVipAppPointAddRuleOrderDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'DeleteShopifyVIPAppPointAddRuleOrder');
        },
        UpdateShopifyVIPAppPointAddRuleSignUp(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyVipAppPointAddRuleSignUpDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyVIPAppPointAddRuleSignUp');
        },
        ShopifyVIPAppPointProgramPointAddRuleSignUpUpdatePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppPointProgramPointAddRuleSignUpUpdatePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppPointProgramPointAddRuleSignUpUpdatePage');
        },
        DeleteShopifyVIPAppPointAddRuleSignUp(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(DeleteShopifyVipAppPointAddRuleSignUpDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'DeleteShopifyVIPAppPointAddRuleSignUp');
        },
        ShopifyVIPProgramPointSettingPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipProgramPointSettingPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPProgramPointSettingPage');
        },
        UpdateShopifyVIPAppSetting(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyVipAppSettingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyVIPAppSetting');
        },
        ShopifyVIPAppRankProgramCreatePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppRankProgramCreatePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppRankProgramCreatePage');
        },
        ShopifyVIPAppRankProgramEditPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppRankProgramEditPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppRankProgramEditPage');
        },
        UpdateShopifyVIPAppRankRule(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyVipAppRankRuleDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyVIPAppRankRule');
        },
        DeleteShopifyVIPAppRankRule(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(DeleteShopifyVipAppRankRuleDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'DeleteShopifyVIPAppRankRule');
        },
        ShopifyVIPAppRankProgramPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppRankProgramPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppRankProgramPage');
        },
        ShopifyVIPAppRankProgramSettingPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppRankProgramSettingPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppRankProgramSettingPage');
        },
        UpdateShopifyVIPAppRankDecisionSetting(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyVipAppRankDecisionSettingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyVIPAppRankDecisionSetting');
        },
        ShopifyVIPAppReInstallPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppReInstallPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppReInstallPage');
        },
        ShopifyVIPAppRedirectPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppRedirectPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppRedirectPage');
        },
        ShopifyVIPAppSettingInviteMemberPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppSettingInviteMemberPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppSettingInviteMemberPage');
        },
        InviteApplicationMember(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(InviteApplicationMemberDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'InviteApplicationMember');
        },
        ShopifyVIPAppSettingPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppSettingPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppSettingPage');
        },
        ShopifyVIPAppSubscriptionCallbackPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppSubscriptionCallbackPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppSubscriptionCallbackPage');
        },
        ShopifyVIPAppThemeInstallationGuidePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppThemeInstallationGuidePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppThemeInstallationGuidePage');
        },
        ShopifyVipAppCustomerDetailPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppCustomerDetailPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVipAppCustomerDetailPage');
        },
        UpdateShopifyVipAppCustomerPoint(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyVipAppCustomerPointDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyVipAppCustomerPoint');
        },
        AddShopifyVIPAppManualPoint(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AddShopifyVipAppManualPointDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'AddShopifyVIPAppManualPoint');
        },
        AddShopifyVIPAppConsumptionPoint(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AddShopifyVipAppConsumptionPointDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'AddShopifyVIPAppConsumptionPoint');
        },
        ShopifyVIPAppHome(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppHomeDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppHome');
        },
        CreateShopifyVIPAppSubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyVipAppSubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyVIPAppSubscription');
        },
        ShopifyVIPAppInstallCallback(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppInstallCallbackDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppInstallCallback');
        },
        UpdateShopifyVIPAppPointPrivateAppAdminAPICredential(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyVipAppPointPrivateAppAdminApiCredentialDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyVIPAppPointPrivateAppAdminAPICredential');
        },
        GetShopifyVIPAppPointPrivateAppAdminAPICredential(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetShopifyVipAppPointPrivateAppAdminApiCredentialDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetShopifyVIPAppPointPrivateAppAdminAPICredential');
        },
        ShopifyVIPProgramPointCreate(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipProgramPointCreateDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPProgramPointCreate');
        },
        ShopifyVIPAppPointProgramCreateModal(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ShopifyVipAppPointProgramCreateModalDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ShopifyVIPAppPointProgramCreateModal');
        },
        UpdateShopifyVIPAppMetafieldsSyncPrivateAppAdminAPICredential(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyVipAppMetafieldsSyncPrivateAppAdminApiCredentialDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyVIPAppMetafieldsSyncPrivateAppAdminAPICredential');
        },
        DeleteVIPApplicationMemberInvitation(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(DeleteVipApplicationMemberInvitationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'DeleteVIPApplicationMemberInvitation');
        },
        StartShopifyMetafieldsSyncForAllCustomers(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(StartShopifyMetafieldsSyncForAllCustomersDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'StartShopifyMetafieldsSyncForAllCustomers');
        },
        UseMobileCSLogin(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UseMobileCsLoginDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UseMobileCSLogin');
        },
        ApplicationMobileDetailApplePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ApplicationMobileDetailApplePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ApplicationMobileDetailApplePage');
        },
        ReviewIOSApplication(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ReviewIosApplicationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReviewIOSApplication');
        },
        ReleaseIOSApplication(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ReleaseIosApplicationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReleaseIOSApplication');
        },
        ApplicationMobileDetailGooglePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ApplicationMobileDetailGooglePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ApplicationMobileDetailGooglePage');
        },
        ReviewAndroidApplication(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ReviewAndroidApplicationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReviewAndroidApplication');
        },
        ReleaseAndroidApplication(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ReleaseAndroidApplicationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReleaseAndroidApplication');
        },
        ApplicationMobileDetailPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ApplicationMobileDetailPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ApplicationMobileDetailPage');
        },
        ApplicationMobilePage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ApplicationMobilePageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ApplicationMobilePage');
        },
        SearchMobileApplication(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SearchMobileApplicationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SearchMobileApplication');
        },
        ApplicationVIPDetailPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ApplicationVipDetailPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ApplicationVIPDetailPage');
        },
        ApplicationVIPPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ApplicationVipPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ApplicationVIPPage');
        },
        SearchVIPApplication(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SearchVipApplicationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SearchVIPApplication');
        },
        DashboardPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(DashboardPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'DashboardPage');
        },
        SettingPage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SettingPageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SettingPage');
        },
        UpdateShopifyMobileAppSubscriptionPricing(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyMobileAppSubscriptionPricingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyMobileAppSubscriptionPricing');
        },
        UpdateShopifyAppsflyerAddonSetting(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyAppsflyerAddonSettingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyAppsflyerAddonSetting');
        },
        UpdateShopifyChannelTalkAddonSetting(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyChannelTalkAddonSettingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyChannelTalkAddonSetting');
        },
        SendTestPushNotification(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SendTestPushNotificationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SendTestPushNotification');
        },
        CreateShopifyApplicationFirebaseProject(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateShopifyApplicationFirebaseProjectDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateShopifyApplicationFirebaseProject');
        },
        UpdateAppStoreAccountInfo(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateAppStoreAccountInfoDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateAppStoreAccountInfo');
        },
        UpdateGooglePlayStoreAccountInfo(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateGooglePlayStoreAccountInfoDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateGooglePlayStoreAccountInfo');
        },
        UpdateShopifyVIPAppSubscriptionPricing(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateShopifyVipAppSubscriptionPricingDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateShopifyVIPAppSubscriptionPricing');
        },
        SettingUpdateLatestAppVersions(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SettingUpdateLatestAppVersionsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SettingUpdateLatestAppVersions');
        },
        RefreshIDToken(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(RefreshIdTokenDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'RefreshIDToken');
        },
        CreateImageUploadURL(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateImageUploadUrlDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateImageUploadURL');
        },
        SignUpWithEmailAndPassword(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SignUpWithEmailAndPasswordDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SignUpWithEmailAndPassword');
        },
        CreateAdmin(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateAdminDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateAdmin');
        },
        Admin(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AdminDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'Admin');
        },
        GetUserEstimatedOrderPoint(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetUserEstimatedOrderPointDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetUserEstimatedOrderPoint');
        },
        GetPublicEstimatedOrderPoint(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetPublicEstimatedOrderPointDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetPublicEstimatedOrderPoint');
        },
        GetUserPendingPointLogs(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetUserPendingPointLogsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetUserPendingPointLogs');
        },
        GetUserPointLogs(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetUserPointLogsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetUserPointLogs');
        },
        CreateDiscountCode(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateDiscountCodeDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateDiscountCode');
        },
        DeleteShopifyVIPAppHoldPointDiscountCode(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(DeleteShopifyVipAppHoldPointDiscountCodeDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'DeleteShopifyVIPAppHoldPointDiscountCode');
        },
        GetUserHeldPoint(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetUserHeldPointDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetUserHeldPoint');
        },
        CheckoutCreateGiftCard(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CheckoutCreateGiftCardDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CheckoutCreateGiftCard');
        },
        CheckoutDisableShopifyVIPAppHoldPointGiftCard(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CheckoutDisableShopifyVipAppHoldPointGiftCardDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CheckoutDisableShopifyVIPAppHoldPointGiftCard');
        },
        CheckoutGetUserHeldPoint(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CheckoutGetUserHeldPointDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CheckoutGetUserHeldPoint');
        }
    };
}

// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(687);
;// CONCATENATED MODULE: ./src/vipapp_legacy_theme/assets/pending_points/app.ts
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class App {
    constructor(ui, api) {
        this.ui = ui;
        this.api = api;
        this.pendingPointLogs = [];
    }
    load() {
        this.onLoad();
    }
    onLoad() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.pendingPointLogs = (_b = (_a = (yield this.api.GetUserPendingPointLogs()).shopifyUserViewer.vip) === null || _a === void 0 ? void 0 : _a.pendingPointLogs.nodes) !== null && _b !== void 0 ? _b : [];
            this.syncUI();
        });
    }
    syncUI() {
        this.ui.sync(this);
    }
}

;// CONCATENATED MODULE: ./src/vipapp_legacy_theme/assets/pending_points/ui.ts
// Elementの操作
class UI {
    constructor(tbodyElm) {
        this.tbodyElm = tbodyElm;
    }
    // sync は状態を受け取りElementを操作する
    sync({ pendingPointLogs, }) {
        replaceChildNodes(this.tbodyElm, pendingPointLogs.map((pendingPointLog) => {
            const tr = document.createElement("tr");
            tr.innerHTML = `
          <td>${pendingPointLog.title}</td>
          <td>${pendingPointLog.point.toLocaleString()} ポイント</td>
          <td>${pendingPointLog.availableAt
                ? formatDate(new Date(pendingPointLog.availableAt))
                : "配送待ち"}</td>
        `;
            return tr;
        }));
    }
}
function replaceChildNodes(target, children) {
    [...target.childNodes].forEach((child) => {
        target.removeChild(child);
    });
    children.forEach((child) => {
        target.appendChild(child);
    });
}
function formatDate(date) {
    return date.toLocaleString("ja", {
        year: "numeric",
        month: "narrow",
        day: "numeric",
    });
}

;// CONCATENATED MODULE: ./src/vipapp_legacy_theme/assets/pending_points/index.ts
var pending_points_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




document.addEventListener("DOMContentLoaded", () => pending_points_awaiter(void 0, void 0, void 0, function* () {
    const { customerId, authHash } = globalVariablesFromLiquid(window);
    if (customerId === "")
        return; // 未ログイン
    const tbodyElm = document.querySelector(".vip-pending-points tbody");
    if (!tbodyElm) {
        throw new Error("Could not find the HTML elements.");
    }
    const api = getSdk(new dist.GraphQLClient(`/apps/vip-api?customer=${customerId}`, {
        headers: { authorization: `Bearer ${authHash}` },
    }));
    const ui = new UI(tbodyElm);
    new App(ui, api).load();
}));
function globalVariablesFromLiquid(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
w) {
    if (typeof w.customerId !== "string") {
        throw new Error("window.customerId is not defined.");
    }
    if (typeof w.authHash !== "string") {
        throw new Error("window.authHash is not defined.");
    }
    return w;
}

}();
/******/ })()
;